import { useContext, useEffect, useRef, useState } from "react";
import {
  Button,
  Checkbox,
  Col,
  DatePicker,
  Divider,
  Dropdown,
  Empty,
  Form,
  Input,
  InputNumber,
  Radio,
  Row,
  Select,
  Skeleton,
  Space,
  Spin,
  Tag,
  Tooltip,
  Typography,
  Upload,
} from "antd";
import {
  BarcodeOutlined,
  CloseOutlined,
  DownOutlined,
  EyeOutlined,
  LoadingOutlined,
  PlusOutlined,
  ReloadOutlined,
  SaveOutlined,
  UploadOutlined,
} from "@ant-design/icons";
import deleteImg from "../../../../images/deletebutton.svg";
import { ConfirmationModal } from "../../../Common/ConfirmationModal";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useClient } from "../../../Context/ClientContext";
import {
  handleDecimalValues,
  handleInputFocus,
  updateListWithNewValue,
  Utils,
} from "../../../../Utilities/Utils";
import { dayjs } from "../../../../Utilities/dayjs";
import "../../../../CapsitechAccountsComponents/Common/Acc_Common.css";
import "../../../../CapsitechAccountsComponents/Common/AddPageCommon.css";
import noteContext from "../../../Context/StyleContext";
import { notificationContext } from "../../../Common/Routing/PageRoute";
import TextArea from "antd/es/input/TextArea";
import TcsModel from "../../TcsTds/Tcs/TcsModel";
import TdsModel from "../../TcsTds/Tds/TdsModel";
import AddItems from "../../Items/AddItems";
import { percentCal, percentToRs } from "../../../Common/CAPComponents";
import AddBankAccount from "../../Banking/BankAccounts/AddBankAccountModel";
import LedgerService, {
  ILedgerAddResponse,
  ILedgerSearchByGroupNameResponse,
  LedgerStatus,
  PartyType,
  SearchLedgerByGroupsTypes,
  TypeOfAddress,
} from "../../../Services/LedgerService";
import Layout, { Content, Footer, Header } from "antd/es/layout/layout";
import VoucherServices, {
  AddressEnum,
  DiscountType,
  FreightTypeOptions,
  ITCEligibilityTypeOptions,
  ITCEligibility_Type,
  Party_Tax,
  PriceHistoryByItemIdResponse,
  ReconciledFilter,
  RefType,
  VoucherStatus_New,
  Voucher_Nature,
  Voucher_Type,
  convertToDays,
  voucherNatureOptions,
} from "../../../Services/VoucherServices";
import { AddLedger } from "../../Master/Ledger/AddLedger";
import QuotationServices from "../../../Services/QuotationServices";
import { CompanyGSTTypes } from "../../../../Types/CommonConstants";
import EntryLevelKeys from "../../../Common/EntryLevelKeys";
import {
  Discount_Policy,
  SettingsSections,
  TimeUnits,
  vouchersSettings,
} from "../../../Services/SettingService";
import DraftService from "../../../Services/DraftService";
import TermsAndConditionModal from "../../Settings/TermsAndCondition/VouchersTermsAndConditionModal";
import DocumentPreview from "../../../Common/DocumentPreview";
import { PanCardType } from "../../../Services/PurchaseService";
import { useUser } from "../../../../Context/UserContext";
import { getIndianStates } from "../../../Services/ClientService";
import TdsTcsServices, {
  Transaction_Type,
} from "../../../Services/TdsTcsServices";
import AddTcsTaxRate from "../../TcsTds/Tcs/AddTcsTaxRate";
import AddTdsTaxRate from "../../TcsTds/Tds/AddTdsTaxRate";
import { DiscountSalesType, Item_Nature } from "../../../Services/ItemsService";
import { useTheme } from "../../../Context/ThemeContext";
import SelectBatchItemModal from "../../ItemBatchAndSerial/SelectBatchItemModal";
import SelectSerialNo from "../../ItemBatchAndSerial/SelectSerialNo";
import CurrencyServices from "../../../Services/CurrencyServices";
import { allCountriesStates } from "../../../../Types/CommonAllCountriesStates";
import { findUserOnlyOnePremission } from "../../Users/Roles/UserSecurityFind";
import { IApiResponse } from "../../../../Utilities/ApiUtility.axios";
import { handleRoundoff } from "../../../Common/Calculation/HandleRoundoff";
import { partyIsGstType } from "../../../Common/Party/PartyIsGstType";
import {
  findVoucharCustomizationTemplete,
  IAssetsType,
} from "../../../Common/Vouchar/FindVoucharCustomizationTemplete";
import {
  IVoucherCustomizationTemplate,
  IVoucherFooterLedger,
  IVoucherFooterTotal,
  IVoucherSettingControl,
} from "../../../Common/Vouchar/VoucherStateInterface";
import AddSalesInvoiceExportDetail from "../../SalesAndPurchase/InvoiceAndPurchaseBill/Add/AddInvoiceAndBillExportDetail";
import {
  AssetDropdownItems,
  PurchaseDropdownItems,
} from "../../SalesAndPurchase/InvoiceAndPurchaseBill/Add/SalesPurchaseAndExpensesDropdownList";
import { ShowPriceHistoryDataView } from "../../SalesAndPurchase/ItemPriceHistory/ShowPriceHistoryDataView";
import AddSalesInvoiceDespatchDetails from "../../SalesAndPurchase/InvoiceAndPurchaseBill/Add/AddSalesInvoiceDespatchDetails";
import AddSalesInvBillAndExpensesReferenceModel from "../../SalesAndPurchase/InvoiceAndPurchaseBill/Add/AddSalesInvBillAndExpensesReferenceModel";
import FixedAssetsServiceNew, {
  AssetStatus_New,
} from "../../../Services/FixedAssetsServiceNew";
import SelectDisposeAssetItem from "./SelectDisposeAssetItem";
import { useHotkey } from "../../../Context/HotKeyContext";

const AddSalesInvoiceAndPurchaseBill = () => {
  const { showKeys } = useHotkey();
  const [form] = Form.useForm();
  const themeData: any = useTheme();
  const navigate = useNavigate();
  const location = useLocation();
  const inputRef: any = useRef(null);
  const { windowWidth } = useContext(noteContext);
  const { currentClient, companySettings } = useClient();
  const { getAllIndStates, clientSpecificRole } = useUser();
  const stateOptions: any = getAllIndStates();
  const itemSetting = companySettings?.setting?.item;
  // console.log("stateOptions", currentClient?.addresses, getUser);
  const {
    updateId,
    salesOrderId,
    quotationId,
    // partyId,
    purchaseOrderId,
    proformaInvoiceId,
    cloneId,
    draftId,
  } = useParams();
  const { openNotification } = useContext(notificationContext);
  const [bankLedgerTrigger, setBankLedgerTrigger] = useState(false);
  const [checkIsPartyApiCall, SetCheckIsPartyApiCall] =
    useState<boolean>(false);
  const [checkIsItemApiCall, SetCheckIsItemApiCall] = useState<boolean>(false);
  const [checkIsBankApiCall, SetCheckIsBankApiCall] = useState<boolean>(false);
  const [trigger, setTrigger] = useState(false);
  const [isLocked, setIsLocked] = useState(false);
  const [serialNoData, setSerialNoData] = useState<any[]>([]);
  let splitPathInVchType: Voucher_Type;
  // let splitPathLedgerByGroupsType: SearchLedgerByGroupsTypes;
  if (location.pathname.split("/")[4] === "asset") {
    splitPathInVchType = Voucher_Type.SalesVoucher;
    // splitPathLedgerByGroupsType = SearchLedgerByGroupsTypes.Sales;
  } else {
    splitPathInVchType = Voucher_Type.PurchaseVoucher;
    // splitPathLedgerByGroupsType = SearchLedgerByGroupsTypes.Purchase;
  }
  const [dueOnSetting, setDueOnSetting] = useState<number>(
    convertToDays(currentClient?.duration!, TimeUnits.Day)
  );
  const [refreshDeleteBatch, setRefreshDeleteBatch] = useState<boolean>(false);
  const [batchQty, setBatchQty] = useState<any[]>([]);
  const [clickedIndex, setClickedIndex] = useState<number | null>(null);
  const [index, setIndex] = useState<number | null>(null);
  const [addLedgerResponse, setAddLedgerResponse] =
    useState<ILedgerAddResponse | null>(null);
  const [dueOnParty, setDueOnParty] = useState<number>(0);
  const [dateFiled, setDateFiled] = useState<any>();
  const [purchaseOrderDate, setPurchaseOrderDate] = useState<string>("");
  const [editDate, setEditDate] = useState<any>();
  const [editDueDate, setEditDueDate] = useState<any>();
  const [balance, setBalance] = useState<number>(0);
  const [totalTcs, setTotalTcs] = useState<number>(0);
  const [totalTds, setTotalTds] = useState<number>(0);
  const [tdsOrTcs, setTdsOrTcs] = useState<number>(
    splitPathInVchType === Voucher_Type.SalesVoucher ? 1 : 0
  );
  const [batchData, setBatchData] = useState<any[]>([]);
  const [forAddBatchData, setForAddBatchData] = useState<any[]>([]);
  const [forAddSerialData, setForAddSerialData] = useState<any[]>([]);
  const [serial, setSerial] = useState<any[]>([]);
  const [batchItmName, setBatchItmName] = useState<any>("");
  const [apiCallField, setApiCallField] = useState<string>("");
  const [newBankAccountAddedIndex, setNewBankAccountAddedIndex] =
    useState<number>();
  // const [totalgst, setTotalgst] = useState<number>(0);
  // const [totalQty, setTotalQty] = useState<number>(0);
  const [isOpenDueDate, setIsDueDate] = useState(false);
  const [loading, setLoading] = useState<boolean>(false);
  const [itemLength, setItemLength] = useState<number>(0);
  const [searchItem, setSearchItem] = useState<string>("");
  // const [isInCash, setIsInCash] = useState<boolean>(false);
  const [itemsOption, setItemsOption] = useState<any[]>([]);
  const [deleteItemList, setDeleteItemList] = useState<any>();
  // const [invoiceTotal, setInvoiceTotal] = useState<number>(0.0);
  const [purchaseOrderRef, setPurchaseOrderRef] = useState<string | null>(null);
  const [purchaseOrderRefTrigger, setPurchaseOrderRefTrigger] =
    useState<number>(0);
  const [salesInvoiceNo, setSalesInvoiceNo] = useState<string>("");
  const [editParty, setEditParty] = useState<{ id: string }>({ id: "" });
  const [selectedParty, setSelectedParty] = useState<string>("");
  const [isPartyCompany, setIsPartyCompany] = useState<PartyType>(
    PartyType.IndividualPerson
  );
  const [isGSTEnabled, setGstEnabled] = useState<boolean>(true);
  const [confirmation, setConfirmation] = useState<boolean>(false);
  const [ledgerconfirmation, setLedgerConfirmation] = useState<boolean>(false);
  const [tcsModelOpen, setTcsModelOpen] = useState<boolean>(false);
  const [tdsModelOpen, setTdsModelOpen] = useState<boolean>(false);
  const [customerOptions, setCustomerOptions] = useState<any[]>([]);
  const [onlyEditTimeCustomerOptions, setOnlyEditTimeCustomerOptions] =
    useState<boolean>(false);
  // const [addressList, setAddressList] = useState<any[]>([]);
  // const [effectiveLedger, setEffectiveLedger] = useState<any[]>([]);
  const [currentCustomerState, setCurrentCustomerState] = useState<number>(
    currentClient?.state!
  );
  const [purchasePartyState, setPurchasePartyState] = useState<number>(
    currentClient?.state!
  );
  const [selectedBatchData, setSelectedBatchData] = useState<any>();
  const [triggerSerialData, setTriggerSerialData] = useState<boolean>(false);
  const [updateAndNewButton, setUpdateAndNewButton] = useState<boolean>(false);
  const [saveNewLoading, setSaveNewLoading] = useState<boolean>(false);
  // const [openCustomerDrawer, setOpenCustomerDrawer] = useState<boolean>(false);
  // const [initialRender, seInitialRender] = useState<boolean>(false);
  const [deleteBankAccountRow, setDeleteBankAccountRow] = useState<any>();
  const [bankConfirmation, setBankConfirmation] = useState<boolean>(false);
  // const [countDraft, setCountDraft] = useState<boolean>(false);
  const [searchBankAccount, setSearchBankAccount] = useState<string>("");
  const [isSaveDraft, setIsSaveDraft] = useState<Boolean>(true);
  const [bankAccountAmt, setBankAccountAmt] = useState<number>(0);
  const [termNCondData, setTermNCondData] = useState<any>();
  const [voucherNumberLoader, setVoucherNumberLoader] = useState(false);
  const [customerAddress, setCustomerAddress] = useState<any>(
    splitPathInVchType === Voucher_Type.SalesVoucher
      ? []
      : currentClient?.addresses
  );
  // const [addressEnum, setAddressEnum] = useState<number>(0);
  const [openModel, setOpenModel] = useState<{ type: string; param: any }>({
    type: "",
    param: {},
  });
  const [alReadySelectedData, setAlReadySelectedData] = useState<any[]>([]);
  const [newItem, setNewItem] = useState<any>({
    data: {},
    isSaved: false,
  });
  const [itemFields, setItemFields] = useState<any>({
    field: 0,
    index: 0,
    add: null,
  });
  const [finalBatchQty, setFinalBatchQty] = useState<any>();
  const [presetsDueDate, setPresetsDueDate] = useState<any>({
    label: 0,
    value: "",
  });
  const [checkedType, setCheckedType] = useState<any>();
  const [batchItmId, setBatchItmId] = useState<any>();
  const [triggerBatchData, setTriggerBatchData] = useState<boolean>(false);
  const [footerTotal, setFooterTotal] = useState<IVoucherFooterTotal>({
    qty: 0,
    unitPrice: 0,
    taxableAmount: 0,
    discount: 0,
    gst: 0,
    amount: 0,
  });
  const [footerLedger, setFooterLedger] = useState<IVoucherFooterLedger>({
    ledgerAmount: 0,
    ledgerGstAmount: 0,
    ledgerTotalAmount: 0,
  });
  const [roundOffAmount, setRoundoffAmount] = useState<number>(0.0);
  const [cashDiscountRs, setCashDiscountRs] = useState<number>(0.0);
  const [itemId, setItemId] = useState<any>();
  const [loadItemAPI, setloadItemAPI] = useState<boolean>(false);
  const [bankAccountList, setBankAccountList] = useState<
    ILedgerSearchByGroupNameResponse[]
  >([]);
  // const [directExpenses, setDirectExpenses] = useState<boolean>(false);
  const [ledgerLength, setLedgerLength] = useState<number>(0);
  const [freightAndInsuranceOptions, setFreightAndInsuranceOptions] =
    useState<any>([]);
  const [deleteLedgerList, setDeleteLedgerList] = useState<any>();
  const [ledgerAmount, setLedgerAmount] = useState<any>();
  const [showFreightInsurance, setShowFreightInsurance] =
    useState<boolean>(false);
  const [updateTimeShowFreightIns, setUpdateTimeShowFreightIns] =
    useState<boolean>(false);
  const [updateTimeData, setUpdateTimeData] = useState<{
    contactDetails: boolean;
    shippingAddress: boolean;
    friInsuranceOtherCharge: boolean;
    receipt: boolean;
    cashDiscount: boolean;
    tradeDiscount: boolean;
    isGSTVoucher: boolean;
    showItemDescription: boolean;
    roundOff: boolean;
    showDispatchDetail: boolean;
    showFreightType: boolean;
    showRCM: boolean;
    voucherNature: Voucher_Nature;
  }>({
    contactDetails: false,
    shippingAddress: false,
    friInsuranceOtherCharge: false,
    receipt: false,
    cashDiscount: false,
    tradeDiscount: false,
    isGSTVoucher: false,
    showItemDescription: false,
    roundOff: false,
    showDispatchDetail: false,
    showFreightType: false,
    showRCM: false,
    voucherNature: Voucher_Nature.Regular,
  });
  const [currentInvoiceDetails, setCurrentInvoiceDetails] = useState<any>();
  const [showPriceHistoryLoading, setShowPriceHistoryLoading] =
    useState<boolean>(false);
  const [showPriceHistory, setShowPriceHistory] = useState<boolean[]>([]);
  const [showPriceHistoryData, setShowPriceHistoryData] =
    useState<PriceHistoryByItemIdResponse[]>();
  const [oldPartyRecepitDetails, setOldPartyRecepitDetails] = useState<any[]>(
    []
  );
  const [newPartyRecepitDetails, setNewPartyRecepitDetails] = useState<any[]>(
    []
  );
  const [isCashVoucher, setIsCashVoucher] = useState<boolean>(true);
  const [addBatches, setAddBatches] = useState<any>([]);
  const getVoucherTitle =
    splitPathInVchType === Voucher_Type.SalesVoucher
      ? companySettings?.setting?.vouchersSettings.find(
          (x: any) =>
            x?.settingType === SettingsSections.Invoice &&
            !x.settings.invoiceSettings?.showRCM
        )
      : companySettings?.setting?.vouchersSettings.find(
          (x: any) =>
            x?.settingType === SettingsSections.PurInvoice &&
            !x.settings.invoiceSettings?.showRCM
        );

  // console.log("Settings: 11111111", companySettings, getVoucherTitle);

  const [settingControl, setSettingControl] = useState<IVoucherSettingControl>({
    title: getVoucherTitle?.title!,
    templateId: getVoucherTitle?.id!,
    titleToBePrint:
      splitPathInVchType === Voucher_Type.SalesVoucher
        ? getVoucherTitle?.settings?.invoiceSettings?.titleToBePrint
        : getVoucherTitle?.settings?.billSettings?.titleToBePrint,
    showContactDetail:
      splitPathInVchType === Voucher_Type.SalesVoucher
        ? getVoucherTitle?.settings?.invoiceSettings?.showContactDetail!
        : getVoucherTitle?.settings?.billSettings?.showContactDetail!,
    discountPolicy:
      splitPathInVchType === Voucher_Type.SalesVoucher
        ? getVoucherTitle?.settings?.invoiceSettings?.discountPolicy!
        : getVoucherTitle?.settings?.billSettings?.discountPolicy!,
    showReceipt:
      splitPathInVchType === Voucher_Type.SalesVoucher
        ? getVoucherTitle?.settings?.invoiceSettings?.showReceipt!
        : getVoucherTitle?.settings?.billSettings?.showReceipt!,
    showPriceHistory:
      splitPathInVchType === Voucher_Type.SalesVoucher
        ? false
        : getVoucherTitle?.settings?.billSettings?.showPriceHistory!,
    showOtherCharges:
      splitPathInVchType === Voucher_Type.SalesVoucher
        ? getVoucherTitle?.settings?.invoiceSettings?.showOtherCharges!
        : getVoucherTitle?.settings?.billSettings?.showOtherCharges!,
    showShippingAddress:
      splitPathInVchType === Voucher_Type.SalesVoucher
        ? getVoucherTitle?.settings?.invoiceSettings?.showShippingAddress!
        : getVoucherTitle?.settings?.billSettings?.showShippingAddress!,
    showItemDescription:
      splitPathInVchType === Voucher_Type.SalesVoucher
        ? getVoucherTitle?.settings?.invoiceSettings?.showItemDescription!
        : getVoucherTitle?.settings?.billSettings?.showItemDescription!,
    autoRoundOff:
      splitPathInVchType === Voucher_Type.SalesVoucher
        ? getVoucherTitle?.settings?.invoiceSettings?.autoRoundOff!
        : getVoucherTitle?.settings?.billSettings?.autoRoundOff!,
    roundOffType:
      splitPathInVchType === Voucher_Type.SalesVoucher
        ? getVoucherTitle?.settings?.invoiceSettings?.roundOffType!
        : getVoucherTitle?.settings?.billSettings?.roundOffType!,
    showDispatchDetail:
      splitPathInVchType === Voucher_Type.SalesVoucher
        ? getVoucherTitle?.settings?.invoiceSettings?.showDispatchDetail!
        : getVoucherTitle?.settings?.billSettings?.showDispatchDetail!,
    showFreightType:
      splitPathInVchType === Voucher_Type.SalesVoucher
        ? getVoucherTitle?.settings?.invoiceSettings?.showFreightType!
        : getVoucherTitle?.settings?.billSettings?.showFreightType!,
    showRCM:
      splitPathInVchType === Voucher_Type.SalesVoucher
        ? getVoucherTitle?.settings?.invoiceSettings?.showRCM!
        : getVoucherTitle?.settings?.billSettings?.showRCM!,
    showTcs: currentClient?.tcsApplicability!,
    showTds: currentClient?.tdsDeductible!,
    defaultNature:
      splitPathInVchType === Voucher_Type.SalesVoucher
        ? getVoucherTitle?.settings?.invoiceSettings?.defaultNature
        : getVoucherTitle?.settings?.billSettings?.defaultNature,
  });
  const [voucherStatus, setVoucherStatus] = useState<VoucherStatus_New>(
    VoucherStatus_New.Active
  );
  const [selectCustomizationTemplete, setSelectCustomizationTemplete] =
    useState<IVoucherCustomizationTemplate>({
      templateId: getVoucherTitle?.id!,
      title:
        splitPathInVchType === Voucher_Type.SalesVoucher
          ? getVoucherTitle?.settings?.invoiceSettings?.titleToBePrint
          : getVoucherTitle?.settings?.billSettings?.titleToBePrint,
    });
  const [dueDateTrigger, setDueDateTrigger] = useState<number>(0);
  const [deletePaymentDetails, setDeletePaymentDetails] = useState<any[]>([]);
  const [saveInvoiceReferences, setSaveInvoiceReferences] = useState<any>();
  const [triggerDeletePaymentApi, setTriggerDeletePaymentApi] =
    useState<boolean>(false);
  const [isDeletePaymentApi, setIsDeletePaymentApi] = useState<boolean>(false);
  const [isSaveAndNew, setIsSaveAndNew] = useState<boolean>(false);
  const [partyIsGstRegistered, setPartyIsGstRegistered] =
    useState<CompanyGSTTypes>(CompanyGSTTypes.Regular);
  const [partyIsGstRegisteredTrigger, setPartyIsGstRegisteredTrigger] =
    useState<number>(0);
  const [
    partyIsGstRegisteredSalesInvoice,
    setPartyIsGstRegisteredSalesInvoice,
  ] = useState<CompanyGSTTypes>(CompanyGSTTypes.Regular);
  const [
    partyIsGstRegisteredSalesInvoiceTrigger,
    setPartyIsGstRegisteredSalesInvoiceTrigger,
  ] = useState<number>(0);
  // companySettings?.setting?.vouchersSettings;
  const [itemSearch, setItemSearch] = useState<string>("");
  const [barCodeSearch, setBarCodeSearch] = useState<string>("");
  const [isBarCodeSearch, SetIsBarCodeSearch] = useState<boolean>(false);
  const [voucherNature, setVoucherNature] = useState<Voucher_Nature>(
    Voucher_Nature.Regular
  );
  const [underLUT, setUnderLUT] = useState<boolean>(false);

  useEffect(() => {
    const findVoucharType = companySettings?.setting?.vouchersSettings?.find(
      (x) => x?.id === selectCustomizationTemplete.templateId
    );
    const voucherData =
      splitPathInVchType === Voucher_Type.SalesVoucher
        ? findVoucharType?.settings?.invoiceSettings
        : findVoucharType?.settings?.billSettings;

    setSettingControl({
      ...voucherData,
      title: findVoucharType?.title,
      titleToBePrint:
        splitPathInVchType === Voucher_Type.SalesVoucher
          ? findVoucharType?.settings?.invoiceSettings?.titleToBePrint
          : findVoucharType?.settings?.billSettings?.titleToBePrint,
      templateId: findVoucharType?.id,
      showContactDetail: voucherData?.showContactDetail!,
      discountPolicy: voucherData?.discountPolicy!,
      showReceipt: voucherData?.showReceipt!,
      showPriceHistory: voucherData?.showPriceHistory!,
      showOtherCharges: voucherData?.showOtherCharges!,
      showShippingAddress: voucherData?.showShippingAddress!,
      showItemDescription: voucherData?.showItemDescription!,
      autoRoundOff: voucherData?.autoRoundOff!,
      roundOffType: voucherData?.roundOffType!,
      showDispatchDetail: voucherData?.showDispatchDetail!,
      showFreightType: voucherData?.showFreightType!,
      showRCM: voucherData?.showRCM!,
      // showTcsTds: settingControl?.showTcsTds!,
    });
    !updateId && setVoucherNature(voucherData?.defaultNature);
    // setTermsAndConditionField({
    //   templateId:
    //     splitPathInVchType === Voucher_Type.SalesVoucher
    //       ? voucherData?.tnCTemplateId
    //       : voucherData?.tnCTemplateId,
    //   tnCText:
    //     splitPathInVchType === Voucher_Type.SalesVoucher
    //       ? voucherData?.termsnConditions
    //       : voucherData?.termsnConditions,
    // });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectCustomizationTemplete]);

  console.log("selectCustomizationTemplete: ", selectCustomizationTemplete);

  const [termsAndConditionField, setTermsAndConditionField] = useState<any>({
    templateId:
      splitPathInVchType === Voucher_Type.SalesVoucher
        ? getVoucherTitle?.settings?.invoiceSettings?.tnCTemplateId
        : getVoucherTitle?.settings?.billSettings?.tnCTemplateId,
    tnCText:
      splitPathInVchType === Voucher_Type.SalesVoucher
        ? getVoucherTitle?.settings?.invoiceSettings?.termsnConditions
        : getVoucherTitle?.settings?.billSettings?.termsnConditions,
  });
  const [transactionId, setTransactionId] = useState<{
    partyId: string;
    effectiveId: string;
  }>({ partyId: "", effectiveId: "" });
  const [updateInPartyId, setUpdateInPartyId] = useState<string>("");
  const [invoiceDespatchDetails, setInvoiceDespatchDetails] = useState<any>();
  const [invoiceExportDetails, setInvoiceExportDetails] = useState<any>();
  const [refreshNumber, setRefreshNumber] = useState<boolean>(false);
  const [saveAndNew, setSaveAndNew] = useState<boolean>(false);
  const [updateAndNew, setUpdateAndNew] = useState<boolean>(false);
  const [orderListOptions, setOrderListOptions] = useState<
    { voucherId: string; voucherNumber: string }[]
  >([]);
  const [currencyList, setCurrencyList] = useState<any[]>([]);
  const [selectAssetItem, setSelectAssetItem] = useState<string[]>([]);
  const [selectedOtherExpenses, setSelectedOtherExpenses] = useState<string[]>(
    []
  );
  const [selectedBankLedger, setSelectedBankLedger] = useState<string[]>([]);
  const [selectedBankBalance, setSelectedBankBalance] = useState<number[]>([]);
  const [selectedBankPartyOrTax, setSelectedBankPartyOrTax] = useState<
    Party_Tax[]
  >([]);
  const [editInvBankDetails, setEditInvBankDetails] = useState<any[]>([]);
  const [mode, setMode] = useState<boolean>(false);
  // const [selectCondition, setSelectCondition] = useState<any>();
  const [isSameBillingAddress, setIsSameBillingAddress] =
    useState<boolean>(false);
  const [deleteUploadId, setDeleteUploadId] = useState<string[]>([]);
  const [previewImage, setPreviewImage] = useState<{
    isBaseConvert: boolean;
    path: any;
  }>({ isBaseConvert: false, path: "" });

  const [tdsList, setTdsList] = useState<any[]>([]);
  const [tcsList, setTcsList] = useState<any[]>([]);
  const [tdsListTrigger, setTdsListTrigger] = useState<boolean>(false);
  const [tcsListTrigger, setTcsListTrigger] = useState<boolean>(false);
  const [tdsPostDetail, setTdsPostDetail] = useState<{
    id: string;
    formNo: string;
    transactionType: Transaction_Type;
  }>({ id: "", formNo: "", transactionType: Transaction_Type.Domestic });
  const [partyPanCard, setPartyPanCard] = useState<PanCardType>(
    PanCardType.notAvailable
  );
  const [itmData, setItmData] = useState<any[]>([]);
  const [tcsTdsPercentage, setTcsTdsPercentage] = useState<number>(0.0);
  const [isPartTDSOrTDS, setIsPartTDSOrTDS] = useState<{
    tds: Boolean;
    tcs: Boolean;
  }>({ tds: false, tcs: false });
  const [partyDropDownLoading, setPartyDropDownLoading] =
    useState<boolean>(false);
  const [ledgerDropDownLoading, setLedgerDropDownLoading] =
    useState<boolean>(false);
  const [orderDropDownLoading, setOrderDropDownLoading] =
    useState<boolean>(false);
  const [bankAccountDropDownLoading, setbankAccountDropDownLoading] =
    useState<boolean>(false);
  const [itemDropDownLoading, setItemDropDownLoading] =
    useState<boolean>(false);
  const [otherExpensiveDropDownLoading, setOtherExpensiveDropDownLoading] =
    useState<boolean>(false);
  const [isStateSame, setIsStateSame] = useState<boolean>(
    splitPathInVchType === Voucher_Type.SalesVoucher
      ? currentCustomerState === currentClient?.state!
      : (currentCustomerState ?? currentClient?.state!) === purchasePartyState
  );
  const handleDataFromChild = (data: any) => {
    setInvoiceExportDetails(data);
    setOpenModel({ type: "", param: "" });
  };

  const gstOption = companySettings?.gsts;

  const amountInNumber = (val: any, key: any) => {
    return Utils.getNumber(val?.amount?.[key]);
  };

  const price = (curr: any) => amountInNumber(curr, "price");
  const qty = (curr: any) => amountInNumber(curr, "qty");
  const discount = (curr: any) => amountInNumber(curr, "discount");
  const taxRate = (curr: any) => Utils.getNumber(curr?.amount?.tax?.title);
  // const netAmount = (curr: any) => price(curr) * qty(curr);
  const netAmount = (curr: any) => price(curr);

  const discountRupee = (curr: any, percentDiscountAll?: number) => {
    console.log("percentDiscountAll", percentDiscountAll);
    if (percentDiscountAll || percentDiscountAll === 0) {
      return percentCal(netAmount(curr), percentDiscountAll);
    } else return percentCal(netAmount(curr), discount(curr));
  };

  // const amountWithoutTax = (curr: any, percentDiscountAll?: number) =>
  //   netAmount(curr) - discountRupee(curr, percentDiscountAll);

  const amountWithoutTax = (curr: any, percentDiscountAll?: number) =>
    netAmount(curr);

  const itemTaxAmt = (curr: any, percentDiscountAll?: number) => {
    console.log("itemTaxAmt1`", taxRate(curr), curr?.amount?.tax);
    return amountWithoutTax(curr, percentDiscountAll) * (taxRate(curr) / 100);
  };

  const amountWithTax = (curr: any, percentDiscountAll?: number) =>
    amountWithoutTax(curr, percentDiscountAll) +
    itemTaxAmt(curr, percentDiscountAll);
  // const amountWithOutTax = (curr: any) => amountWithoutTax(curr);

  const amount = (curr: any) => amountInNumber(curr, "amount");
  const gstrate = (curr: any) => Utils.getNumber(curr?.gstRate?.title);
  const gstamount = (curr: any) =>
    percentCal(Utils.getNumber(curr?.amount), gstrate(curr));

  const ledgertotalamout = (curr: any) =>
    Utils.getNumber(curr?.amount) + gstamount(curr);

  // const setDefaultEffectedAccount = (templateId: number) => {
  //   const ledger = companySettings?.setting?.defaultLedgers?.find(
  //     (x) => x?.voucherTitle.id === templateId
  //   );
  //   if (ledger) {
  //     form.setFieldValue("effectiveLedger", {
  //       value: ledger?.defaultLedgerId,
  //     });
  //   }
  // };

  // update the IsStateSame
  useEffect(() => {
    setIsStateSame(purchasePartyState === currentCustomerState);
  }, [currentCustomerState, purchasePartyState]);

  //To get Item's price history data
  const handlePriceHistoryData = async (itemId: string) => {
    setShowPriceHistoryLoading(true);
    await VoucherServices.getPriceHistoryByItemId(
      currentClient?.id!,
      splitPathInVchType,
      itemId,
      true
    ).then((res: IApiResponse<PriceHistoryByItemIdResponse[]>) => {
      setShowPriceHistoryData(
        updateId
          ? res.result?.filter(
              (res: PriceHistoryByItemIdResponse) => res.voucherId !== updateId
            )
          : res.result
      );
    });
    setShowPriceHistoryLoading(false);
  };

  // Save & New
  useEffect(() => {
    if (saveAndNew || updateAndNew) {
      setFooterTotal({
        qty: 0,
        unitPrice: 0,
        taxableAmount: 0,
        discount: 0,
        gst: 0,
        amount: 0,
      });
      form.resetFields();
      setFooterLedger({
        ledgerAmount: 0,
        ledgerGstAmount: 0,
        ledgerTotalAmount: 0,
      });
      setBankAccountAmt(0);
      form.setFieldValue("dueDate", dayjs(dateFiled).add(dueOnSetting, "d"));
      // setDefaultEffectedAccount(selectCustomizationTemplete.templateId);
      setRefreshNumber(!refreshNumber);
      // setInvoiceTotal(0.0);
      setItemLength(0);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [saveAndNew, updateAndNew]);

  // Date Api
  useEffect(() => {
    const getDate = async () => {
      if (currentClient?.id && !updateId && !location.state?.ledgerId) {
        await VoucherServices.getMaxVoucherDate(
          currentClient?.id!,
          splitPathInVchType
        ).then((res) => {
          const givenDate = new Date(res?.result);
          const currentTime = new Date();

          // Set the time part of givenDate to match currentTime
          givenDate?.setHours(
            currentTime.getHours(),
            currentTime.getMinutes(),
            currentTime.getSeconds(),
            currentTime.getMilliseconds()
          );
          form.setFieldValue("date", dayjs(givenDate));

          // console.log("givenDate", givenDate);

          form.setFieldValue(
            "dueDate",
            dayjs(givenDate).add(
              convertToDays(currentClient?.duration!, TimeUnits.Day),
              "d"
            )
          );
          setDateFiled(givenDate);
        });
      } else if (location.state?.ledgerId) {
        const givenDate = new Date(
          dayjs(
            location?.state?.BankTransactionData?.date,
            "DD/MM/YYYY"
          ).toISOString()
        );
        // dayjs(location?.state?.BankTransactionData?.date)
        const currentTime = new Date();

        // Set the time part of givenDate to match currentTime
        givenDate?.setHours(
          currentTime.getHours(),
          currentTime.getMinutes(),
          currentTime.getSeconds(),
          currentTime.getMilliseconds()
        );
        form.setFieldValue("date", dayjs(givenDate));

        form.setFieldValue(
          "dueDate",
          dayjs(givenDate).add(
            convertToDays(currentClient?.duration!, TimeUnits.Day),
            "d"
          )
        );

        form.setFieldValue(["bankDts", 0], {
          name: {
            value: location.state?.ledgerId,
          },
          amount:
            location?.state?.BankTransactionData?.moneyIn ||
            location?.state?.BankTransactionData?.moneyOut,
          date: givenDate,
        });

        setBankAccountAmt(
          location?.state?.BankTransactionData?.moneyIn ||
            location?.state?.BankTransactionData?.moneyOut
        );

        setDateFiled(givenDate);
      }
    };
    getDate();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentClient?.id, splitPathInVchType]);

  useEffect(() => {
    setSelectCustomizationTemplete({
      templateId: getVoucherTitle?.id!,
      title:
        splitPathInVchType === Voucher_Type.SalesVoucher
          ? getVoucherTitle?.settings?.invoiceSettings?.titleToBePrint
          : getVoucherTitle?.settings?.billSettings?.titleToBePrint,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [splitPathInVchType]);

  useEffect(() => {
    const getInitialValue = async () => {
      if (
        (currentClient?.id && !updateId && !draftId && dateFiled) ||
        (updateAndNew && dateFiled)
      ) {
        setVoucherNumberLoader(true);
        setLoading(true);
        await VoucherServices.getVoucherMaxNo(
          currentClient?.id!,
          splitPathInVchType,
          dayjs(dateFiled).endOf("day").toISOString(),
          selectCustomizationTemplete.templateId
        )
          .then((res) => {
            // console.log("initial value", res.result);
            form.setFieldValue("number", res?.result);
            setSalesInvoiceNo(res?.result);
            setVoucherNumberLoader(false);
            if (!updateId) {
              setLoading(false);
            }

            // setDefaultEffectedAccount(selectCustomizationTemplete.templateId);
          })
          .catch((err: any) => {
            openNotification("error", err.message);
            setVoucherNumberLoader(false);
            // setLoading(false);
          });
        // setVoucherNumberLoader(false);
      }
    };
    getInitialValue();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    currentClient?.id,
    refreshNumber,
    cloneId,
    dateFiled,
    // splitPathInVchType,
    selectCustomizationTemplete,
  ]);

  // -------- Edit Sales Invoice Get API ---------
  useEffect(() => {
    if (
      (updateId || cloneId || draftId) &&
      checkIsBankApiCall &&
      checkIsPartyApiCall &&
      checkIsItemApiCall
      // (settingControl?.showReceipt ||
      //   (editInvBankDetails?.length > 0 ? bankAccountList?.length > 0 : true))
      // customerOptions?.length > 0
    ) {
      const editData = async (id: any) => {
        try {
          setLoading(true);
          const res = draftId
            ? await DraftService.getByDraftId(currentClient?.id!, draftId)
            : await VoucherServices.getVoucharById(
                currentClient?.id!,
                id,
                splitPathInVchType === Voucher_Type.SalesVoucher
                  ? Voucher_Type.SalesVoucher
                  : Voucher_Type.PurchaseVoucher
              );
          if (res?.result) {
            res.result?.purchaseOrderRef?.date &&
              setPurchaseOrderDate(res.result?.purchaseOrderRef?.date);
            setVoucherNature(res.result?.nature);
            setIsLocked(res?.result?.isLocked);
            setTermsAndConditionField(res?.result?.termsNConditions);
            setMode(res.result?.isPurchaseJVVoucher);
            setIsSameBillingAddress(res?.result?.isShippingAddressSame);
            setSelectCustomizationTemplete({
              templateId: res?.result?.voucherTitle?.id,
              title: res?.result?.voucherTitle?.name,
            });
            // CustomerSelect(res.result?.partyLedger[0]?.id);
            setIsCashVoucher(res.result?.isCashVoucher);

            const partyDetail = customerOptions.find(
              (x) => x.id === res.result?.partyLedger[0]?.id
            );
            setIsPartyCompany(partyDetail?.partyType);
            if (
              !res.result?.isCashVoucher ||
              res.result?.payRecVouchers !== null
            ) {
              setUpdateInPartyId(res.result?.partyLedger[0]?.id);
              setSelectedParty(res.result?.partyLedger[0]?.id);
              // Tcs & Tds Party condition show & hinde

              setIsPartTDSOrTDS({
                tds: partyDetail?.deductTDSinSameVoucher,
                tcs: partyDetail?.ledgerTCSApplicability,
              });

              setOldPartyRecepitDetails(
                res.result?.partyLedger[0]?.ref?.map(
                  (v: any, index: number) => {
                    return {
                      key: index,
                      // date: dayjs(v?.date),
                      value: v?.value,
                      refType: v?.refType,
                      id:
                        index === 0
                          ? {
                              value: v?.id,
                              label:
                                v?.refType === 0
                                  ? res?.result?.number
                                  : v?.name,
                              title: v?.parentRef,
                            }
                          : {
                              value: v?.id,
                              label: v?.name,
                              title: v?.parentRef,
                            },
                      dueAmount: v?.dueAmount,
                    };
                  }
                )
              );
            }
            // setEditParty({ id: res.result?.partyLedger[0]?.id });
            setFooterTotal({
              qty: res.result?.amountSummary?.totalQty,
              unitPrice: res.result?.amountSummary?.totalPrice,
              taxableAmount:
                res.result?.amountSummary?.taxableAmount +
                res.result?.amountSummary?.totalDis,
              discount: res.result?.amountSummary?.totalDis,
              gst: res.result?.amountSummary?.totalItemGSTAmt,
              amount:
                Math.abs(res.result?.effectiveLedger[0]?.amount) +
                (partyDetail?.gstType === CompanyGSTTypes.Overseas ||
                partyDetail?.gstType === CompanyGSTTypes.SEZ
                  ? 0
                  : res.result?.amountSummary?.totalItemGSTAmt),
            });
            setFooterLedger({
              ledgerAmount: res.result?.amountSummary?.cifExpenses ?? 0,
              ledgerGstAmount: res.result?.amountSummary?.totalCIFGSTAmt ?? 0,
              ledgerTotalAmount:
                res.result?.amountSummary?.cifExpenses +
                res.result?.amountSummary?.totalCIFGSTAmt,
            });
            setBalance(res.result.amountSummary?.receivedAmount);
            setRoundoffAmount(
              res.result?.amountSummary?.roundOff?.roundOffAmount ?? 0
            );
            setCashDiscountRs(
              res.result?.amountSummary?.cashDiscount?.discountAmount ?? 0
            );

            setTotalTds(res.result?.amountSummary?.tdsAmt);
            setTotalTcs(res.result?.amountSummary?.tcsAmt);
            setTdsOrTcs(res.result?.tcsApplicable ? 1 : 0);
            setTcsTdsPercentage(
              res.result?.tcsApplicable
                ? res.result?.tcsDetail?.rate
                : res.result?.tdsDetail?.rate
            );
            res.result?.tdsApplicable &&
              setTdsPostDetail({
                id: res.result?.tdsDetail?.id,
                formNo: res.result?.tdsDetail?.form,
                transactionType: res.result?.tdsDetail?.transactionType,
              });
            setItemLength(res.result?.items?.length);

            if (splitPathInVchType === Voucher_Type.PurchaseVoucher) {
              setCurrentCustomerState(res.result?.billState);
              setPurchasePartyState(res.result?.supplyState);
              setPartyIsGstRegistered(partyDetail?.gstType);
            } else {
              setPurchasePartyState(res.result?.supplyState);
              setPartyIsGstRegisteredSalesInvoice(partyDetail?.gstType);
              // setPartyIsGstRegisteredSalesInvoiceTrigger((x) => x + 1);
            }
            splitPathInVchType === Voucher_Type.PurchaseVoucher &&
              setTransactionId({
                partyId: res.result?.partyLedger[0]?.transactionId,
                effectiveId: res.result?.effectiveLedger[0]?.transactionId,
              });

            setUnderLUT(res.result.underLUT ?? false);
            const Items = res.result?.assetItems?.map(
              (itm: any, index: number) => {
                const selectedItem = itemsOption?.find(
                  (Item: any) => Item?.id === itm.id
                );
                setSelectAssetItem((prevState) => {
                  const updatedSelectedOptions = [...prevState];
                  updatedSelectedOptions[index] = itm?.id;
                  return updatedSelectedOptions;
                });

                const selectedInvDetail = itm?.selectedInvDetail?.map(
                  (x: any, index: number) => {
                    const otherData = selectedItem?.assetInvDetail?.find(
                      (y: any) => y.id === x.id
                    );
                    return {
                      ...x,
                      availableQty: otherData?.availableQty,
                      editTotalQty: otherData?.availableQty + x?.qty,
                      purchasePrice: otherData?.price,
                      date: dayjs(
                        dayjs(otherData?.date)?.format("DD/MM/YYYY"),
                        "DD/MM/YYYY"
                      ),
                      id: x?.id,
                      voucherRef: {
                        value: x?.id,
                        label: x?.name,
                      },
                      sellPrice: x?.value,
                      totalAmount: Utils.getNumber(x?.qty * x?.value),
                    };
                  }
                );
                return {
                  ...itm,
                  id: {
                    value: itm.id,
                    label: itm?.name,
                  },
                  trackingType: itm?.trackingType,
                  allAssetInvDetail: selectedItem?.assetInvDetail,
                  selectedInvDetail: [...selectedInvDetail, {}],
                  amount: {
                    ...itm?.amount,
                    itemTaxAmt:
                      partyDetail?.gstType === CompanyGSTTypes.Overseas ||
                      partyDetail?.gstType === CompanyGSTTypes.SEZ
                        ? 0
                        : (itm?.amount?.price * itm?.amount?.tax?.rate) / 100,
                    totalAmount:
                      partyDetail?.gstType === CompanyGSTTypes.Overseas ||
                      partyDetail?.gstType === CompanyGSTTypes.SEZ
                        ? itm?.amount?.grossAmount
                        : itm?.amount?.price +
                          (itm?.amount?.price * itm?.amount?.tax?.rate) / 100,
                    unit: {
                      label: itm?.amount?.unit?.name,
                      value: itm?.amount?.unit?.id,
                      unitType: itm?.amount?.unit?.unitType,
                    },
                    tax: {
                      title: itm?.amount?.tax?.rate,
                      label: itm?.amount?.tax?.name,
                      value: itm?.amount?.tax?.id,
                    },
                    hideTax: {
                      title: itm?.amount?.tax?.rate,
                      label: itm?.amount?.tax?.name,
                      value: itm?.amount?.tax?.id,
                    },
                  },
                  otherDetails: {
                    depRate: selectedItem?.depRate ?? 0,
                    depMethod: selectedItem?.depMethod,
                    accumulatedDepreciation:
                      selectedItem?.accumulatedDepreciation,
                    lifeCycleDuration: selectedItem?.lifeCycleDuration,
                    isDepreciable: selectedItem?.isDepreciable,
                  },
                };
              }
            );

            const filterFreightInsLedger =
              res.result?.freightInsLedgers?.filter(
                (x: any) => x?.partyOrTax !== 7 && x?.partyOrTax !== 6
              );

            setShowFreightInsurance(filterFreightInsLedger?.length > 0);
            setUpdateTimeShowFreightIns(filterFreightInsLedger?.length > 0);

            const freightInsLedgers: any[] = filterFreightInsLedger?.map(
              (exp: any) => {
                setSelectedOtherExpenses((select) => [...select, exp?.id]);
                return {
                  ...exp,
                  id: {
                    value: exp?.id,
                    label: exp?.ledgerName,
                  },
                  amount: Math.abs(exp?.amount),
                  transactionId: exp?.transactionId,
                  gstRate: exp?.gstRate?.name && {
                    value: exp?.gstRate?.id,
                    title: exp?.gstRate?.rate,
                    label: exp?.gstRate?.name,
                  },
                };
              }
            );

            setLedgerLength(freightInsLedgers?.length ?? 1);
            const bankDtsGet = draftId
              ? res.result?.instantPayLedgersDetails?.map((x: any) => {
                  let bankAccount = bankAccountList?.find(
                    (y: any) => y?.id === x?.ledgerId
                  );
                  setSelectedBankBalance((y) => [...y, bankAccount?.balance!]);
                  return {
                    name: {
                      value: x?.ledgerId,
                      label: x?.ledgerName,
                      title: Party_Tax.BanknCash,
                    },
                    // name: x?.ledgerId,
                    payRecReference: x?.payRecReference,
                    amount: x?.amount,
                    isDeleted: false,
                  };
                })
              : res.result?.isCashVoucher && !res.result?.payRecVouchers
              ? res.result?.partyLedger?.map((x: any) => {
                  let bankAccount = bankAccountList?.find(
                    (y: any) => y.id === x?.id
                  );

                  if (updateId) {
                    setSelectedBankBalance((y) => [
                      ...y,
                      splitPathInVchType === Voucher_Type.SalesVoucher
                        ? bankAccount?.balance! - x?.amount
                        : Math.abs(x?.amount) + bankAccount?.balance!,
                    ]);
                  } else if (cloneId) {
                    setSelectedBankBalance((y) => [
                      ...y,
                      bankAccount?.balance!,
                    ]);
                  }

                  setSelectedBankLedger((select: any) => [...select, x?.id]);

                  setSelectedBankPartyOrTax((select: any) => [
                    ...select,
                    x?.partyOrTax,
                  ]);

                  return {
                    // editId: x?.id,
                    paymentNumber: x?.number,
                    payRecReference: x?.payRecReference,
                    date: x?.date,
                    // partyRefId: x?.partyLedger[0]?.ref[0]?.id,
                    name: {
                      value: x?.id,
                      label: x?.ledgerName,
                      title: x?.partyOrTax,
                    },
                    isDeleted: false,
                    amount: Math.abs(x?.amount),
                    isReconciled: x.isReconciled,
                    bankImportEntryRef: x.bankImportEntryRef,
                  };
                })
              : res.result?.payRecVouchers?.map((x: any) => {
                  let bankAccount = bankAccountList?.find(
                    (y: any) => y.id === x?.effectiveLedger[0]?.id
                  );

                  if (updateId) {
                    setSelectedBankBalance((y) => [
                      ...y,
                      splitPathInVchType === Voucher_Type.SalesVoucher
                        ? bankAccount?.balance! - x?.effectiveLedger[0]?.amount
                        : Math.abs(x?.effectiveLedger[0]?.amount) +
                          bankAccount?.balance!,
                    ]);
                  } else if (cloneId) {
                    setSelectedBankBalance((y) => [
                      ...y,
                      bankAccount?.balance!,
                    ]);
                  }

                  setSelectedBankLedger((select: any) => [
                    ...select,
                    x?.effectiveLedger[0]?.id,
                  ]);

                  setSelectedBankPartyOrTax((select: any) => [
                    ...select,
                    x?.effectiveLedger[0]?.partyOrTax,
                  ]);

                  return {
                    editId: x?.id,
                    paymentNumber: x?.number,
                    payRecReference: x?.payRecReference,
                    date: x?.date,
                    // totalAmount: {...x?.effectiveLedger[0]?.amount, x?.effectiveLedger?.amount},
                    partyRefId: x?.partyLedger[0]?.ref[0]?.id,
                    name: {
                      value: x?.effectiveLedger[0]?.id,
                      label: x?.effectiveLedger[0]?.ledgerName,
                      title: x?.effectiveLedger[0]?.partyOrTax,
                    },
                    isDeleted: false,
                    amount: Math.abs(x?.effectiveLedger[0]?.amount),
                    isReconciled: x.isReconciled,
                    bankImportEntryRef: x.bankImportEntryRef,
                  };
                });

            setEditInvBankDetails(bankDtsGet ?? []);

            const receivedAmount = draftId
              ? res.result?.instantPayLedgersDetails?.reduce(
                  (acc: number, curr: any) => {
                    return (acc += Utils.getNumber(Math.abs(curr?.amount)));
                  },
                  0
                )
              : res.result?.isCashVoucher && !res.result?.payRecVouchers
              ? res.result?.partyLedger?.reduce((acc: number, curr: any) => {
                  return (acc += Utils.getNumber(Math.abs(curr?.amount)));
                }, 0)
              : res.result?.payRecVouchers?.reduce((acc: number, curr: any) => {
                  return (acc += Utils.getNumber(
                    Math.abs(curr?.effectiveLedger[0]?.amount)
                  ));
                }, 0);

            setBankAccountAmt(receivedAmount ?? 0);

            setUpdateTimeData({
              contactDetails:
                res.result?.contactName || res.result?.contactNo ? true : false,
              shippingAddress:
                res.result?.shippingAddress?.address ||
                res.result?.shippingAddress?.type
                  ? true
                  : false,
              friInsuranceOtherCharge: filterFreightInsLedger?.length > 0,
              receipt: bankDtsGet?.length > 0,
              cashDiscount:
                res.result?.amountSummary?.cashDiscount?.discountAmount > 0,
              tradeDiscount: res.result?.amountSummary?.totalDis > 0,
              isGSTVoucher: res.result?.isGSTVoucher,
              showItemDescription: res.result?.showItemDescription,
              roundOff:
                res.result?.amountSummary?.roundOff?.roundOffApplicable ||
                res.result?.amountSummary?.roundOff?.roundOffAmount !== 0,
              showDispatchDetail: res.result?.despatchDetail ? true : false,
              showFreightType: res.result?.freightType ? true : false,
              showRCM: res.result?.nature === Voucher_Nature.RCM ? true : false,
              voucherNature: res.result?.nature,
            });

            const despatchDetail = {
              ...res.result?.despatchDetail,
              delNoteDate: dayjs(
                dayjs(res.result?.despatchDetail?.delNoteDate).format(
                  "DD/MM/YYYY"
                ),
                "DD/MM/YYYY"
              ),
            };
            setInvoiceDespatchDetails(despatchDetail);

            const exportDetail = {
              ...res.result?.exportDetail,
              shipDate: Utils.isValidDate(res.result?.exportDetail?.shipDate)
                ? dayjs(
                    dayjs(res.result?.exportDetail?.shipDate).format(
                      "DD/MM/YYYY"
                    ),
                    "DD/MM/YYYY"
                  )
                : undefined,
              insuranceDetail: {
                ...res.result?.exportDetail?.insuranceDetail,
                policyDate: Utils.isValidDate(
                  res.result?.exportDetail?.insuranceDetail?.policyDate
                )
                  ? dayjs(
                      dayjs(
                        res.result?.exportDetail?.insuranceDetail?.policyDate
                      ).format("DD/MM/YYYY"),
                      "DD/MM/YYYY"
                    )
                  : undefined,
              },
            };
            setInvoiceExportDetails(exportDetail);
            // let purchaseOrderRefSelect: any = orderListOptions?.find(
            //   (order: any) => order.voucherId === purchaseOrderRef
            // );
            form.setFieldsValue({
              ...res.result,
              supplierInvoiceDate:
                Utils.isValidDate(res.result?.supplierInvoiceDate) &&
                dayjs(res.result?.supplierInvoiceDate),
              currency: {
                value: res.result?.currency?.id,
                label: res.result?.currency?.name,
              },
              billingAddress: {
                ...res.result?.billingAddress,
                type: {
                  value: res.result?.billingAddress?.addressName,
                  lable: res.result?.billingAddress?.addressName,
                  title: res.result?.billingAddress?.type,
                },
              },
              shippingAddress: {
                ...res.result?.shippingAddress,
                type: {
                  value: res.result?.shippingAddress?.addressName,
                  lable: res.result?.shippingAddress?.addressName,
                  title: res.result?.shippingAddress?.type,
                },
              },
              tdsDetail: {
                value: res.result?.tdsDetail?.id,
                label: res.result?.tdsDetail?.name,
                title: res.result?.tdsDetail?.rate,
              },
              tcsDetail: {
                value: res.result?.tcsDetail?.id,
                label: res.result?.tcsDetail?.name,
                title: res.result?.tcsDetail?.rate,
              },
              freightType: res.result?.freightType
                ? res.result?.freightType
                : null,
              roundOff:
                res.result?.amountSummary?.roundOff?.roundOffAmount ?? 0,
              roundoffCheckbox:
                res.result?.amountSummary?.roundOff?.roundOffApplicable,
              cashDiscount:
                res.result?.amountSummary?.cashDiscount?.discountRate > 0
                  ? res.result?.amountSummary?.cashDiscount?.discountRate
                  : Number(
                      res.result?.amountSummary?.cashDiscount?.discountAmount ??
                        0
                    ),
              cashDiscountDrop:
                Number(res.result?.amountSummary?.cashDiscount?.discountRate) >
                0
                  ? DiscountType.PercentageDiscount
                  : DiscountType.RupeeDiscount,
              bankDts:
                bankDtsGet?.length > 0
                  ? bankDtsGet?.length < 2
                    ? [...bankDtsGet, { amount: 0.0 }]
                    : [...bankDtsGet]
                  : [{ amount: 0.0 }],
              showFreightInsLedgers: freightInsLedgers?.length > 0,
              items: Items?.length > 0 && [
                ...Items,
                // {trackingType : t},
                { amount: { price: 0.0, qty: 0, grossAmount: 0 } },
              ],
              purchaseOrderRef: res.result?.purchaseOrderRef?.id && {
                value: res.result?.purchaseOrderRef?.id,
                label: res.result?.purchaseOrderRef?.name,
              },
              freightInsLedgers:
                freightInsLedgers?.length > 0
                  ? [
                      ...freightInsLedgers,
                      {
                        id: null,
                        // gstRate: 0,
                        gstAmount: 0,
                        totalAmount: 0,
                        amount: 0,
                      },
                    ]
                  : [
                      {
                        id: null,
                        // gstRate: 0,
                        gstAmount: 0,
                        totalAmount: 0,
                        amount: 0,
                      },
                    ],
              // effectiveLedger: {
              //   value: res.result?.effectiveLedger[0]?.id,
              //   label: res.result?.effectiveLedger[0]?.ledgerName,
              // },
              partyLedger: res.result?.isCashVoucher
                ? res.result?.payRecVouchers !== null
                  ? {
                      value: res.result?.partyLedger[0]?.id,
                      label: res.result?.partyLedger[0]?.ledgerName,
                    }
                  : null
                : {
                    value: res.result?.partyLedger[0]?.id,
                    label: res.result?.partyLedger[0]?.ledgerName,
                  },
              number: cloneId
                ? form.getFieldValue("number")
                : res.result?.number,
              receivedAmount: res.result?.amountSummary?.receivedAmount,
              paymentType: res.result?.paymentType === 1 ? true : false,
              date: dayjs(res.result?.date),
              dueDate: dayjs(
                dayjs(res.result?.dueDate).format("DD/MM/YYYY"),
                "DD/MM/YYYY"
              ),
            });

            setDueOnParty(partyDetail?.payTerms?.creditPeriod);
            setVoucherStatus(res.result?.voucherStatus);
            setDateFiled(dayjs(res.result?.date));
            setEditDate(res.result?.date);
            setEditDueDate(res.result?.dueDate);
          }
        } catch (err: any) {
          console.error("error", err);

          openNotification("error", err.message);
        } finally {
          setLoading(false);
        }
      };

      editData(draftId ? draftId : updateId ?? cloneId);
    }
    // customerOptions;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    updateId,
    cloneId,
    draftId,
    checkIsPartyApiCall,
    checkIsBankApiCall,
    checkIsItemApiCall,
  ]);

  // Get Sales Order get api to save invoice
  useEffect(() => {
    const getOrderDetails = async (
      orderId: string | undefined,
      type: Voucher_Type,
      setOrderRef: boolean
    ) => {
      if (orderId) {
        // setLoading(true);
        await QuotationServices.getQuotationId(
          currentClient?.id!,
          orderId,
          type
        )
          .then((res: any) => {
            if (res?.result) {
              setPurchaseOrderDate(res?.result?.date);
              setTermsAndConditionField(res?.result?.termsNConditions);
              setVoucherNature(res.result?.nature);
              setIsSameBillingAddress(res?.result?.isShippingAddressSame);
              const party = customerOptions.find(
                (x) => x?.id === res.result?.partyLedger[0]?.id
              );
              setIsPartyCompany(party?.partyType);
              setSelectedParty(res.result?.partyLedger[0]?.id);
              setUpdateInPartyId(res.result?.partyLedger[0]?.id);
              setSelectedParty(res.result?.partyLedger[0]?.id);
              // Tcs & Tds Party condition show & hinde
              setIsPartTDSOrTDS({
                tds: party?.deductTDSinSameVoucher,
                tcs: party?.ledgerTCSApplicability,
              });
              setFooterLedger({
                ledgerAmount: Utils.getNumber(
                  res.result?.amountSummary?.cifExpenses
                ),
                ledgerGstAmount: Utils.getNumber(
                  res.result?.amountSummary?.totalCIFGSTAmt
                ),
                ledgerTotalAmount: Utils.getNumber(
                  res.result?.amountSummary?.cifExpenses +
                    res.result?.amountSummary?.totalCIFGSTAmt
                ),
              });
              setRoundoffAmount(
                res.result?.amountSummary?.roundOff?.roundOffAmount ?? 0
              );
              setTotalTds(res.result?.amountSummary?.tdsAmt);
              setTotalTcs(res.result?.amountSummary?.tcsAmt);
              setTdsOrTcs(res.result?.tcsApplicable ? 1 : 0);
              setTcsTdsPercentage(
                res.result?.tcsApplicable
                  ? res.result?.tcsDetail?.rate
                  : res.result?.tdsDetail?.rate
              );
              res.result?.tdsApplicable &&
                setTdsPostDetail({
                  id: res.result?.tdsDetail?.id,
                  formNo: res.result?.tdsDetail?.form,
                  transactionType: res.result?.tdsDetail?.transactionType,
                });
              if (splitPathInVchType === Voucher_Type.PurchaseVoucher) {
                setCurrentCustomerState(res.result?.billState);
                setPurchasePartyState(res.result?.supplyState);
                setPartyIsGstRegistered(party?.gstType);
              } else {
                setPurchasePartyState(res.result?.supplyState);
                setPartyIsGstRegisteredSalesInvoice(party?.gstType);
                // setPartyIsGstRegisteredSalesInvoiceTrigger((x) => x + 1);
              }
              splitPathInVchType === Voucher_Type.PurchaseVoucher &&
                setTransactionId({
                  partyId: res.result?.partyLedger[0]?.transactionId,
                  effectiveId: res.result?.effectiveLedger[0]?.transactionId,
                });
              setUnderLUT(res.result.underLUT ?? false);

              const Items = res.result?.items?.map((itm: any) => {
                return {
                  ...itm,
                  id: {
                    value: itm.id,
                    label: itm?.name,
                  },
                  trackingType: itm?.trackingType,
                  amount: {
                    ...itm?.amount,
                    qty: itm?.amount?.qty - itm?.amount?.suppliedQty,
                    itemTaxAmt:
                      party?.gstType === CompanyGSTTypes.Overseas ||
                      party?.gstType === CompanyGSTTypes.SEZ
                        ? 0
                        : itm?.amount?.itemTaxAmt,
                    totalAmount:
                      party?.gstType === CompanyGSTTypes.Overseas ||
                      party?.gstType === CompanyGSTTypes.SEZ
                        ? itm?.amount?.grossAmount
                        : itm?.amount?.totalAmount,
                    unit: {
                      label: itm?.amount?.unit?.name,
                      value: itm?.amount?.unit?.id,
                      unitType: itm?.amount?.unit?.unitType,
                    },
                    tax:
                      splitPathInVchType === Voucher_Type?.PurchaseVoucher
                        ? party?.gstType === CompanyGSTTypes.Regular && {
                            title: itm?.amount?.tax?.rate,
                            label: itm?.amount?.tax?.name,
                            value: itm?.amount?.tax?.id,
                          }
                        : currentClient?.gstType === CompanyGSTTypes.Regular
                        ? {
                            title: itm?.amount?.tax?.rate,
                            label: itm?.amount?.tax?.name,
                            value: itm?.amount?.tax?.id,
                          }
                        : null,
                    hideTax: {
                      title: itm?.amount?.tax?.rate,
                      label: itm?.amount?.tax?.name,
                      value: itm?.amount?.tax?.id,
                    },
                  },
                };
              });
              setItemLength(Items?.length);
              const filterFreightInsLedger =
                res.result?.freightInsLedgers?.filter(
                  (x: any) => x?.partyOrTax !== 7 && x?.partyOrTax !== 6
                );
              setShowFreightInsurance(filterFreightInsLedger?.length > 0);
              setUpdateTimeShowFreightIns(filterFreightInsLedger?.length > 0);
              const freightInsLedgers: any[] = filterFreightInsLedger?.map(
                (exp: any) => {
                  setSelectedOtherExpenses((select) => [...select, exp?.id]);
                  return {
                    ...exp,
                    id: {
                      value: exp?.id,
                      label: exp?.ledgerName,
                    },
                    amount: Math.abs(exp?.amount),
                    transactionId: exp?.transactionId,
                    totalAmount:
                      party?.gstType === CompanyGSTTypes.Regular
                        ? Math.abs(exp?.totalAmount)
                        : exp?.amount,
                    gstAmount:
                      party?.gstType === CompanyGSTTypes.Regular
                        ? exp?.gstAmount
                        : 0,
                    gstRate:
                      splitPathInVchType === Voucher_Type?.PurchaseVoucher
                        ? party?.gstType === CompanyGSTTypes.Regular &&
                          exp?.gstRate?.name && {
                            value: exp?.gstRate?.id,
                            title: exp?.gstRate?.rate,
                            label: exp?.gstRate?.name,
                          }
                        : currentClient?.gstType === CompanyGSTTypes.Regular &&
                          exp?.gstRate?.name
                        ? {
                            value: exp?.gstRate?.id,
                            title: exp?.gstRate?.rate,
                            label: exp?.gstRate?.name,
                          }
                        : null,
                    hideTax: exp?.gstRate?.name && {
                      value: exp?.gstRate?.id,
                      label: exp?.gstRate?.name,
                      title: exp?.gstRate?.rate,
                    },
                  };
                }
              );
              setLedgerLength(freightInsLedgers?.length ?? 1);
              setUpdateTimeData({
                contactDetails:
                  res.result?.contactName || res.result?.contactNo
                    ? true
                    : false,
                shippingAddress:
                  res.result?.shippingAddress?.address ||
                  res.result?.shippingAddress?.type
                    ? true
                    : false,
                friInsuranceOtherCharge: freightInsLedgers?.length > 0,
                receipt: false,
                cashDiscount: false,
                tradeDiscount: res.result?.amountSummary?.totalDis > 0,
                isGSTVoucher:
                  splitPathInVchType === Voucher_Type?.PurchaseVoucher
                    ? party?.gstType === CompanyGSTTypes.Regular
                    : true &&
                      currentClient?.gstType === CompanyGSTTypes.Regular,
                showItemDescription: res.result?.showItemDescription,
                roundOff:
                  res.result?.amountSummary?.roundOff?.roundOffApplicable ||
                  res.result?.amountSummary?.roundOff?.roundOffAmount !== 0,
                showDispatchDetail: res.result?.despatchDetail ? true : false,
                showFreightType: res.result?.freightType ? true : false,
                showRCM:
                  res.result?.nature === Voucher_Nature.RCM ? true : false,
                voucherNature: res.result?.nature,
              });

              setOrderRef && setPurchaseOrderRef(orderId);

              form.setFieldsValue({
                // ...res.result,
                supplierInvoiceDate:
                  Utils.isValidDate(res.result?.supplierInvoiceDate) &&
                  dayjs(res.result?.supplierInvoiceDate),
                currency: {
                  value: res.result?.currency?.id,
                  label: res.result?.currency?.name,
                },
                billingAddress: {
                  ...res.result?.billingAddress,
                  type: {
                    value: res.result?.billingAddress?.addressName,
                    lable: res.result?.billingAddress?.addressName,
                    title: res.result?.billingAddress?.type,
                  },
                },
                shippingAddress: {
                  ...res.result?.shippingAddress,
                  type: {
                    value: res.result?.shippingAddress?.addressName,
                    lable: res.result?.shippingAddress?.addressName,
                    title: res.result?.shippingAddress?.type,
                  },
                },
                supplyState:
                  splitPathInVchType === Voucher_Type.PurchaseVoucher
                    ? res.result?.billState
                    : res.result?.supplyState,
                tdsDetail: {
                  value: res.result?.tdsDetail?.id,
                  label: res.result?.tdsDetail?.name,
                  title: res.result?.tdsDetail?.rate,
                },
                tcsDetail: {
                  value: res.result?.tcsDetail?.id,
                  label: res.result?.tcsDetail?.name,
                  title: res.result?.tcsDetail?.rate,
                },
                freightType: res.result?.freightType
                  ? res.result?.freightType
                  : null,
                showFreightInsLedgers: freightInsLedgers?.length > 0,
                roundOff:
                  res.result?.amountSummary?.roundOff?.roundOffAmount ?? 0,
                roundoffCheckbox:
                  res.result?.amountSummary?.roundOff?.roundOffApplicable,
                items: [
                  ...Items,
                  { amount: { price: 0.0, qty: 0, grossAmount: 0 } },
                ],
                freightInsLedgers:
                  freightInsLedgers?.length > 0
                    ? [
                        ...freightInsLedgers,
                        {
                          id: null,
                          // gstRate: 0,
                          gstAmount: 0,
                          totalAmount: 0,
                          amount: 0,
                        },
                      ]
                    : [
                        {
                          id: null,
                          // gstRate: 0,
                          gstAmount: 0,
                          totalAmount: 0,
                          amount: 0,
                        },
                      ],
                // effectiveLedger: {
                //   value: res.result?.effectiveLedger[0]?.id,
                //   label: res.result?.effectiveLedger[0]?.ledgerName,
                // },
                partyLedger: {
                  value: res.result?.partyLedger[0]?.id,
                  label: res.result?.partyLedger[0]?.ledgerName,
                },
                purchaseOrderRef: {
                  value: orderId,
                  label: res.result?.number,
                },
                date: dayjs(
                  dayjs(res.result.date).format("DD/MM/YYYY"),
                  "DD/MM/YYYY"
                ),
                dueDate: dayjs(res.result?.date).add(
                  party && party?.creditPeriod > 0
                    ? convertToDays(party?.creditPeriod!, TimeUnits.Day)
                    : convertToDays(currentClient?.duration!, TimeUnits.Day),
                  "d"
                ),

                // id: val?.partyLedger?.value,
                // PartyOrTax: Party_Tax.party,
                // amount:
                //   Utils.getNumber(invoiceTotal) +
                //   Utils.getNumber(footerLedger.ledgerTotalAmount),
                // receivedAmount: res.result?.amountSummary?.receivedAmount,
                // paymentType: res?.result?.paymentType === 1 ? true : false,
              });
              handleAllTheTotalValues();
            } else;
          })
          .catch((err: any) => {
            // setLoading(false);
            openNotification("error", err.message);
          });
        // setLoading(false);
      }
    };

    if (customerOptions.length > 0) {
      if (quotationId) {
        getOrderDetails(quotationId, Voucher_Type.Quotation, true);
      } else if (salesOrderId) {
        getOrderDetails(salesOrderId, Voucher_Type.SalesOrder, true);
      } else if (purchaseOrderId) {
        getOrderDetails(purchaseOrderId, Voucher_Type.PurchaseOrder, true);
      } else if (proformaInvoiceId) {
        getOrderDetails(proformaInvoiceId, Voucher_Type.PInvoice, true);
      } else if (purchaseOrderRef) {
        getOrderDetails(
          purchaseOrderRef,
          splitPathInVchType === Voucher_Type.SalesVoucher
            ? Voucher_Type.SalesOrder
            : Voucher_Type.PurchaseOrder,
          false
        );
      }
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    salesOrderId,
    purchaseOrderId,
    quotationId,
    proformaInvoiceId,
    purchaseOrderRefTrigger,
    customerOptions,
  ]);

  // ----- Get Estimate Api (Post Sales Invoice) Api -------
  // useEffect(() => {
  //   if (quotationId) {
  //     setLoading(true);
  //     SalesService.getQuotation(
  //       currentClient?.id!,
  //       EstimateTypes.Estimate,
  //       quotationId
  //     )
  //       .then((res: any) => {
  //         const quot = res.result?.invoice;
  //         if (res.result) {
  //           setFooterTotal({
  //             qty: quot?.amountSummary?.totalQty,
  //             unitPrice: quot?.amountSummary?.totalPrice,
  //             taxableAmount: quot?.amountSummary?.taxableAmount,
  //             discount: quot?.amountSummary?.totalDis,
  //             gst: quot?.amountSummary?.igstAmt
  //               ? quot?.amountSummary?.igstAmt
  //               : quot?.amountSummary?.sgstAmt + quot?.amountSummary?.cgstAmt,
  //             amount: quot?.amountSummary?.totalInvoiceAmount,
  //           });
  //           // setInvoiceTotal(quot?.amountSummary?.totalInvoiceAmount);
  //           setItemLength(quot?.items.length);
  //           setEstimateNo(quot?.number);
  //           setEditParty({ id: quot?.partyLedger.id });
  //           setCurrentCustomerState(quot.supplyState);

  //           const Items = quot?.items?.map((itm: any) => {
  //             return {
  //               ...itm,
  //               account: {
  //                 label: itm?.account?.name,
  //                 value: itm?.account?.id,
  //               },
  //               amount: {
  //                 ...itm?.amount,
  //                 tax: {
  //                   title: itm?.amount?.tax?.id,
  //                   label: itm?.amount?.tax?.name,
  //                   value: itm?.amount?.tax?.rate,
  //                 },
  //               },
  //             };
  //           });

  //           form.setFieldsValue({
  //             items: [...Items, [{ amount: { price: 0.0, qty: 0 } }]],
  //             phoneNo: quot?.phoneNo,
  //             billingAddress: quot?.billingAddress,
  //             shippingAddress: quot?.shippingAddress,
  //             supplyState: quot?.supplyState,
  //             explanation: quot?.explanation,
  //             receivedAmount: quot?.amountSummary?.receivedAmount,
  //             partyLedger: {
  //               value: quot?.partyLedger.id,
  //               label: quot?.partyLedger.name,
  //             },
  //             date: dayjs(dayjs(quot?.date).format("DD/MM/YYYY"), "DD/MM/YYYY"),
  //             dueDate: dayjs(
  //               dayjs(quot?.dueDate).format("DD/MM/YYYY"),
  //               "DD/MM/YYYY"
  //             ),
  //           });
  //           setLoading(false);
  //         } else setLoading(false);
  //       })
  //       .catch((err: any) => {
  //         openNotification("error", err.message);
  //         console.error("Error..", err.message);
  //         setLoading(false);
  //       });
  //   }
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [quotationId]);

  //------ Get a Include Other Expenses(Direct Income) Ledger

  useEffect(() => {
    const FreightAndInsuranceOptions = async () => {
      setOtherExpensiveDropDownLoading(true);
      await LedgerService.getLedgersByGroupName(
        currentClient?.id!,
        splitPathInVchType === Voucher_Type.SalesVoucher
          ? SearchLedgerByGroupsTypes.SellingAndDistributionExpenses
          : mode
          ? SearchLedgerByGroupsTypes.AllExpensesWithDutiesAndTaxes
          : SearchLedgerByGroupsTypes.DirectExpenses
      )
        .then((res: any) => {
          // console.log(res, "indirExpLedgers");
          if (res) {
            setFreightAndInsuranceOptions(res);
            setOtherExpensiveDropDownLoading(false);
          }
        })
        .catch((ex: any) => {
          console.error("error", ex);
          setOtherExpensiveDropDownLoading(false);
        });
    };
    FreightAndInsuranceOptions();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentClient?.id, trigger, splitPathInVchType, mode]);

  // -------- Add Sales Invoice Post API ---------
  const addSalesInvoice = (isSaveAndNew?: boolean) => {
    form.validateFields().then(async (val: any) => {
      setLoading(true);
      console.log("valll", val);
      if (
        Utils.getNumber(footerTotal.amount) +
          Utils.getNumber(footerLedger.ledgerTotalAmount) +
          roundOffAmount -
          cashDiscountRs >
        0
      ) {
        try {
          if (val?.items[0]?.id) {
            console.log("data", val, footerTotal, footerLedger);
            if (
              isCashVoucher &&
              Utils.getNumber(
                Utils.getFormattedNumber(Utils.getNumber(bankAccountAmt))
              ) !==
                Utils.getNumber(
                  Utils.getFormattedNumber(
                    voucherNature === Voucher_Nature.RCM ||
                      partyIsGstRegisteredSalesInvoice ===
                        CompanyGSTTypes.Overseas ||
                      partyIsGstRegisteredSalesInvoice === CompanyGSTTypes.SEZ
                      ? footerTotal.taxableAmount +
                          footerLedger.ledgerAmount +
                          totalTcs +
                          roundOffAmount -
                          footerTotal.discount -
                          cashDiscountRs
                      : Utils.getNumber(footerTotal.amount) +
                          Utils.getNumber(footerLedger.ledgerTotalAmount) +
                          totalTcs +
                          roundOffAmount -
                          cashDiscountRs
                  )
                )
            ) {
              openNotification(
                "error",
                "Cash Invoice - Received amount must be equal to the total transaction amount."
              );
              setLoading(false);
            } else {
              let bankBalanceLargeAmount: any = [];
              if (splitPathInVchType === Voucher_Type.PurchaseVoucher) {
                if (val.bankDts?.length > 0) {
                  for (const index in selectedBankBalance) {
                    if (
                      val.bankDts[index]?.amount > selectedBankBalance[index]
                    ) {
                      bankBalanceLargeAmount.push({
                        name: val.bankDts[index]?.name?.label,
                        amount: selectedBankBalance[index],
                      });
                      console.log("index", val.bankDts[index]?.name?.value);
                    }
                  }
                }
              }

              if (bankBalanceLargeAmount?.length > 0) {
                const formattedDetails = bankBalanceLargeAmount.map(
                  (obj: any) =>
                    `${obj?.name} -  Bank Amount: ₹ ${Utils.getFormattedNumber(
                      obj?.amount
                    )}`
                );
                alert(formattedDetails.join("\n"));
              } else {
                console.log(
                  "post...........",
                  val.bankDts,
                  bankBalanceLargeAmount
                );

                isSaveAndNew
                  ? setSaveNewLoading(true)
                  : setUpdateAndNewButton(true);
                setSaveAndNew(false);
                // setUpdateAndNew(false);
                const freightInsLedgers = val?.freightInsLedgers?.map(
                  (exp: any) => {
                    return {
                      ...exp,
                      id: exp?.id?.value,
                      gstRate: {
                        id: exp?.gstRate?.value,
                        rate: exp?.gstRate?.title,
                        name: exp?.gstRate?.label,
                      },
                    };
                  }
                );

                const partyLedger = val?.partyLedger?.value
                  ? new Array({
                      id: val?.partyLedger?.value,
                      partyOrTax: Party_Tax.party,
                      amount:
                        Utils.getNumber(footerTotal.amount) +
                        Utils.getNumber(footerLedger.ledgerTotalAmount) -
                        cashDiscountRs +
                        roundOffAmount -
                        (voucherNature === Voucher_Nature.RCM
                          ? footerTotal?.gst + footerLedger.ledgerGstAmount
                          : 0) -
                        totalTds +
                        totalTcs,
                      transactionId:
                        transactionId.partyId === ""
                          ? null
                          : transactionId.partyId,
                    })
                  : val.bankDts.map((x: any) => {
                      return {
                        id: x?.name?.value,
                        amount: x?.amount,
                        partyOrTax: x?.name?.title,
                        transactionId:
                          transactionId.partyId === ""
                            ? null
                            : transactionId.partyId,
                      };
                    });

                const bankDts = val?.partyLedger?.value ? val.bankDts : [];

                // const effectiveLedger = new Array({
                //   id: val?.effectiveLedger?.value,
                //   PartyOrTax: Party_Tax.other,
                //   amount:
                //     Utils.getNumber(footerTotal.taxableAmount) -
                //     footerTotal.discount,
                //   transactionId:
                //     transactionId.partyId === "" ? null : transactionId.partyId,
                // });

                const adjustDateToCurrentTime = (date: any) => {
                  const currentTime = new Date();

                  // Set the time part of the date to match the current time
                  date.setHours(
                    currentTime.getHours(),
                    currentTime.getMinutes(),
                    currentTime.getSeconds(),
                    currentTime.getMilliseconds()
                  );
                  return date;
                };

                const items = val?.items?.map((itm: any) => {
                  return {
                    ...itm,
                    id: itm.id?.value,
                    name: itm.id?.label,
                    // batchItem: itm?.batchItem?.map((d: any) => {
                    //   return {
                    //     ...d,
                    //     mfDate:
                    //       Utils.isValidDate(d?.mfDate) &&
                    //       dayjs(d?.mfDate).toString(),
                    //     expiryDate:
                    //       Utils.isValidDate(d?.expiryDate) &&
                    //       dayjs(d?.expiryDate).toString(),
                    //   };
                    // }),
                    // serialItem: itm?.serialItem?.map((d: any) => {
                    //   return {
                    //     ...d,
                    //     warranty:
                    //       Utils.isValidDate(d?.warranty) &&
                    //       dayjs(d?.warranty).toString(),
                    //   };
                    // }),
                    // trackingType: itm?.batchItem?.length
                    //   ? Item_Nature?.Batch
                    //   : itm?.serialItem?.length
                    //   ? Item_Nature?.Serial
                    //   : "",
                    amount: {
                      ...itm?.amount,
                      unit: {
                        id: itm.amount?.unit?.value,
                        name: itm.amount?.unit?.label,
                        // shortName: itm.amount?.unit?.shortName,
                        unitType: itm?.amount?.unit?.unitType,
                      },
                      grossAmount: Utils.getNumber(itm?.amount?.price),
                      // * itm?.amount?.qty,
                      tax: {
                        id: itm?.amount?.tax?.value,
                        rate: itm?.amount?.tax?.title,
                        name: itm?.amount?.tax?.label,
                      },
                    },
                  };
                });

                const despatchDetail = {
                  ...invoiceDespatchDetails,
                  delNoteDate: invoiceDespatchDetails?.delNoteDate
                    ? dayjs(invoiceDespatchDetails?.delNoteDate).toISOString()
                    : null,
                };

                let adjustedGivenDate = adjustDateToCurrentTime(
                  new Date(val.date)
                );
                let adjustedDueGivenDate = adjustDateToCurrentTime(
                  new Date(val.dueDate)
                );

                if (updateId) {
                  adjustedGivenDate = dayjs(val.date).isSame(
                    dayjs(editDate),
                    "day"
                  )
                    ? editDate
                    : adjustedGivenDate;

                  adjustedDueGivenDate = dayjs(val.dueDate).isSame(
                    dayjs(editDueDate),
                    "day"
                  )
                    ? editDueDate
                    : adjustedDueGivenDate;
                }
                const tdsRatePredentage =
                  partyPanCard === PanCardType.HUF
                    ? val?.tdsDetail?.title?.rates?.indHUFRate ??
                      val?.tdsDetail?.title
                    : partyPanCard === PanCardType.Other
                    ? val?.tdsDetail?.title?.rates?.otherRate ??
                      val?.tdsDetail?.title
                    : val?.tdsDetail?.title?.rates?.ifPANNotRate ??
                      val?.tdsDetail?.title;

                const invoice = {
                  ...val,
                  isAssetVoucher: true,
                  voucherTitle: {
                    id: selectCustomizationTemplete.templateId,
                    name: selectCustomizationTemplete.title,
                  },
                  currency: {
                    id: val?.currency?.value,
                    name: val?.currency?.label,
                  },
                  underLUT: underLUT,
                  bankDts: bankDts,
                  isCashVoucher: isCashVoucher,
                  assetItems: items,
                  billingAddress: {
                    ...val?.billingAddress,
                    // type: val?.billingAddress?.type?.title,
                    addressName: val?.billingAddress?.type?.value,
                  },
                  shippingAddress: {
                    ...val?.shippingAddress,
                    // type: val?.shippingAddress?.type?.title,
                    addressName: val?.shippingAddress?.type?.value,
                  },
                  tcsApplicable:
                    tdsOrTcs && totalTcs > 0 && isPartTDSOrTDS.tcs
                      ? true
                      : false,
                  tcsDetail:
                    tdsOrTcs && totalTcs > 0 && isPartTDSOrTDS.tcs
                      ? {
                          id: val?.tcsDetail?.value,
                          name: val?.tcsDetail?.label,
                          rate: val?.tcsDetail?.title,
                          value: totalTcs,
                        }
                      : null,
                  tdsApplicable:
                    tdsOrTcs === 0 && totalTds > 0 && isPartTDSOrTDS.tds
                      ? true
                      : false,
                  tdsDetail:
                    tdsOrTcs === 0 && totalTds > 0 && isPartTDSOrTDS.tds
                      ? {
                          id: val?.tdsDetail?.value,
                          name: val?.tdsDetail?.label,
                          rate: tdsRatePredentage,
                          value: totalTds,
                          transactionType: tdsPostDetail.transactionType,
                          form: tdsPostDetail.formNo,
                        }
                      : null,
                  nature: voucherNature,
                  isPurchaseJVVoucher: mode,
                  isShippingAddressSame: isSameBillingAddress,
                  isGSTVoucher:
                    splitPathInVchType === Voucher_Type.SalesVoucher
                      ? currentClient?.gstType === CompanyGSTTypes.Regular ||
                        updateTimeData.isGSTVoucher
                      : partyIsGstRegistered === CompanyGSTTypes.Regular,
                  showItemDescription:
                    settingControl.showItemDescription ||
                    updateTimeData.showItemDescription,
                  draftId: draftId,
                  termsNConditions: termsAndConditionField,
                  bankAmount: bankAccountAmt,
                  instantPayment:
                    isCashVoucher &&
                    !selectedParty &&
                    Utils.getNumber(bankAccountAmt) ===
                      Utils.getNumber(
                        voucherNature === Voucher_Nature.RCM ||
                          partyIsGstRegisteredSalesInvoice ===
                            CompanyGSTTypes.Overseas ||
                          partyIsGstRegisteredSalesInvoice ===
                            CompanyGSTTypes.SEZ
                          ? footerTotal.taxableAmount +
                              footerLedger.ledgerAmount +
                              totalTcs +
                              roundOffAmount -
                              footerTotal.discount -
                              cashDiscountRs
                          : Utils.getNumber(footerTotal.amount) +
                              Utils.getNumber(footerLedger.ledgerTotalAmount) +
                              totalTcs +
                              roundOffAmount -
                              cashDiscountRs
                      )
                      ? false
                      : bankAccountAmt > 0
                      ? true
                      : false,
                  purchaseOrderRef: {
                    id: val?.purchaseOrderRef?.value,
                    date:
                      Utils.isValidDate(purchaseOrderDate) &&
                      dayjs(purchaseOrderDate).toISOString(),
                  },
                  date: dayjs(adjustedGivenDate).toISOString(),
                  dueDate: dayjs(adjustedDueGivenDate)?.toISOString(),
                  supplierInvoiceDate:
                    Utils.isValidDate(val?.supplierInvoiceDate) &&
                    dayjs(val?.supplierInvoiceDate).toISOString(),

                  freightInsLedgers,
                  partyLedger,
                  // effectiveLedger,
                  despatchDetail: despatchDetail,
                  exportDetail: {
                    ...invoiceExportDetails,
                    shipDate:
                      Utils.isValidDate(invoiceExportDetails?.shipDate) &&
                      dayjs(invoiceExportDetails?.shipDate).toISOString(),
                    insuranceDetail: {
                      ...invoiceExportDetails?.insuranceDetail,
                      policyDate:
                        Utils.isValidDate(
                          invoiceExportDetails?.insuranceDetail?.policyDate
                        ) &&
                        dayjs(
                          invoiceExportDetails?.insuranceDetail?.policyDate
                        ).toISOString(),
                    },
                  },
                  isStateSame: isStateSame,
                  billState: currentCustomerState,
                  amountSummary: {
                    tCSRate: val?.tcsDetail?.title,
                    tCSAmt: totalTcs,
                    tDSRate: tdsRatePredentage,
                    tDSAmt: totalTds,
                    totalQty: footerTotal?.qty,
                    taxableAmount:
                      Utils.getNumber(footerTotal?.taxableAmount) -
                      footerTotal?.discount, // befor gst
                    totalDis: footerTotal?.discount,
                    freightAmount: 0,
                    cessAmount: 0,
                    igstAmt:
                      !isStateSame ||
                      partyIsGstRegisteredSalesInvoice ===
                        CompanyGSTTypes.SEZ ||
                      partyIsGstRegisteredSalesInvoice ===
                        CompanyGSTTypes.Overseas
                        ? footerTotal?.gst + footerLedger.ledgerGstAmount
                        : 0,
                    cgstAmt:
                      isStateSame &&
                      partyIsGstRegisteredSalesInvoice !==
                        CompanyGSTTypes.SEZ &&
                      partyIsGstRegisteredSalesInvoice !==
                        CompanyGSTTypes.Overseas
                        ? (footerTotal?.gst + footerLedger.ledgerGstAmount) / 2
                        : 0,
                    sgstAmt:
                      isStateSame &&
                      partyIsGstRegisteredSalesInvoice !==
                        CompanyGSTTypes.SEZ &&
                      partyIsGstRegisteredSalesInvoice !==
                        CompanyGSTTypes.Overseas
                        ? (footerTotal?.gst + footerLedger.ledgerGstAmount) / 2
                        : 0,
                    // roundOffAmount: roundOffAmount,
                    roundOff: {
                      roundOffApplicable: val?.roundoffCheckbox,
                      roundOffAmount: roundOffAmount,
                    },
                    cashDiscount: {
                      discountRate:
                        val.cashDiscountDrop === DiscountType.PercentageDiscount
                          ? val.cashDiscount ?? 0
                          : 0,
                      discountAmount: cashDiscountRs,
                    },
                    totalInvoiceAmount: Utils.getFormattedNumber(
                      Utils.getNumber(footerTotal.amount) +
                        Utils.getNumber(footerLedger.ledgerTotalAmount) +
                        roundOffAmount -
                        cashDiscountRs -
                        (voucherNature === Voucher_Nature.RCM
                          ? footerTotal?.gst + footerLedger.ledgerGstAmount
                          : 0) +
                        totalTcs
                    ),
                    // -
                    // totalTds,
                    receivedAmount: 0,
                    voucherAmountWithoutTCS:
                      Utils.getNumber(footerTotal.amount) +
                      Utils.getNumber(footerLedger.ledgerTotalAmount) -
                      balance,
                  },
                  deleteUploadId: deleteUploadId,
                };

                console.log("invoice", invoice, invoiceExportDetails);
                setCurrentInvoiceDetails(invoice);

                if (footerTotal?.discount <= footerTotal?.taxableAmount) {
                  if (
                    Utils.getNumber(Utils.getFormattedNumber(bankAccountAmt)) <=
                    Utils.getNumber(invoice.amountSummary?.totalInvoiceAmount)
                    // total Invoice Amount Already Formatted Number
                  ) {
                    if (
                      Utils.getNumber(footerTotal.amount) +
                        Utils.getNumber(footerLedger.ledgerTotalAmount) >
                      0
                    ) {
                      // cash voucher model not open
                      if (isCashVoucher) {
                        // Cash Only (Party Not Available) This time not delete payment method
                        if (!invoice?.isCashVoucher || updateInPartyId) {
                          const findDeletePaymentVouchar =
                            editInvBankDetails?.filter(
                              (x: any) =>
                                !(
                                  invoice?.bankDts?.some(
                                    (y: any) =>
                                      y?.editId === x?.editId && y.amount > 0
                                  ) && x.isDeleted === false
                                )
                            );

                          if (
                            findDeletePaymentVouchar != null &&
                            findDeletePaymentVouchar?.length > 0
                          ) {
                            setDeletePaymentDetails(findDeletePaymentVouchar);
                          }
                        }

                        try {
                          // setSaveButtonLoading(true);
                          isSaveAndNew
                            ? setSaveNewLoading(true)
                            : setUpdateAndNewButton(true);

                          const postData = {
                            ...invoice,
                            partyLedger:
                              invoice?.isCashVoucher &&
                              invoice?.partyLedger[0]?.partyOrTax !==
                                Party_Tax.party
                                ? invoice?.partyLedger
                                : new Array({
                                    ...invoice?.partyLedger[0],
                                    ref: updateId
                                      ? [
                                          {
                                            id: oldPartyRecepitDetails[0]?.id
                                              ?.value,
                                            name: invoice.number,
                                            refType: RefType.newRef,
                                            value: invoice?.bankAmount,
                                            // date: x?.date,
                                          },
                                        ]
                                      : [
                                          {
                                            id: null,
                                            name: invoice.number,
                                            refType: RefType.newRef,
                                            value: invoice?.bankAmount,
                                          },
                                        ],
                                  }),
                          };

                          await FixedAssetsServiceNew.postAsssetVoucher(
                            currentClient?.id!,
                            splitPathInVchType,
                            postData,
                            updateId
                            // config
                            // location?.state?.copy ? undefined : id
                          )
                            .then((res: any) => {
                              if (res?.status) {
                                console.log("res....", res);
                                sessionStorage.removeItem(
                                  `${currentClient?.id} Sales`
                                );
                                sessionStorage.removeItem("NotificationState");

                                openNotification(
                                  "success",
                                  ` ${
                                    splitPathInVchType ===
                                    Voucher_Type.SalesVoucher
                                      ? "Disposed Sales Invoice "
                                      : "Purchase Bill"
                                  }  ${res.result?.name} ${
                                    updateId
                                      ? " updated successfully."
                                      : " added successfully."
                                  }`
                                );
                                if (invoice?.bankDts?.length > 0) {
                                  setSaveInvoiceReferences(
                                    res.result?.references[0]
                                  );
                                } // first credit & user change to cash & not select party & deletePaymentDetails length > 0
                                else if (
                                  invoice?.bankDts?.length === 0 &&
                                  updateId &&
                                  invoice?.isCashVoucher &&
                                  invoice?.partyLedger[0]?.partyOrTax !==
                                    Party_Tax.party &&
                                  deletePaymentDetails.length > 0
                                ) {
                                  setTriggerDeletePaymentApi(true);
                                } else {
                                  onPostSuccess();
                                }
                              } else if (res?.message) {
                                openNotification("error", res?.message);
                                setLoading(false);
                              }
                            })
                            .catch((ex) => openNotification("error", ex));
                          setLoading(false);

                          // setSaveNewLoading(false);
                          // isSaveAndNew && seInitialRender(!initialRender);
                        } catch (err) {
                          console.error("error", err);
                          openNotification("error", err);
                        } finally {
                          setLoading(false);
                          // setSaveButtonLoading(false);
                          isSaveAndNew
                            ? setSaveNewLoading(false)
                            : setUpdateAndNewButton(false);
                        }
                      } else {
                        setOpenModel({
                          type: "addInvoiceReferenceModel",
                          param: {
                            open: true,
                          },
                        });
                      }
                    } else {
                      setSaveNewLoading(false);
                      openNotification(
                        "error",
                        "Selling price must be greater than 0"
                      );
                      setUpdateAndNewButton(false);
                      setLoading(false);
                    }
                  } else {
                    openNotification(
                      "error",
                      "Bank amount must be less than Total Invoice amount."
                    );
                    setLoading(false);
                  }
                } else {
                  openNotification(
                    "error",
                    "Discount must be less than selling price."
                  );
                  setLoading(false);

                  setUpdateAndNewButton(false);
                }
              }
            }
          } else {
            openNotification("error", "Please select atleast one item");
            setLoading(false);
          }
        } catch (ex) {
          ex && openNotification("error", ex);
          console.log("Error for ID:", ex);
          setLoading(false);
        } finally {
          setSaveNewLoading(false);
          setUpdateAndNewButton(false);
          setLoading(false);
        }
      } else {
        openNotification(
          "error",
          `${
            splitPathInVchType === Voucher_Type.SalesVoucher
              ? "Disposed Sales Invoice "
              : "Purchase Bill "
          } amount must be greater than zero`
        );
        setLoading(false);
      }
    });
  };

  // Post(add) payment api
  useEffect(() => {
    const paymentAdd = async () => {
      let index = 0;
      setLoading(true);
      try {
        let postSucessData = {};
        for (const x of currentInvoiceDetails?.bankDts || []) {
          // console.log("date x.............", x, index);
          let selVoucherTemplate =
            companySettings?.setting?.vouchersSettings?.find(
              (vchTemp: vouchersSettings) =>
                vchTemp.settingType ===
                (splitPathInVchType === Voucher_Type.SalesVoucher
                  ? SettingsSections.Receipt
                  : SettingsSections.Payment)
            );
          const data = {
            voucherTitle: {
              id: selVoucherTemplate?.id,
              name: selVoucherTemplate?.title,
            },
            amountSummary: {
              totalInvoiceAmount: x?.amount,
              roundOff: { roundOffApplicable: false, roundOffAmount: 0 },
            },
            editId: x?.editId,
            instantPayment: true,
            amount: x?.amount,
            payRecReference: x?.payRecReference,
            effectiveLedger: [
              {
                id: x?.name?.value,
                amount: x?.amount,
                partyOrTax: x?.name?.title,
              },
            ],
            isReconciled: x?.editId
              ? x?.isReconciled
              : location.state?.ledgerId && !index
              ? ReconciledFilter.reconciled
              : ReconciledFilter.nonreconciled,
            bankImportEntryRef: x?.editId
              ? x.bankImportEntryRef
              : location.state?.ledgerId && !index
              ? location.state?.bankEntriesId
              : "",
            date: currentInvoiceDetails.date,
            isLocked: false,
            isAudited: false,
            isActive: true,
            partyLedger: [
              {
                id: currentInvoiceDetails?.partyLedger[0]?.id,
                amount: x?.amount,
                partyOrTax: Party_Tax.party,
                value: x?.amount,
                ref: [
                  {
                    refType: RefType.AgnstRef,
                    value: x?.amount,
                    name: saveInvoiceReferences?.name,
                    id: x?.partyRefId,
                    parentRef: saveInvoiceReferences?.id,
                  },
                ],
              },
            ],
          };

          if (data.amount > 0 && data.effectiveLedger[0]?.id) {
            try {
              const res = await VoucherServices.postVoucher(
                currentClient?.id!,
                splitPathInVchType === Voucher_Type.SalesVoucher
                  ? Voucher_Type.Receipt
                  : Voucher_Type.Payment,
                data,
                // props.
                data?.editId
              );
              if (res.result) {
                if (index === 0) {
                  postSucessData = {
                    id: res.result?.id,
                    name: res.result?.name,
                    voucherType: res.result?.voucherType,
                  };
                }
                openNotification(
                  "success",
                  `Payment ${res.result?.name} ${
                    data?.editId
                      ? "updated successfully."
                      : "added successfully."
                  }`
                );
              } else if (res.message) {
                openNotification("error", res.message);
              }
              index++;
            } catch (ex: any) {
              openNotification("error", ex.message);
              console.log("Error for ID:", x?.id, ex);
            }
          }
        }
        if (deletePaymentDetails?.length > 0) {
          setIsDeletePaymentApi(true);
        } else {
          onPostSuccess(postSucessData);
        }
      } catch (ex: any) {
        openNotification("error", ex.message);
        console.log("Error for ID:", ex);
      } finally {
        // setSaveButtonLoading(false);
        isSaveAndNew ? setSaveNewLoading(false) : setUpdateAndNewButton(false);
        setLoading(false);
      }
    };

    if (
      saveInvoiceReferences?.id &&
      currentInvoiceDetails?.bankDts[0]?.name?.value
    ) {
      // setSaveButtonLoading(true);
      setLoading(true);
      isSaveAndNew ? setSaveNewLoading(true) : setUpdateAndNewButton(true);
      paymentAdd();
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [saveInvoiceReferences, currentInvoiceDetails]);

  // delete payment api
  useEffect(() => {
    // console.log("deleteCreditNote.id", deletePaymentIn?.id);
    const deletePaymentVoucher = async () => {
      try {
        // setSaveButtonLoading(true);
        setLoading(true);
        isSaveAndNew ? setSaveNewLoading(true) : setUpdateAndNewButton(true);
        for (const x of deletePaymentDetails) {
          if (x?.editId) {
            await VoucherServices.deleteVoucher(currentClient?.id!, x?.editId)
              .then((res) => {
                if (res?.result) {
                  openNotification(
                    "success",
                    `Voucher ${x?.paymentNumber} deleted successfully.`
                  );
                }
              })
              .catch((err) => {
                openNotification("error", err.message);
              });
          }
        }
        onPostSuccess();
      } catch (err: any) {
        console.error("error", err);
      } finally {
        // setSaveButtonLoading(false);
        setLoading(false);

        isSaveAndNew ? setSaveNewLoading(false) : setUpdateAndNewButton(false);
      }
    };

    if (isDeletePaymentApi || triggerDeletePaymentApi) {
      deletePaymentVoucher();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isDeletePaymentApi, triggerDeletePaymentApi]);

  const onPostSuccess = (afterSave?: any) => {
    // import transaction save voucher
    if (location.state?.ledgerId) {
      navigate(
        `/books/clients/${currentClient?.id}/banking/bankTransactionsDetails/${location.state?.bankEntriesId}`,
        {
          state: {
            ledgerId: location.state?.ledgerId,
            bankImportIndex: location.state?.bankImportIndex,
            voucherRef: [afterSave],
          },
        }
      );
    }
    // Save & New - Update & New
    else if (isSaveAndNew) {
      form.resetFields();
      setFooterLedger({
        ledgerAmount: 0,
        ledgerGstAmount: 0,
        ledgerTotalAmount: 0,
      });
      setBankAccountAmt(0);
      form.setFieldValue("dueDate", dayjs(dateFiled).add(dueOnSetting, "d"));
      setRefreshNumber(!refreshNumber);
      setItemLength(0);
    } else {
      navigate(-1);
    }
  };

  // Post Draft
  const saveDrift = async () => {
    try {
      const val = form.getFieldsValue();
      console.log("post Deaft Date: " + val);

      const freightInsLedgers = val?.freightInsLedgers?.map((exp: any) => {
        return {
          ...exp,
          id: exp?.id?.value,
          gstRate: {
            id: exp?.gstRate?.value,
            rate: exp?.gstRate?.title,
            name: exp?.gstRate?.label,
          },
        };
      });

      const partyLedger = new Array({
        id: val?.partyLedger?.value,
        PartyOrTax: Party_Tax.party,
        amount:
          Utils.getNumber(footerTotal.amount) +
          Utils.getNumber(footerLedger.ledgerTotalAmount) -
          cashDiscountRs +
          roundOffAmount,
        transactionId:
          transactionId.partyId === "" ? null : transactionId.partyId,
      });

      const effectiveLedger = new Array({
        id: val?.effectiveLedger?.value,
        PartyOrTax: Party_Tax.other,
        amount:
          Utils.getNumber(footerTotal.taxableAmount) - footerTotal.discount,
        transactionId:
          transactionId.partyId === "" ? null : transactionId.partyId,
      });

      const items = val?.items?.map((itm: any) => {
        return {
          ...itm,
          amount: {
            ...itm?.amount,
            unit: {
              id: itm.amount?.unit?.value,
              name: itm.amount?.unit?.label,
              unitType: itm?.amount?.unit?.unitType,
            },
            grossAmount: Utils.getNumber(itm?.amount?.price),
            // * itm?.amount?.qty,
            tax: {
              id: itm?.amount?.tax?.value,
              rate: itm?.amount?.tax?.title,
              name: itm?.amount?.tax?.label,
            },
          },
        };
      });

      const instantPayLedgersDetails = val?.bankDts?.map((itm: any) => {
        return {
          ledgerId: itm.name?.value,
          ledgerName: itm.name?.label,
          payRecReference: itm?.payRecReference,
          amount: itm?.amount,
        };
      });

      const adjustDateToCurrentTime = (date: any) => {
        const currentTime = new Date();
        // Set the time part of the date to match the current time
        date.setHours(
          currentTime.getHours(),
          currentTime.getMinutes(),
          currentTime.getSeconds(),
          currentTime.getMilliseconds()
        );

        return date;
      };

      let adjustedGivenDate = adjustDateToCurrentTime(new Date(val.date));
      let adjustedDueGivenDate = adjustDateToCurrentTime(new Date(val.dueDate));
      let supplierInvoiceDate = val?.supplierInvoiceDate;

      if (updateId) {
        adjustedGivenDate = dayjs(val.date).isSame(dayjs(editDate), "day")
          ? editDate
          : adjustedGivenDate;

        adjustedDueGivenDate = dayjs(val.dueDate).isSame(
          dayjs(editDueDate),
          "day"
        )
          ? editDueDate
          : adjustedDueGivenDate;
      }

      const draftData = {
        ...val,
        voucherTitle: {
          id: selectCustomizationTemplete.templateId,
          name: selectCustomizationTemplete.title,
        },
        items: items,
        underLUT: underLUT,
        tcsApplicable: tdsOrTcs === 1 ? true : false,
        billingAddress: {
          ...val?.billingAddress,
          type: val?.billingAddress?.title,
          addressName: val?.billingAddress?.value,
        },
        shippingAddress: {
          ...val?.shippingAddress,
          type: val?.shippingAddress?.title,
          addressName: val?.shippingAddress?.value,
        },
        tcsDetail: tdsOrTcs
          ? {
              id: val?.tcsDetail?.value,
              name: val?.tcsDetail?.label,
              rate: val?.tcsDetail?.title,
              value: totalTcs,
            }
          : null,
        tdsApplicable: tdsOrTcs ? false : true,
        tdsDetail: tdsOrTcs
          ? null
          : {
              id: val?.tdsDetail?.value,
              name: val?.tdsDetail?.label,
              rate: val?.tdsDetail?.title,
              value: totalTds,
              transactionType: tdsPostDetail.transactionType,
              form: tdsPostDetail.formNo,
            },
        isPurchaseJVVoucher: mode,
        nature: voucherNature,
        isShippingAddressSame: isSameBillingAddress,
        isGSTVoucher:
          partyIsGstRegistered === CompanyGSTTypes.Regular &&
          (currentClient?.gstType === CompanyGSTTypes.Regular ||
            updateTimeData.isGSTVoucher),
        showItemDescription:
          settingControl.showItemDescription ||
          updateTimeData.showItemDescription,
        instantPayLedgersDetails: instantPayLedgersDetails,
        bankAmount: bankAccountAmt,
        instantPayment: bankAccountAmt > 0 ? true : false,
        purchaseOrderRef: {
          id: val?.purchaseOrderRef?.value,
          date: purchaseOrderDate && dayjs(purchaseOrderDate).toISOString(),
        },
        date: dayjs(adjustedGivenDate).toISOString(),
        dueDate: dayjs(adjustedDueGivenDate).toISOString(),
        supplierInvoiceDate: supplierInvoiceDate
          ? dayjs(supplierInvoiceDate).toISOString()
          : null,
        freightInsLedgers,
        partyLedger,
        effectiveLedger,
        despatchDetail: invoiceDespatchDetails,
        exportDetail: invoiceExportDetails,

        isStateSame: isStateSame,
        billState: currentCustomerState,
        amountSummary: {
          tCSRate: val?.tcsDetail?.title,
          tCSAmt: totalTcs,
          tDSRate: val?.tdsDetail?.title,
          tDSAmt: totalTds,
          totalQty: footerTotal?.qty,
          taxableAmount:
            Utils.getNumber(footerTotal?.taxableAmount) - footerTotal?.discount, // befor gst
          totalDis: footerTotal?.discount,
          freightAmount: 0,
          cessAmount: 0,
          igstAmt: !isStateSame
            ? footerTotal?.gst + footerLedger.ledgerGstAmount
            : 0,
          cgstAmt: isStateSame
            ? (footerTotal?.gst + footerLedger.ledgerGstAmount) / 2
            : 0,
          sgstAmt: isStateSame
            ? (footerTotal?.gst + footerLedger.ledgerGstAmount) / 2
            : 0,
          // roundOffAmount: roundOffAmount,
          roundOff: {
            roundOffApplicable: val?.roundoffCheckbox,
            roundOffAmount: roundOffAmount,
          },
          cashDiscount: {
            discountRate:
              val.cashDiscountDrop === DiscountType.PercentageDiscount
                ? val.cashDiscount ?? 0
                : 0,
            discountAmount: cashDiscountRs,
          },
          totalInvoiceAmount:
            Utils.getNumber(footerTotal.amount) +
            Utils.getNumber(footerLedger.ledgerTotalAmount) +
            roundOffAmount -
            cashDiscountRs +
            totalTcs -
            totalTds,
          receivedAmount: 0,
          voucherAmountWithoutTCS:
            Utils.getNumber(footerTotal.amount) +
            Utils.getNumber(footerLedger.ledgerTotalAmount) -
            balance,
        },
      };

      const saveDraftData = await DraftService.postVoucherDraft(
        currentClient?.id!,
        splitPathInVchType === Voucher_Type.SalesVoucher
          ? Voucher_Type.SalesVoucher
          : Voucher_Type.PurchaseVoucher,
        draftData,
        draftId
      );

      if (saveDraftData.result) {
        openNotification(
          "success",
          `Draft ${draftId ? "updated successfully." : "added successfully."}`
        );
      } else if (saveDraftData.message) {
        openNotification("error", saveDraftData?.message);
      }
    } catch (ex: any) {
      openNotification("error", ex);
    }
  };

  EntryLevelKeys({
    save: () => addSalesInvoice(),
    cancel: () => navigate(-1),
    saveAndNew: () => addSalesInvoice(),
  });

  // useHotkeys("shift+b", () => alert("Callback got executed"), {
  //   enabled: (event, hotkeysEvent) => {
  //     return true;
  //   },
  // });
  // useHotkeys("crtl+s", () => alert("We saved your progress!"), {
  //   // enabled: () => false,
  //   preventDefault: true,
  // });
  // useKeyboardShortcuts("s", ["altKey"], () => addSalesInvoice());

  //-------- Get All Item List-----------
  useEffect(() => {
    const items = async () => {
      setItemDropDownLoading(true);
      await FixedAssetsServiceNew.getAssetsItemList(
        currentClient?.id!,
        undefined,
        undefined,
        searchItem,
        AssetStatus_New.Active,
        splitPathInVchType
      )
        .then((res) => {
          console.log("response", res);
          setItemDropDownLoading(false);
          setItemsOption(res);
          SetCheckIsItemApiCall(true);
        })
        .catch((err) => {
          console.log("error", err);
          SetCheckIsItemApiCall(true);
        });
    };
    items();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    currentClient?.id,
    searchItem,
    loadItemAPI,
    splitPathInVchType,
    barCodeSearch,
  ]);

  // ----- Serch customer Api -----
  useEffect(() => {
    const customer = async () => {
      setPartyDropDownLoading(true);

      setLoading(true);
      inputRef.current?.focus();
      await LedgerService.getLedgersByGroupName(
        currentClient?.id!,
        SearchLedgerByGroupsTypes.PartiesOnly
      )
        .then((res: any) => {
          if (res) {
            // form.setFieldValue("date", dayjs());
            // form.setFieldValue("dueDate", dayjs().add(7, "d"));

            // form.setFieldValue(
            //   "dueDate",
            //   dayjs().add(
            //     companySettings?.setting?.dueOn?.duration
            //       ? companySettings?.setting?.dueOn?.duration
            //       : 0,
            //     companySettings?.setting?.dueOn?.durationUnit === TimeUnits.Day
            //       ? "d"
            //       : companySettings?.setting?.dueOn?.durationUnit ===
            //         TimeUnits.Week
            //       ? "w"
            //       : companySettings?.setting?.dueOn?.durationUnit ===
            //         TimeUnits.Month
            //       ? "month"
            //       : "y"
            //   )
            // );
            setOnlyEditTimeCustomerOptions(true);
            setCustomerOptions(res);
            setPartyDropDownLoading(false);
            SetCheckIsPartyApiCall(true);
            // console.log(customerOptions, "getledger");
          }
          setLoading(false);
        })
        .catch((ex: any) => {
          console.error("error", ex);
          // setLoading(false);
          setPartyDropDownLoading(false);
        });
    };
    customer();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentClient?.id]);

  // ----- Serch effectiveLedger Api ------
  // useEffect(() => {
  //   const ledger = async () => {
  //     setLedgerDropDownLoading(true);

  //     await LedgerService.getLedgersByGroupName(
  //       currentClient?.id!,
  //       splitPathInVchType === Voucher_Type.SalesVoucher
  //         ? SearchLedgerByGroupsTypes.Sales
  //         : SearchLedgerByGroupsTypes.Purchase
  //     )
  //       .then((res: any) => {
  //         if (res) {
  //           // console.log(res.result, "partyname");
  //           setEffectiveLedger(res);
  //           setLedgerDropDownLoading(false);
  //         }
  //       })
  //       .catch((ex: any) => {
  //         console.error(ex);
  //         setLedgerDropDownLoading(false);
  //       });
  //   };
  //   ledger();
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [currentClient?.id, trigger, splitPathInVchType]);
  useEffect(() => {
    debugger;
    if (addLedgerResponse?.id) {
      console.log("addLedgerResponse", addLedgerResponse);
      let newSupplierData = Utils.getNewlyAddedLedgerData(addLedgerResponse);
      if (apiCallField === "New Supplier") {
        if (!addLedgerResponse.isEdited) {
          setCustomerOptions((pre: any) => {
            const newData = [...pre, newSupplierData];
            return newData;
          });
        } else {
          setCustomerOptions((pre: any) =>
            updateListWithNewValue(pre, newSupplierData, false)
          );
        }
      } else if (apiCallField === "New Bank") {
        setBankAccountList((pre) => {
          const newData = [...pre, newSupplierData];
          return newData;
        });
        setSelectedBankLedger((prevState) => {
          const updatedSelectedOptions = [...prevState];
          updatedSelectedOptions[newBankAccountAddedIndex!] =
            addLedgerResponse?.id;
          return updatedSelectedOptions;
        });

        setSelectedBankPartyOrTax((prevState) => {
          const updatedSelectedOptions = [...prevState];
          updatedSelectedOptions[newBankAccountAddedIndex!] =
            addLedgerResponse?.partyOrTax!;
          return updatedSelectedOptions;
        });
        setSelectedBankBalance((x: any) => {
          const updatedSelectedOptions = [...x];
          updatedSelectedOptions[newBankAccountAddedIndex!] = 0.0;
          return updatedSelectedOptions;
        });
      }
    }
  }, [addLedgerResponse]);
  //----------set Newly added data in Bank Account List ----------
  useEffect(() => {
    if (addLedgerResponse?.id) {
      debugger;
      let exist = bankAccountList.some((e) => e.id === addLedgerResponse?.id);
      let preData = [...form.getFieldValue("bankDts")];
      if (exist) {
        if (newBankAccountAddedIndex === 0) {
          preData[0] = {
            name: {
              key: addLedgerResponse?.id,
              value: addLedgerResponse?.id,
              label: addLedgerResponse?.ledgerName,
              title: "",
            },
            payRecReference: "",
            amount: 0.0,
          };
          let BankDetails = form.getFieldValue(["bankDts", 0, "name"]);
          !BankDetails &&
            preData.push({
              name: {
                key: "",
                value: "",
                label: "",
                title: "",
              },
              pyaRecReference: "",
              amount: 0.0,
            });
        } else {
          preData[1] = {
            name: {
              key: addLedgerResponse?.id,
              value: addLedgerResponse?.id,
              label: addLedgerResponse?.ledgerName,
              title: "",
            },
            payRecReference: "",
            amount: 0.0,
          };
        }
        form.setFieldValue("bankDts", preData);
      }
      setAddLedgerResponse(null);
    }
  }, [bankAccountList]);
  //------- Set partner Data After Adding ledger ------
  useEffect(() => {
    if (addLedgerResponse) {
      const exists = customerOptions.some(
        (option) => option.id === addLedgerResponse.id
      );
      if (exists) {
        form.setFieldValue("partyLedger", {
          key: addLedgerResponse?.id,
          value: addLedgerResponse?.id,
          label: addLedgerResponse?.ledgerName,
        });
        CustomerSelect(addLedgerResponse?.id);
        setAddLedgerResponse(null);
        setLoading(false);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [customerOptions]);

  //------- Set other expense Data After Adding ledger ------
  useEffect(() => {
    try {
      if (addLedgerResponse) {
        const exists = freightAndInsuranceOptions.some(
          (option: any) => option.id === addLedgerResponse.id
        );
        if (exists) {
          let freightInsLedgers = [
            ...(form.getFieldValue("freightInsLedgers") || []),
          ];
          freightInsLedgers.pop();
          freightInsLedgers.push({
            // gstRate: 0,
            gstAmount: 0,
            totalAmount: 0,
            id: {
              label: addLedgerResponse?.ledgerName,
              value: addLedgerResponse.id,
              key: addLedgerResponse.id,
            },
          });
          freightInsLedgers.push({
            // gstRate: 0,
            gstAmount: 0,
            totalAmount: 0,
            id: {
              label: "",
              value: "",
              key: "",
            },
          });
          const index = freightInsLedgers.findIndex(
            (ledgerArray) => ledgerArray?.id?.value === addLedgerResponse.id
          );
          form.setFieldValue("freightInsLedgers", freightInsLedgers);
          freightInsLedgersSelect(addLedgerResponse.id, index);
          setAddLedgerResponse(null);
        }
      }
    } catch (error) {
      console.log("error", error);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [freightAndInsuranceOptions]);

  // //------- Set sales ledger Data After Adding ledger ------
  // useEffect(() => {
  //   if (addLedgerResponse) {
  //     const exists = effectiveLedger.some(
  //       (option) => option.id === addLedgerResponse.id
  //     );
  //     if (exists) {
  //       form.setFieldValue("effectiveLedger", {
  //         ...form.getFieldValue("effectiveLedger"),
  //         key: addLedgerResponse?.id,
  //         value: addLedgerResponse?.id,
  //         label: addLedgerResponse?.ledgerName,
  //       });
  //       setAddLedgerResponse(null);
  //     }
  //   }
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [effectiveLedger]);

  //----- Bank (ledger) Account Get Api -----
  useEffect(() => {
    // if (settingControl?.showReceipt || editInvBankDetails?.length > 0) {
    setbankAccountDropDownLoading(true);
    const bankLedger = async () => {
      await LedgerService.getLedgersByGroupName(
        currentClient?.id!,
        SearchLedgerByGroupsTypes.BankAndCash
      )
        .then((res: any) => {
          if (res) {
            console.log("data..1111.", res);
            setBankAccountList(res);
            setbankAccountDropDownLoading(false);
            SetCheckIsBankApiCall(true);
          }
        })
        .catch((ex: any) => {
          // setBankLoading(false);
          setBankAccountList([]);
          setbankAccountDropDownLoading(false);
        });
    };
    bankLedger();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    // }
  }, [currentClient]);

  const handleDeleteRowButton = () => {
    handleItemsNetAmmount(0);
    setConfirmation(false);
  };

  useEffect(() => {
    // update invoice time Customer address set
    if ((updateId || cloneId) && selectedParty && onlyEditTimeCustomerOptions) {
      setOnlyEditTimeCustomerOptions(false);
      CustomerSelect(selectedParty, onlyEditTimeCustomerOptions);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [customerOptions, selectedParty]);

  // Customer select
  const CustomerSelect: any = async (
    value: string,
    onlyFirstEdit: boolean = false
  ) => {
    purchaseOrderRef && form.setFieldValue("purchaseOrderRef", "");
    console.log("customerAddress CustomerSelect", value, onlyFirstEdit);

    if (value) {
      let findCutomerDetails = customerOptions.find(
        (Ledgerlist: any) => Ledgerlist?.id === value
      );

      if (!onlyFirstEdit) {
        if (findCutomerDetails?.payTerms?.creditPeriod > 0) {
          form.setFieldValue(
            "dueDate",
            dayjs(dateFiled).add(
              findCutomerDetails?.payTerms?.creditPeriod,
              "d"
            )
          );
          setDueOnParty(findCutomerDetails?.payTerms?.creditPeriod);
        } else {
          form.setFieldValue(
            "dueDate",
            dayjs(dateFiled).add(dueOnSetting, "d")
          );
          setDueOnParty(0);
        }
        if (splitPathInVchType === Voucher_Type.SalesVoucher) {
          // TypeOfAddress.RegisteredAddress,
          if (findCutomerDetails?.addresses) {
            customerAddSelect(
              findCutomerDetails?.addresses[0]?.addressName,
              findCutomerDetails?.addresses[0]?.type,
              AddressEnum.BillingAddress,
              findCutomerDetails?.addresses
            );
          } else if (
            findCutomerDetails?.partyType === PartyType.IndividualPerson
          ) {
            form.setFieldValue(["billingAddress", "address"], "");
            // form.setFieldValue(["billingAddress", "type"], {});
            form.setFieldValue(
              "supplyState",
              findCutomerDetails?.state !== 0
                ? findCutomerDetails?.state
                : currentCustomerState
            );
          } else {
            form.setFieldValue(["billingAddress", "address"], "");
            form.setFieldValue(["billingAddress", "type"], {});
            form.setFieldValue(
              "supplyState",
              findCutomerDetails?.state !== 0
                ? findCutomerDetails?.state
                : currentCustomerState
            );
          }

          // setCustomerAddress(findCutomerDetails?.addresses);
        } else {
          setPurchasePartyState(findCutomerDetails?.state);
          form.setFieldValue(
            "supplyState",
            findCutomerDetails?.state !== 0
              ? findCutomerDetails?.state
              : undefined
          );
          form.validateFields(["supplyState"]);
        }
      }
      setEditParty({ id: value });
      setIsPartyCompany(findCutomerDetails.partyType);
      setSelectedParty(value);

      const gstType = partyIsGstType(
        splitPathInVchType,
        findCutomerDetails?.gstType,
        partyIsGstRegistered,
        partyIsGstRegisteredSalesInvoice
      );
      switch (findCutomerDetails?.gstType) {
        case CompanyGSTTypes.DeemedExportImport:
          setVoucherNature(Voucher_Nature.DeemedExport);
          break;
        case CompanyGSTTypes.Overseas:
          setVoucherNature(Voucher_Nature.ImportExport);
          break;
        case CompanyGSTTypes.SEZ:
          setVoucherNature(Voucher_Nature.SEZ);
          break;
        default:
          voucherNature !== Voucher_Nature.RCM &&
            setVoucherNature(Voucher_Nature.Regular);
          break;
      }
      if (splitPathInVchType === Voucher_Type.SalesVoucher) {
        setCustomerAddress(findCutomerDetails?.addresses);
        // setPurchasePartyState(findCutomerDetails?.state);
        setPartyIsGstRegisteredSalesInvoice(findCutomerDetails?.gstType);
      }
      if (gstType !== null && gstType !== undefined) {
        if (splitPathInVchType === Voucher_Type.PurchaseVoucher) {
          setPartyIsGstRegistered(gstType);
          setPartyIsGstRegisteredTrigger((x) => x + 1);
        } else {
          setPartyIsGstRegisteredSalesInvoiceTrigger((x) => x + 1);
        }
      }
      // get party ref (payment invoice no.)
      // await VoucherServices.getReferencesByParty(
      //   currentClient?.id!,
      //   value,
      //   splitPathInVchType === Voucher_Type.SalesVoucher
      //     ? Voucher_Type.SalesVoucher
      //     : Voucher_Type.PurchaseVoucher
      // )
      //   .then((res: any) => {
      //     console.log(res);
      //     if (res) {
      //       // console.log("res............", res);
      //       setNewPartyRecepitDetails(
      //         res?.result?.map((x: any, index: number) => {
      //           return {
      //             key: index,
      //             // date: dayjs(x?.date),
      //             id: x?.id,
      //             refNo: x?.refNo,
      //             dueAmount: x?.dueAmount,
      //           };
      //         })
      //       );
      //     }
      //   })
      //   .catch((ex: any) => {
      //     console.log(ex.message);
      //   });
      // setOrderDropDownLoading(true);
      // //  get api order(sales & purchase order) number list
      // await QuotationServices.getOrderNumber(
      //   currentClient?.id!,
      //   splitPathInVchType,
      //   value
      // )
      //   .then((res: any) => {
      //     if (res) {
      //       setOrderListOptions(res?.result);
      //       setOrderDropDownLoading(false);

      //       // console.log("res.result QuotationServices......", res);
      //     } else {
      //       console.error(res?.error);
      //       setOrderDropDownLoading(false);
      //     }
      //   })
      //   .catch((err: any) => console.error(err?.message));
    }
  };

  // onChange in address type
  const customerAddSelect: any = (
    typeOfAddressName: string,
    typeOfAddress: TypeOfAddress,
    addressEnum: AddressEnum,
    addressTotal: any[]
  ) => {
    if (typeOfAddressName) {
      let findAddress: any;
      if (addressTotal?.length > 0) {
        findAddress = addressTotal?.find(
          (type: any) => type?.addressName === typeOfAddressName
        );
      } else if (customerAddress?.length > 0) {
        findAddress = customerAddress?.find(
          (type: any) => type?.addressName === typeOfAddressName
        );
      }
      // console.log("Hello findAddress", findAddress);

      if (findAddress?.address) {
        // console.log("findAddress.....", findAddress?.address);
        // const objectofaddress1: any[] = [];
        const countryLength = findAddress?.address?.country?.length === 2;
        var country: any;
        if (countryLength) {
          country = allCountriesStates?.find(
            (x) => x.iso2 === findAddress?.address?.country
          );
          console.log("partyGstType", country);
        }

        let objectofaddress1: string = "";
        Object.keys(findAddress?.address).forEach((key: any) => {
          // console.log("key...........", key);
          switch (key) {
            case "building":
              if (findAddress?.address[key])
                objectofaddress1 += findAddress?.address[key] + ", ";
              break;
            case "street":
              if (findAddress?.address[key])
                objectofaddress1 += findAddress?.address[key] + ", " + "\n";
              else if (findAddress?.address[key] === "building")
                objectofaddress1 += "\n";
              break;
            case "landmark":
              if (findAddress?.address[key])
                objectofaddress1 += findAddress?.address[key] + ", ";
              break;
            case "city":
              if (findAddress?.address[key])
                objectofaddress1 += findAddress?.address[key] + ", " + "\n";
              else if (findAddress?.address[key] === "landmark")
                objectofaddress1 += "\n";
              break;
            case "district":
              if (findAddress?.address[key])
                objectofaddress1 += findAddress?.address[key] + ", ";
              break;
            case "pincode":
              if (findAddress?.address[key])
                objectofaddress1 += findAddress?.address[key] + ", " + "\n";
              else if (findAddress?.address[key] === "district")
                objectofaddress1 += "\n";
              break;
            case "overseasState":
              if (countryLength && country?.states?.length > 0) {
                const matchedState = country?.states?.find(
                  (x: any) => x.id === findAddress?.address?.overseasState
                );
                objectofaddress1 += matchedState?.name + ", ";
              }
              break;
            case "state":
              if (!countryLength && findAddress?.address[key]) {
                objectofaddress1 +=
                  getIndianStates(findAddress?.address[key]) + ", ";
              }

              if (splitPathInVchType === Voucher_Type.PurchaseVoucher) {
                if (findAddress?.address[key]) {
                  setCurrentCustomerState(findAddress?.address[key]);
                } else {
                  setCurrentCustomerState(currentClient?.state!);
                }
              } else {
                setPurchasePartyState(findAddress?.address[key]);
                if (
                  addressEnum === AddressEnum.BillingAddress &&
                  splitPathInVchType === Voucher_Type.SalesVoucher
                ) {
                  form.setFieldValue(
                    "supplyState",
                    findAddress?.address[key] !== 0
                      ? findAddress?.address[key]
                      : undefined
                  );
                  form.validateFields(["supplyState"]);
                }
              }

              break;
            case "country":
              if (countryLength) {
                objectofaddress1 += country?.name;
              } else if (findAddress?.address[key])
                objectofaddress1 += findAddress?.address[key];
              break;
            default:
              if (findAddress?.address[key])
                objectofaddress1 += findAddress?.address[key] + ", ";
          }
        });
        if (addressEnum === AddressEnum.BillingAddress) {
          form.setFieldValue(["billingAddress", "address"], objectofaddress1);
          form.setFieldValue(["billingAddress", "type"], {
            value: typeOfAddressName,
            label: typeOfAddressName,
            title: typeOfAddress,
          });
          if (objectofaddress1) {
            form.validateFields([["billingAddress", "address"]]);
          }
          if (isSameBillingAddress) {
            form.setFieldValue(
              ["shippingAddress", "address"],
              objectofaddress1
            );
            form.setFieldValue(["shippingAddress", "type"], {
              value: typeOfAddressName,
              label: typeOfAddressName,
              title: typeOfAddress,
            });
          }
        } else {
          form.setFieldValue(["shippingAddress", "address"], objectofaddress1);
          form.setFieldValue(["shippingAddress", "type"], {
            value: typeOfAddressName,
            label: typeOfAddressName,
            title: typeOfAddress,
          });
        }
      } else {
        if (addressEnum === AddressEnum.BillingAddress) {
          form.setFieldValue(["billingAddress", "address"], "");
          form.setFieldValue(["billingAddress", "type"], {
            value: typeOfAddressName,
            label: typeOfAddressName,
            title: typeOfAddress,
          });
          if (isSameBillingAddress) {
            form.setFieldValue(["shippingAddress", "address"], "");
            form.setFieldValue(["shippingAddress", "type"], {
              value: typeOfAddressName,
              label: typeOfAddressName,
              title: typeOfAddress,
            });
          }
        } else {
          form.setFieldValue(["shippingAddress", "address"], "");
          form.setFieldValue(["shippingAddress", "type"], {
            value: typeOfAddressName,
            label: typeOfAddressName,
            title: typeOfAddress,
          });
        }
        // Needs to check
        if (splitPathInVchType === Voucher_Type.PurchaseVoucher) {
          setCurrentCustomerState(-1);
        }
      }
    } else {
      form.setFieldValue(["billingAddress", "address"], "");
      form.setFieldValue(["billingAddress", "type"], {});
    }
  };

  // select in Items
  const itemSelect: any = async (value: string, index: number) => {
    // debugger
    setItemLength(index + 1);
    const selectedItem = itemsOption?.find((Item: any) => Item?.id === value);

    if (selectedItem) {
      form.setFieldValue(["items", index], {
        isTaxable: selectedItem?.isTaxable,
        id: {
          value: selectedItem?.id,
          label: selectedItem?.assetName,
        },
        description: selectedItem?.description,
        hsnsac: selectedItem?.hsnCode ?? selectedItem?.sacCode,
        trackingType: selectedItem?.trackingType,
        itcEligibilityType:
          splitPathInVchType === Voucher_Type.PurchaseVoucher
            ? ITCEligibility_Type.Available
            : null,
        allAssetInvDetail: selectedItem?.assetInvDetail,
        amount: {
          // discount: form.getFieldValue("discount"),
          qty:
            selectedItem?.trackingType === Item_Nature.Batch ||
            selectedItem?.trackingType === Item_Nature.Serial
              ? 0
              : 0,
          unit: {
            value: selectedItem?.unit?.id,
            label: selectedItem?.unit?.shortName,
            // shortName: selectedItem?.unit?.name,
            unitType: selectedItem?.unit?.unitType,
          },
          price: 0,
          // discount:
          //   (settingControl.discountPolicy ===
          //     Discount_Policy.TradenCashDiscount ||
          //     settingControl.discountPolicy ===
          //       Discount_Policy.OnlyTradeDiscount ||
          //     updateTimeData.tradeDiscount) &&
          //   !mode
          //     ? selectedItem?.discountSalesType === DiscountSalesType.Percentage
          //       ? selectedItem?.discountSalesPrice
          //       : (selectedItem?.discountSalesPrice /
          //           (selectedItem?.isTaxable
          //             ? (selectedItem?.price /
          //                 (100 + selectedItem?.taxRate.rate)) *
          //               100
          //             : selectedItem?.price)) *
          //         100
          //     : 0,
          hideTax:
            currentClient?.gstType === CompanyGSTTypes.Regular ||
            updateTimeData.isGSTVoucher ||
            splitPathInVchType === Voucher_Type.PurchaseVoucher
              ? {
                  value: selectedItem?.taxRate?.id,
                  label: selectedItem?.taxRate?.name,
                  title: selectedItem?.taxRate?.rate,
                }
              : null,
          tax:
            splitPathInVchType === Voucher_Type.PurchaseVoucher
              ? (partyIsGstRegistered === CompanyGSTTypes.Regular ||
                  updateTimeData.isGSTVoucher) && {
                  value: selectedItem?.taxRate?.id,
                  label: selectedItem?.taxRate?.name,
                  title: selectedItem?.taxRate?.rate,
                }
              : // partyIsGstRegisteredSalesInvoice === CompanyGSTTypes.Overseas
              // ? {
              //     value: findGstRate?.id,
              //     label: findGstRate?.name,
              //     title: findGstRate?.rate,
              //   }
              // :
              currentClient?.gstType === CompanyGSTTypes.Regular ||
                updateTimeData.isGSTVoucher
              ? {
                  value: selectedItem?.taxRate?.id,
                  label: selectedItem?.taxRate?.name,
                  title: selectedItem?.taxRate?.rate,
                }
              : null,
        },
        otherDetails: {
          depRate: selectedItem?.depRate ?? 0,
          depMethod: selectedItem?.depMethod,
          accumulatedDepreciation: selectedItem?.accumulatedDepreciation,
          lifeCycleDuration: selectedItem?.lifeCycleDuration,
          isDepreciable: selectedItem?.isDepreciable,
        },
      });
      // handleItemsNetAmmount(index);
      setItemSearch("");
      setBarCodeSearch("");

      setSelectAssetItem((prevState) => {
        const updatedSelectedOptions = [...prevState];
        updatedSelectedOptions[index] = selectedItem?.id;
        return updatedSelectedOptions;
      });

      setOpenModel({
        type:
          selectedItem?.serialItem?.length > 0
            ? "serialNo"
            : selectedItem?.batchItem?.length > 0
            ? "batchItem"
            : "normalAssetItem",
        param: {
          open: true,
          index: index,
        },
      });
    }
  };

  // console.log("ItemSelect", ItemSelect);

  const handleAllTheTotalValues = (
    isTcsTds?: number,
    panType?: PanCardType
  ) => {
    const ItemList = form.getFieldValue(["items"]);

    // console.log("ItemList", ItemList);
    //------- Total Row Calculations -------
    const Total = ItemList?.reduce(
      (
        acc: {
          TotalQty: number;
          TotalUnitPrice: number;
          ItemSubTotal: number;
          TotalDiscount: number;
          Totalgst: number;
          TotalAmount: number;
        },
        curr: any
      ) => {
        acc.TotalQty += qty(curr);
        acc.TotalUnitPrice += price(curr);
        // acc.ItemSubTotal += price(curr) * qty(curr);
        acc.ItemSubTotal += price(curr);

        acc.TotalDiscount += amountInNumber(curr, "discountRupee");
        acc.Totalgst +=
          (partyIsGstRegisteredSalesInvoice === CompanyGSTTypes.Overseas ||
            partyIsGstRegisteredSalesInvoice === CompanyGSTTypes.SEZ) &&
          !underLUT
            ? Utils.getNumber(
                (curr?.amount?.price *
                  curr?.amount?.qty *
                  curr?.amount?.tax?.title) /
                  100
              )
            : amountInNumber(curr, "itemTaxAmt");
        acc.TotalAmount += amountInNumber(curr, "totalAmount");
        return acc;
      },
      {
        TotalQty: 0,
        TotalUnitPrice: 0,
        ItemSubTotal: 0,
        TotalDiscount: 0,
        Totalgst: 0,
        TotalAmount: 0,
      }
    );
    setFooterTotal({
      qty: Total.TotalQty,
      unitPrice: Total.TotalUnitPrice,
      taxableAmount: Total.ItemSubTotal,
      discount: Total.TotalDiscount,
      gst: Total.Totalgst,
      amount: Total.TotalAmount,
    });

    // cash discount
    const discount = form.getFieldValue("cashDiscount");
    const discountType = form.getFieldValue("cashDiscountDrop");

    const totalSumIncludedGst =
      Total.TotalAmount + footerLedger.ledgerTotalAmount;
    const totalSumExcludedGst =
      Total.ItemSubTotal + footerLedger.ledgerAmount - Total.TotalDiscount;
    // ----- Calculate item's total amount with discount -----
    let cashDiscountAmount: number = 0.0;
    // console.log("discount", totalSum, discount, discountType, typeof discount);
    if (discount > 0) {
      if (discountType === DiscountType.PercentageDiscount) {
        cashDiscountAmount = percentCal(totalSumIncludedGst, discount);
        setCashDiscountRs(cashDiscountAmount);
      } else {
        cashDiscountAmount = discount;
        setCashDiscountRs(cashDiscountAmount);
      }
    } else {
      setCashDiscountRs(0.0);
    }

    let totTcs = 0;
    let totTds = 0;
    if (isTcsTds ?? tdsOrTcs) {
      //----- Calculate TCS amount -----
      const tcsRate = form.getFieldValue("tcsDetail");

      totTcs = percentCal(
        totalSumIncludedGst - cashDiscountAmount,
        tcsRate?.title
      );
      setTotalTcs(totTcs);
      setTotalTds(0);
      setTcsTdsPercentage(tcsRate?.title);
    } else {
      //----- Calculate TDS amount -----
      const tdsRate = form.getFieldValue("tdsDetail");
      const type = panType ?? partyPanCard;

      const tdsPredentage =
        type === PanCardType.HUF
          ? tdsRate?.title?.rates?.indHUFRate ?? tdsRate?.title
          : type === PanCardType.Other
          ? tdsRate?.title?.rates?.otherRate ?? tdsRate?.title
          : tdsRate?.title?.rates?.ifPANNotRate ?? tdsRate?.title;

      setTcsTdsPercentage(tdsPredentage);
      // totTds = percentCal(
      //   totalSumExcludedGst - cashDiscountAmount,
      //   tdsPredentage
      // );

      // // console.log("Tds Rate", tdsPredentage, totTds);
      // setTotalTds(totTds);
      setTotalTcs(0);
    }

    // roundOff
    const totalAmount =
      voucherNature === Voucher_Nature.RCM ||
      partyIsGstRegisteredSalesInvoice === CompanyGSTTypes.Overseas ||
      partyIsGstRegisteredSalesInvoice === CompanyGSTTypes.SEZ
        ? Total.ItemSubTotal +
          footerLedger.ledgerAmount -
          Total.TotalDiscount -
          cashDiscountAmount +
          totTcs
        : //  -
          // totTds
          Total.TotalAmount +
          footerLedger.ledgerTotalAmount -
          cashDiscountAmount +
          totTcs;
    // -
    // totTds;

    const nRoundOffAmount = handleRoundoff(
      totalAmount,
      form.getFieldValue("roundoffCheckbox"),
      settingControl.roundOffType
    );

    form.setFieldValue("roundOff", nRoundOffAmount);
    setRoundoffAmount(nRoundOffAmount);
  };

  // on change in items files amount chnage
  const handleItemsNetAmmount = (index: number) => {
    // console.log(index);
    const ItemList = form.getFieldValue(["items"]);
    const currentIndexData = ItemList[index];
    setBatchItmId(ItemList[0]?.id?.value);
    if (currentIndexData) {
      form.setFieldValue(["items", index], {
        ...currentIndexData,
        amount: {
          ...currentIndexData.amount,
          discountRupee: discountRupee(currentIndexData),
          itemTaxAmt:
            (partyIsGstRegisteredSalesInvoice === CompanyGSTTypes.Overseas ||
              partyIsGstRegisteredSalesInvoice === CompanyGSTTypes.SEZ) &&
            // underLUT &&
            splitPathInVchType === Voucher_Type.SalesVoucher
              ? 0
              : itemTaxAmt(currentIndexData),
          totalAmount:
            (partyIsGstRegisteredSalesInvoice === CompanyGSTTypes.Overseas ||
              partyIsGstRegisteredSalesInvoice === CompanyGSTTypes.SEZ) &&
            // underLUT &&
            splitPathInVchType === Voucher_Type.SalesVoucher
              ? amountWithoutTax(
                  currentIndexData,
                  currentIndexData?.amount?.discount ?? 0
                )
              : amountWithTax(currentIndexData),
          hideTax:
            currentClient?.gstType === CompanyGSTTypes.Regular ||
            updateTimeData.isGSTVoucher ||
            splitPathInVchType !== Voucher_Type.SalesVoucher
              ? {
                  value:
                    currentIndexData.amount?.tax?.value ??
                    currentIndexData.amount?.hideTax?.value,
                  label:
                    currentIndexData.amount?.tax?.label ??
                    currentIndexData.amount?.hideTax?.label,
                  title:
                    currentIndexData.amount?.tax?.title ??
                    currentIndexData.amount?.hideTax?.title,
                }
              : null,
        },
      });
    }
    handleAllTheTotalValues();
    // addTotalTaxAmountChange(currentIndexData);
  };

  // Discount (%)
  const handleItemsAllDiscount = (discountPercentage: number) => {
    const ItemList = form.getFieldValue(["items"]);
    if (ItemList?.length > 0) {
      ItemList?.map((x: any, index: number) => {
        // ItemList;
        const currentIndexData = ItemList[index];

        form.setFieldValue(["items", index], {
          ...currentIndexData,
          amount: {
            ...currentIndexData.amount,
            discount: discountPercentage ?? 0,
            discountRupee: discountRupee(
              currentIndexData,
              discountPercentage ?? 0
            ),
            itemTaxAmt:
              (partyIsGstRegisteredSalesInvoice === CompanyGSTTypes.Overseas ||
                partyIsGstRegisteredSalesInvoice === CompanyGSTTypes.SEZ) &&
              // underLUT &&
              splitPathInVchType === Voucher_Type.SalesVoucher
                ? 0
                : itemTaxAmt(currentIndexData, discountPercentage ?? 0),
            totalAmount:
              (partyIsGstRegisteredSalesInvoice === CompanyGSTTypes.Overseas ||
                partyIsGstRegisteredSalesInvoice === CompanyGSTTypes.SEZ) &&
              // underLUT &&
              splitPathInVchType === Voucher_Type.SalesVoucher
                ? amountWithoutTax(currentIndexData, discountPercentage ?? 0)
                : amountWithTax(currentIndexData, discountPercentage ?? 0),
          },
        });
      });
    }
    handleAllTheTotalValues();
    // addTotalTaxAmountChange(currentIndexData);
  };

  // Purchase Bill party change - Gst register to unregister & unregister to gst register
  useEffect(() => {
    if (partyIsGstRegisteredTrigger) {
      const ItemList = form.getFieldValue(["items"]);
      if (ItemList?.length > 0 && ItemList[0]?.id?.value) {
        ItemList?.map((x: any, index: number) => {
          // const currentIndexData = ItemList[index];

          // const netAmount = Utils.getNumber(x?.amount?.price * x?.amount?.qty);
          const netAmount = Utils.getNumber(x?.amount?.price);
          const discountRupee = percentCal(netAmount, x?.amount?.discount);
          const taxRate = Utils.getNumber(x?.amount?.hideTax?.title);
          const withoutTaxAmount = Utils.getNumber(netAmount - discountRupee);
          const itemTaxAmt = Utils.getNumber(
            withoutTaxAmount * (taxRate / 100)
          );
          // itemsOption.find(x => x.id)
          if (
            partyIsGstRegistered === CompanyGSTTypes.Regular
            // ||
            // partyIsGstRegistered === CompanyGSTTypes.Composition
          ) {
            form.setFieldValue(["items", index], {
              ...x,
              amount: {
                ...x?.amount,
                // tax:
                itcEligibilityType: ITCEligibility_Type.Available,
                tax: {
                  title: x?.amount?.hideTax?.title,
                  value: x?.amount?.hideTax?.value,
                  label: x?.amount?.hideTax?.label,
                },
                itemTaxAmt: itemTaxAmt,
                totalAmount: withoutTaxAmount + itemTaxAmt,
              },
            });
          } else {
            form.setFieldValue(["items", index], {
              ...x,
              amount: {
                ...x?.amount,
                itemTaxAmt: 0,
                itcEligibilityType: null,
                tax: null,
                hideTax:
                  currentClient?.gstType === CompanyGSTTypes.Regular ||
                  updateTimeData.isGSTVoucher ||
                  splitPathInVchType !== Voucher_Type.SalesVoucher
                    ? {
                        value: x?.amount?.tax?.value,
                        label: x?.amount?.tax?.label,
                        title: x?.amount?.tax?.title,
                      }
                    : null,
                totalAmount: amountWithoutTax(x, x?.amount?.discount ?? 0),
              },
            });
          }
        });
        handleAllTheTotalValues();
        // console.log("checkinvoicedat", ItemList);
      }

      const freightInsLedgers = form.getFieldValue("freightInsLedgers");
      if (freightInsLedgers?.length > 0 && freightInsLedgers[0]?.id) {
        freightInsLedgers?.map((x: any, index: number) => {
          // const currentLedgerIndexData = freightInsLedgers[index];

          const gstrate = Utils.getNumber(x?.hideTax?.title);
          const gstamount = percentCal(Utils.getNumber(x?.amount), gstrate);
          const ledgertotalamout = Utils.getNumber(x?.amount) + gstamount;

          //  value: currentSelectLedger?.gstRate?.id,
          //   label: currentSelectLedger?.gstRate?.name,
          //   title: currentSelectLedger?.gstRate?.rate,
          if (
            partyIsGstRegistered === CompanyGSTTypes.Regular
            // ||
            // partyIsGstRegistered === CompanyGSTTypes.Composition
          ) {
            form.setFieldValue(["freightInsLedgers", index], {
              ...x,
              itcEligibilityType: ITCEligibility_Type.Available,
              gstRate: x?.hideTax && {
                title: x?.hideTax?.title,
                value: x?.hideTax?.value,
                label: x?.hideTax?.label,
              },
              gstAmount: gstamount,
              totalAmount: ledgertotalamout,
            });
          } else {
            form.setFieldValue(["freightInsLedgers", index], {
              ...x,
              itcEligibilityType: null,
              hideTax:
                currentClient?.gstType === CompanyGSTTypes.Regular ||
                updateTimeData.isGSTVoucher ||
                splitPathInVchType !== Voucher_Type.SalesVoucher
                  ? {
                      value: x.gstRate?.value,
                      label: x.gstRate?.label,
                      title: x.gstRate?.title,
                    }
                  : null,
              // gstRate: null,
              gstAmount: 0,
              totalAmount: x?.amount,
            });
          }
        });
        handleFreightAndInsLedgerTotal();
      }
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [partyIsGstRegisteredTrigger]);

  // Sales Invoice party chage - Not overseas to overseas & overseas to not Overseas
  useEffect(() => {
    if (
      // false &&
      partyIsGstRegisteredSalesInvoiceTrigger &&
      currentClient?.gstType === CompanyGSTTypes.Regular
    ) {
      // debugger
      const ItemList = form.getFieldValue(["items"]);
      const party = form.getFieldValue("partyLedger");

      // let findCutomerDetails;

      const findCutomerDetails = customerOptions.find(
        (Ledgerlist: any) => Ledgerlist?.id === party?.value
      );
      // const findGstRate = gstOption?.find((x) => x.id === 3);
      if (ItemList?.length > 0) {
        ItemList?.map((x: any, index: number) => {
          // const findItem = itemsOption?.find((itm) => itm?.id === x?.id?.value);
          // const currentIndexData = ItemList[index];

          // gst rate calculate like not LUT
          if (
            // underLUT === false ||
            findCutomerDetails?.gstType === CompanyGSTTypes.Unregistered ||
            findCutomerDetails?.gstType === CompanyGSTTypes.Regular ||
            findCutomerDetails?.gstType === CompanyGSTTypes.Composition ||
            findCutomerDetails?.gstType === CompanyGSTTypes.Consumer ||
            findCutomerDetails?.gstType ===
              CompanyGSTTypes.DeemedExportImport ||
            findCutomerDetails?.gstType === undefined ||
            findCutomerDetails?.gstType === null
          ) {
            // const netAmount = Utils.getNumber(
            //   x?.amount?.price * x?.amount?.qty
            // );
            const netAmount = Utils.getNumber(x?.amount?.price);
            const discountRupee = percentCal(netAmount, x?.amount?.discount);
            const taxRate = Utils.getNumber(x?.amount?.hideTax?.title);
            const withoutTaxAmount = Utils.getNumber(netAmount - discountRupee);
            const itemTaxAmt =
              partyIsGstRegisteredSalesInvoice === CompanyGSTTypes.Overseas ||
              partyIsGstRegisteredSalesInvoice === CompanyGSTTypes.SEZ
                ? 0
                : Utils.getNumber(withoutTaxAmount * (taxRate / 100));

            form.setFieldValue(["items", index], {
              ...x,
              amount: {
                ...x?.amount,
                // tax:
                itcEligibilityType: ITCEligibility_Type.Available,
                // tax: {
                //   title: findItem?.taxRate?.rate,
                //   value: findItem?.taxRate?.id,
                //   label: findItem?.taxRate?.name,
                // },
                itemTaxAmt:
                  partyIsGstRegisteredSalesInvoice ===
                    CompanyGSTTypes.Overseas ||
                  partyIsGstRegisteredSalesInvoice === CompanyGSTTypes.SEZ
                    ? 0
                    : itemTaxAmt,
                totalAmount: withoutTaxAmount + itemTaxAmt,
              },
            });
          }
          // gst rate not calculate like under LUT findCutomerDetails?.gstType ===  CompanyGSTTypes.Overseas ya CompanyGSTTypes.SEZ
          else {
            form.setFieldValue(["items", index], {
              ...x,
              amount: {
                ...x?.amount,
                itemTaxAmt: 0,
                itcEligibilityType: null,
                // tax: {
                //   title: findItem?.taxRate?.rate,
                //   value: findItem?.taxRate?.id,
                //   label: findItem?.taxRate?.name,
                // },
                hideTax:
                  currentClient?.gstType === CompanyGSTTypes.Regular ||
                  updateTimeData.isGSTVoucher ||
                  splitPathInVchType !== Voucher_Type.SalesVoucher
                    ? {
                        value: x?.amount?.tax?.value,
                        label: x?.amount?.tax?.label,
                        title: x?.amount?.tax?.title,
                      }
                    : null,
                totalAmount: amountWithoutTax(x, x?.amount?.discount ?? 0),
              },
            });
          }
        });
        handleAllTheTotalValues();
        // console.log("checkinvoicedat", ItemList);
      }

      const freightInsLedgers = form.getFieldValue("freightInsLedgers");
      if (freightInsLedgers?.length > 0 && freightInsLedgers[0]?.id) {
        freightInsLedgers?.map((x: any, index: number) => {
          // const currentLedgerIndexData = freightInsLedgers[index];

          const gstrate = Utils.getNumber(x?.hideTax?.title);
          const gstamount = percentCal(Utils.getNumber(x?.amount), gstrate);
          const ledgerTotalGstAmount = Utils.getNumber(x?.amount) + gstamount;

          //  value: currentSelectLedger?.gstRate?.id,
          //   label: currentSelectLedger?.gstRate?.name,
          //   title: currentSelectLedger?.gstRate?.rate,
          if (
            // underLUT === false ||
            findCutomerDetails?.gstType === CompanyGSTTypes.Unregistered ||
            findCutomerDetails?.gstType === CompanyGSTTypes.Regular ||
            findCutomerDetails?.gstType === CompanyGSTTypes.Composition ||
            findCutomerDetails?.gstType === CompanyGSTTypes.Consumer ||
            findCutomerDetails?.gstType ===
              CompanyGSTTypes.DeemedExportImport ||
            findCutomerDetails?.gstType === undefined ||
            findCutomerDetails?.gstType === null
          ) {
            form.setFieldValue(["freightInsLedgers", index], {
              ...x,
              itcEligibilityType: ITCEligibility_Type.Available,
              gstRate:
                splitPathInVchType === Voucher_Type.SalesVoucher
                  ? x.gstRate && {
                      value: x.gstRate?.value,
                      label: x.gstRate?.label,
                      title: x.gstRate?.title,
                    }
                  : x?.hideTax && {
                      title: x?.hideTax?.title,
                      value: x?.hideTax?.value,
                      label: x?.hideTax?.label,
                    },
              gstAmount: gstamount,
              totalAmount: ledgerTotalGstAmount,
            });
          } else {
            form.setFieldValue(["freightInsLedgers", index], {
              ...x,
              itcEligibilityType: null,
              hideTax:
                currentClient?.gstType === CompanyGSTTypes.Regular ||
                updateTimeData.isGSTVoucher ||
                splitPathInVchType !== Voucher_Type.SalesVoucher
                  ? x.gstRate && {
                      value: x.gstRate?.value,
                      label: x.gstRate?.label,
                      title: x.gstRate?.title,
                    }
                  : null,
              gstRate:
                splitPathInVchType === Voucher_Type.SalesVoucher
                  ? x.gstRate && {
                      value: x.gstRate?.value,
                      label: x.gstRate?.label,
                      title: x.gstRate?.title,
                    }
                  : x?.hideTax && {
                      title: x?.hideTax?.title,
                      value: x?.hideTax?.value,
                      label: x?.hideTax?.label,
                    },
              gstAmount: 0,
              totalAmount: x?.amount,
            });
          }
        });
        handleFreightAndInsLedgerTotal();
      }
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    partyIsGstRegisteredSalesInvoice,
    partyIsGstRegisteredSalesInvoiceTrigger,
    underLUT,
  ]);

  const onDiscountAmountChange = (index: number) => {
    const ItemList = form.getFieldValue(["items"]);
    const currentIndexData = ItemList[index];

    if (currentIndexData) {
      // Calculate the new values based on the discount change
      const newDiscountAmount = percentToRs(
        amountInNumber(currentIndexData, "discountRupee"),
        netAmount(currentIndexData)
      );

      const newTaxRs = percentCal(
        netAmount(currentIndexData) -
          amountInNumber(currentIndexData, "discountRupee"),
        taxRate(currentIndexData)
      );

      const newTotalAmount =
        netAmount(currentIndexData) -
        amountInNumber(currentIndexData, "discountRupee") +
        newTaxRs;

      // Update the form field with the new calculated values
      form.setFieldValue(["items", index], {
        ...currentIndexData,
        amount: {
          ...currentIndexData.amount,
          discount: newDiscountAmount,
          itemTaxAmt: newTaxRs,
          totalAmount: newTotalAmount,
        },
      });

      // Call the function to handle the total values if needed
      handleAllTheTotalValues();
    }
  };

  // const onItemsTotalAmountChange = async (index: number) => {
  //   // console.log("index...........", index);

  //   const ItemList = form.getFieldValue(["items"]);
  //   const currentIndexData = ItemList[index];

  //   // Calculate the denominator for various calculations
  //   const denominator =
  //     100 -
  //     discount(currentIndexData) +
  //     percentCal(
  //       100 - discount(currentIndexData),
  //       (partyIsGstRegisteredSalesInvoice === CompanyGSTTypes.Overseas ||
  //         partyIsGstRegisteredSalesInvoice === CompanyGSTTypes.SEZ) &&
  //         underLUT &&
  //         splitPathInVchType === Voucher_Type.SalesVoucher
  //         ? 0
  //         : taxRate(currentIndexData)
  //     );

  //   // Calculate the price based on the given formula
  //   const calculatedPrice =
  //     (amountInNumber(currentIndexData, "totalAmount") * 100) /
  //     (denominator * qty(currentIndexData));

  //   // Calculate the discountRupee based on the given formula
  //   const calculatedDiscountRupee =
  //     (amountInNumber(currentIndexData, "totalAmount") *
  //       discount(currentIndexData)) /
  //     denominator;

  //   // Calculate the itemTaxAmt based on the given formula
  //   const calculatedTaxRs =
  //     (amountInNumber(currentIndexData, "totalAmount") *
  //       percentCal(
  //         100 - discount(currentIndexData),
  //         (partyIsGstRegisteredSalesInvoice === CompanyGSTTypes.Overseas ||
  //           partyIsGstRegisteredSalesInvoice === CompanyGSTTypes.SEZ) &&
  //           underLUT &&
  //           splitPathInVchType === Voucher_Type.SalesVoucher
  //           ? 0
  //           : taxRate(currentIndexData)
  //       )) /
  //     denominator;

  //   if (denominator > 0 && currentIndexData?.amount?.qty > 0) {
  //     // Update the form field values with the calculated values
  //     form.setFieldValue(["items", index], {
  //       ...currentIndexData,
  //       amount: {
  //         ...currentIndexData?.amount,
  //         price: calculatedPrice,
  //         discountRupee: calculatedDiscountRupee,
  //         itemTaxAmt: calculatedTaxRs,
  //       },
  //     });
  //   } else {
  //     // Denominator is zero or negative, set all fields to 0
  //     form.setFieldValue(["items", index], {
  //       ...currentIndexData,
  //       amount: {
  //         ...currentIndexData?.amount,
  //         price: 0,
  //         discountRupee: 0,
  //         itemTaxAmt: 0,
  //         totalAmount: 0,
  //       },
  //     });
  //   }
  //   handleAllTheTotalValues();
  // };

  // Freight And InsLedger total in fotter

  const handleFreightAndInsLedgerTotal = () => {
    const LedgerAllList = form.getFieldValue(["freightInsLedgers"]);

    //----- Total Row Calculations---------
    const AmountLedger = LedgerAllList.reduce((acc: number, curr: any) => {
      return (acc += Utils.getNumber(curr?.amount));
    }, 0);

    const Total = LedgerAllList.reduce(
      (
        acc: {
          amount: number;
          gstAmount: number;
          totalAmount: number;
        },
        curr: any
      ) => {
        acc.amount += Utils.getNumber(curr?.amount);
        acc.gstAmount +=
          (partyIsGstRegisteredSalesInvoice === CompanyGSTTypes.Overseas ||
            partyIsGstRegisteredSalesInvoice === CompanyGSTTypes.SEZ) &&
          !underLUT
            ? Utils.getNumber((curr?.amount * curr?.gstRate?.title) / 100)
            : Utils.getNumber(curr?.gstAmount);
        acc.totalAmount += Utils.getNumber(curr?.totalAmount);
        return acc;
      },
      {
        amount: 0,
        gstAmount: 0,
        totalAmount: 0,
      }
    );
    setFooterLedger({
      ledgerAmount: Total.amount,
      ledgerGstAmount: Total.gstAmount,
      ledgerTotalAmount: Total.totalAmount,
    });

    // ----- Calculate items total unit Price -----
    const TotalLedgerAmount = LedgerAllList.reduce((acc: number, curr: any) => {
      return (acc += amountInNumber(curr, "totalAmount"));
    }, 0);
    setLedgerAmount(TotalLedgerAmount);

    // cash discount
    const discount = form.getFieldValue("cashDiscount");
    const discountType = form.getFieldValue("cashDiscountDrop");

    const totalSum = footerTotal.amount + Total.totalAmount;
    let cashDiscountAmount: number = 0.0;
    // console.log("discount", totalSum, discount, discountType, typeof discount);
    if (discount > 0) {
      if (discountType === DiscountType.PercentageDiscount) {
        cashDiscountAmount = percentCal(totalSum, discount);
        setCashDiscountRs(cashDiscountAmount);
      } else {
        cashDiscountAmount = discount;
        setCashDiscountRs(cashDiscountAmount);
      }
    } else {
      setCashDiscountRs(0.0);
    }

    let totTcs = 0;
    let totTds = 0;
    if (tdsOrTcs) {
      //----- Calculate TCS amount -----
      const tcsRate = form.getFieldValue("tcsDetail");

      totTcs = percentCal(totalSum, tcsRate?.title);
      console.log("Tcs Rate", tcsRate, footerTotal.amount, totTcs);

      setTotalTcs(totTcs);
    }
    // else {
    //   //----- Calculate TDS amount -----
    //   const tdsRate = form.getFieldValue("tdsDetail");

    //   totTds = percentCal(totalSum, tdsRate?.title);
    //   console.log("Tds Rate", tdsRate, totTds);
    //   setTotalTds(totTds);
    // }

    // roundOff
    const totalAmount =
      voucherNature === Voucher_Nature.RCM ||
      partyIsGstRegisteredSalesInvoice === CompanyGSTTypes.Overseas ||
      partyIsGstRegisteredSalesInvoice === CompanyGSTTypes.SEZ
        ? footerTotal.taxableAmount +
          Total.ledgerAmount -
          footerTotal.discount -
          cashDiscountAmount +
          totTcs
        : // -totTds
          footerTotal.amount + Total.totalAmount - cashDiscountAmount + totTcs;
    // -totTds;

    const roundOffAmount = handleRoundoff(
      totalAmount,
      form.getFieldValue("roundoffCheckbox"),
      settingControl.roundOffType
    );

    form.setFieldValue("roundOff", roundOffAmount);
    setRoundoffAmount(roundOffAmount);
  };

  // on chnage in Freight And InsLedger unit price & gst
  const handleLedgerNetAmount = (index: number) => {
    const Ledgerlist = form.getFieldValue(["freightInsLedgers"]);
    const currentLedgerIndexData = Ledgerlist[index];
    console.log(
      "currentLedgerIndexData",
      currentLedgerIndexData,
      Utils.getFormattedNumber(gstamount(currentLedgerIndexData)),
      ledgertotalamout(currentLedgerIndexData)
    );
    if (currentLedgerIndexData) {
      form.setFieldValue(["freightInsLedgers", index], {
        ...currentLedgerIndexData,
        gstAmount:
          (partyIsGstRegisteredSalesInvoice === CompanyGSTTypes.Overseas ||
            partyIsGstRegisteredSalesInvoice === CompanyGSTTypes.SEZ) &&
          // underLUT &&
          splitPathInVchType === Voucher_Type.SalesVoucher
            ? 0
            : gstamount(currentLedgerIndexData),
        // totalAmount: Utils.getFormattedNumber(currentLedgerIndexData?.amount),
        totalAmount:
          (partyIsGstRegisteredSalesInvoice === CompanyGSTTypes.Overseas ||
            partyIsGstRegisteredSalesInvoice === CompanyGSTTypes.SEZ) &&
          // underLUT &&
          splitPathInVchType === Voucher_Type.SalesVoucher
            ? Utils.getNumber(currentLedgerIndexData?.amount)
            : ledgertotalamout(currentLedgerIndexData),
      });
      handleFreightAndInsLedgerTotal();
    }
    Ledgerlist?.length === 0 && setShowFreightInsurance(false);
  };
  console.log("Party Type: ", isPartyCompany);

  const onLedgerTotalAmountChange = async (index: number) => {
    const LedgerList = form.getFieldValue(["freightInsLedgers"]);
    const currentIndexData = LedgerList[index];
    // console.log("currentIndexData", currentIndexData.totalAmount);

    //Calculate the denominator for various calculations
    const denominators =
      (partyIsGstRegisteredSalesInvoice === CompanyGSTTypes.Overseas ||
        partyIsGstRegisteredSalesInvoice === CompanyGSTTypes.SEZ) &&
      underLUT &&
      splitPathInVchType === Voucher_Type.SalesVoucher
        ? 0
        : gstrate(currentIndexData);
    // console.log("denominators", denominators);

    const ledgernetAmount =
      (Utils.getNumber(currentIndexData.totalAmount) / (100 + denominators)) *
      100;
    // console.log("gstAmount", ledgernetAmount);

    const gstAmount =
      Utils.getNumber(currentIndexData.totalAmount) - ledgernetAmount;
    // console.log("ledgernetAmount...", gstAmount);

    if (ledgernetAmount > 0) {
      form.setFieldValue(["freightInsLedgers", index], {
        ...currentIndexData,
        amount: ledgernetAmount,
        gstAmount: gstAmount,
        // totalAmount: Utils.getFormattedNumber(
        //   ledgertotalamout(currentIndexData)
        // ),
      });
    } else {
      // ledgernetAmount is zero or negative, set all fields to 0
      form.setFieldValue(["freightInsLedgers", index], {
        ...currentIndexData,
        amount: ledgernetAmount,
        gstAmount: gstAmount,
      });
    }
    handleFreightAndInsLedgerTotal();
  };

  // Include Other Expenses (Indirect Income expenses) select
  const freightInsLedgersSelect: any = async (value: any, index: number) => {
    // console.log("value11.............", value, index);

    const currentSelectLedger = freightAndInsuranceOptions.find(
      (x: any) => x.id === value
    );

    if (currentSelectLedger) {
      const currentData = form.getFieldValue(["freightInsLedgers", index]);

      const currentValues = {
        id: {
          value: currentSelectLedger?.id,
          label: currentSelectLedger.ledgerName,
        },
        amount: currentData?.amount,
        gstRate:
          currentSelectLedger?.gstRate?.name &&
          (splitPathInVchType === Voucher_Type.PurchaseVoucher
            ? (partyIsGstRegistered === CompanyGSTTypes.Regular ||
                updateTimeData.isGSTVoucher) && {
                value: currentSelectLedger?.gstRate?.id,
                label: currentSelectLedger?.gstRate?.name,
                title: currentSelectLedger?.gstRate?.rate,
              }
            : currentClient?.gstType === CompanyGSTTypes.Regular ||
              updateTimeData.isGSTVoucher
            ? {
                value: currentSelectLedger?.gstRate?.id,
                label: currentSelectLedger?.gstRate?.name,
                title: currentSelectLedger?.gstRate?.rate,
              }
            : null),
        hideTax: currentSelectLedger?.gstRate?.name && {
          value: currentSelectLedger?.gstRate?.id,
          label: currentSelectLedger?.gstRate?.name,
          title: currentSelectLedger?.gstRate?.rate,
        },
        gstAmount:
          (partyIsGstRegisteredSalesInvoice === CompanyGSTTypes.Overseas ||
            partyIsGstRegisteredSalesInvoice === CompanyGSTTypes.SEZ) &&
          // underLUT &&
          splitPathInVchType === Voucher_Type.SalesVoucher
            ? 0
            : gstamount(currentData),
        totalAmount:
          (partyIsGstRegisteredSalesInvoice === CompanyGSTTypes.Overseas ||
            partyIsGstRegisteredSalesInvoice === CompanyGSTTypes.SEZ) &&
          // underLUT &&
          splitPathInVchType === Voucher_Type.SalesVoucher
            ? Utils.getNumber(currentData?.amount)
            : ledgertotalamout(currentData),
        itcEligibilityType:
          splitPathInVchType === Voucher_Type.PurchaseVoucher
            ? ITCEligibility_Type.Available
            : null,
      };
      form.setFieldValue(["freightInsLedgers", index], currentValues);
    }
    setLedgerLength(index + 1);
    handleFreightAndInsLedgerTotal();
    setSelectedOtherExpenses((prevState) => {
      const updatedSelectedOptions = [...prevState];
      updatedSelectedOptions[index] = value;
      return updatedSelectedOptions;
    });
    // console.log("currentSelectLedger", currentSelectLedger);
  };

  const hangleCashDisCount = () => {
    const discount = form.getFieldValue("cashDiscount");
    const discountType = form.getFieldValue("cashDiscountDrop");
    const totalSum =
      voucherNature === Voucher_Nature.RCM ||
      partyIsGstRegisteredSalesInvoice === CompanyGSTTypes.Overseas ||
      partyIsGstRegisteredSalesInvoice === CompanyGSTTypes.SEZ
        ? footerTotal.taxableAmount +
          footerLedger.ledgerAmount -
          footerTotal.discount
        : footerTotal.amount + footerLedger.ledgerTotalAmount;
    // console.log("discount", totalSum, discount, discountType, typeof discount);

    let totalSumIncludedGstLessCashDiscount =
      footerTotal.amount + footerLedger.ledgerTotalAmount;

    let totalSumExcludedGstLessCashDiscount =
      footerTotal.taxableAmount +
      footerLedger.ledgerAmount -
      footerTotal.discount;

    let roundOffAmount = 0;
    if (discount > 0) {
      if (discountType === DiscountType.PercentageDiscount) {
        const percentDis = percentCal(totalSum, discount);
        setCashDiscountRs(percentDis);

        totalSumIncludedGstLessCashDiscount =
          totalSumIncludedGstLessCashDiscount - percentDis;
        totalSumExcludedGstLessCashDiscount =
          totalSumExcludedGstLessCashDiscount - percentDis;

        roundOffAmount = handleRoundoff(
          totalSum - percentDis,
          form.getFieldValue("roundoffCheckbox"),
          settingControl.roundOffType
        );

        form.setFieldValue("roundOff", roundOffAmount);
        setRoundoffAmount(roundOffAmount);
        // console.log("")
        // console.log("footerTotal.taxableAmount", percentCal(totalSum, discount));
      } else {
        setCashDiscountRs(discount);
        roundOffAmount = handleRoundoff(
          totalSum - discount,
          form.getFieldValue("roundoffCheckbox"),
          settingControl.roundOffType
        );

        form.setFieldValue("roundOff", roundOffAmount);
        setRoundoffAmount(roundOffAmount);

        totalSumIncludedGstLessCashDiscount =
          totalSumIncludedGstLessCashDiscount - discount;
        totalSumExcludedGstLessCashDiscount =
          totalSumExcludedGstLessCashDiscount - discount;
        // console.log("RupeeDiscount", totalSum - discount);
      }
    } else {
      setCashDiscountRs(0.0);

      roundOffAmount = handleRoundoff(
        totalSum,
        form.getFieldValue("roundoffCheckbox"),
        settingControl.roundOffType
      );

      form.setFieldValue("roundOff", roundOffAmount);
      setRoundoffAmount(roundOffAmount);
    }

    let totTcs = 0;
    let totTds = 0;
    if (tdsOrTcs) {
      //----- Calculate TCS amount -----
      const tcsRate = form.getFieldValue("tcsDetail");

      totTcs = percentCal(totalSumIncludedGstLessCashDiscount, tcsRate?.title);
      console.log("Tcs Rate", tcsRate, footerTotal.amount, tcsRate);

      setTotalTcs(totTcs);
      setTotalTds(0);
      setTcsTdsPercentage(tcsRate?.title);
    } else {
      //----- Calculate TDS amount -----
      const tdsRate = form.getFieldValue("tdsDetail");
      console.log("Tcs Rate", tdsRate, footerTotal.amount);

      const type = partyPanCard;

      const tdsPredentage =
        type === PanCardType.HUF
          ? tdsRate.title?.rates?.indHUFRate ?? tdsRate?.title
          : type === PanCardType.Other
          ? tdsRate.title?.rates?.otherRate ?? tdsRate?.title
          : tdsRate.title?.rates?.ifPANNotRate ?? tdsRate?.title;

      setTcsTdsPercentage(tdsPredentage);
      // totTds = percentCal(totalSumExcludedGstLessCashDiscount, tdsPredentage);

      // // console.log("Tds Rate", tdsPredentage, totTds);
      // setTotalTds(totTds);
      setTotalTcs(0);
    }
  };

  const [selectedInput, setSelectedInput] = useState<any>([
    "description",
    "hsnCode",
    "unit",
    "discount",
  ]);

  // --------- Get TDS Option List API ---------
  useEffect(() => {
    // if (splitPathInVchType === Voucher_Type.PurchaseVoucher) {
    const getTDSList = async (
      start: number,
      length: number,
      search?: string,
      status: LedgerStatus = LedgerStatus.active
    ) => {
      await TdsTcsServices.getTDSList(
        currentClient?.id!,
        start,
        length,
        search,
        status
      )
        .then((res: any) => {
          if (res.length > 0) {
            setTdsList(res);
          } else if (res.length === 0) {
            setTdsList([]);
          }
          // setLoading(false);
        })
        .catch((ex: any) => {
          console.error(ex.message);
          // openNotification("error", ex.message);
          // setLoading(false);
          setTdsList([]);
        });
    };
    getTDSList(0, 0);
    // }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [splitPathInVchType, tdsListTrigger]);

  // --------- Get TCS TableData API ---------
  useEffect(() => {
    const getList = async (
      start: number,
      length: number,
      search?: string,
      status: LedgerStatus = LedgerStatus.active
    ) => {
      await TdsTcsServices.getTCSList(
        currentClient?.id!,
        start,
        length,
        search,
        status
      )
        .then((res: any) => {
          console.log("res TCS List", res);

          if (res?.length > 0) {
            setTcsList(res);
          } else if (res?.length === 0) {
            setTcsList([]);
          }
          // setLoading(false);
        })
        .catch((ex: any) => {
          console.error(ex?.message);
          // openNotification("error", ex.message);
          // setLoading(false);
          setTcsList([]);
        });
    };
    getList(0, 0);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tcsListTrigger]);

  useEffect(() => {
    if (dueDateTrigger) {
      form.setFieldValue(
        "dueDate",
        dayjs(
          form
            .getFieldValue("date")
            .add(presetsDueDate.label, presetsDueDate.value)
        )
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dueDateTrigger]);

  const itemFilterOptions = itemsOption?.filter((option) => {
    const labelMatches = option?.assetName
      ?.toLowerCase()
      ?.includes(itemSearch?.toLowerCase());

    const aMatches = option?.barCode
      ?.toLowerCase()
      ?.includes(itemSearch?.toLowerCase());
    return labelMatches || aMatches; // Include if either filter matches
  });

  useEffect(() => {
    // debugger
    const mergedBatchData = [...(batchData || []), ...(forAddBatchData || [])];
    if (clickedIndex === null) return;
    const existingItems = form.getFieldValue("items") || [];
    let newItems = [...existingItems];
    const firstItemId = existingItems[clickedIndex]?.id?.value;
    if (Array.isArray(mergedBatchData) && mergedBatchData.length > 0) {
      const selectedItemAllData = itemsOption?.find(
        (x) => x.id === firstItemId
      );
      const discountPrecentage =
        (settingControl.discountPolicy === Discount_Policy.TradenCashDiscount ||
          settingControl.discountPolicy === Discount_Policy.OnlyTradeDiscount ||
          updateTimeData.tradeDiscount) &&
        !mode
          ? selectedItemAllData.discountSalesType ===
            DiscountSalesType.Percentage
            ? selectedItemAllData.discountSalesPrice
            : (selectedItemAllData.discountSalesPrice /
                (selectedItemAllData.isTaxable
                  ? (selectedItemAllData.price /
                      (100 + selectedItemAllData?.taxRate?.rate)) *
                    100
                  : selectedItemAllData.price)) *
              100
          : 0;
      const tax: any =
        splitPathInVchType === Voucher_Type.PurchaseVoucher
          ? (partyIsGstRegistered === CompanyGSTTypes.Regular ||
              updateTimeData.isGSTVoucher) && {
              value: selectedItemAllData?.taxRate?.id,
              label: selectedItemAllData?.taxRate?.name,
              title: selectedItemAllData?.taxRate?.rate,
            }
          : currentClient?.gstType === CompanyGSTTypes.Regular ||
            updateTimeData.isGSTVoucher
          ? {
              value: selectedItemAllData?.taxRate?.id,
              label: selectedItemAllData?.taxRate?.name,
              title: selectedItemAllData?.taxRate?.rate,
            }
          : null;
      const hideTax =
        currentClient?.gstType === CompanyGSTTypes.Regular ||
        updateTimeData.isGSTVoucher ||
        splitPathInVchType !== Voucher_Type.SalesVoucher
          ? {
              value: selectedItemAllData?.taxRate?.id,
              label: selectedItemAllData?.taxRate?.name,
              title: selectedItemAllData?.taxRate?.rate,
            }
          : null;
      const taxRate = tax?.title ? Utils.getNumber(tax?.title) : 0;

      const updatedItems = mergedBatchData
        .filter((itm) => itm !== undefined && Object.keys(itm).length > 0)
        .map((itm, index) => {
          const existingItem = existingItems[clickedIndex];

          const price =
            splitPathInVchType === Voucher_Type.SalesVoucher
              ? existingItem.isTaxable
                ? (itm?.salesPrice / (100 + taxRate)) * 100
                : itm?.salesPrice
              : existingItem.isTaxable
              ? (itm?.purchasePrice / (100 + taxRate)) * 100
              : itm?.purchasePrice;

          const netAmount = Utils.getNumber(price * (itm?.qty ?? 1));
          const discountRupee = percentCal(netAmount, discountPrecentage);
          const withoutTaxAmount = Utils.getNumber(netAmount - discountRupee);
          const itemTaxAmt = Utils.getNumber(
            withoutTaxAmount * (taxRate / 100)
          );
          return {
            ...existingItem,
            id: {
              value: firstItemId,
              label: batchItmName,
            },
            // id: firstItemId,
            // name: batchItmName,
            amount: {
              unit: existingItem.amount?.unit,
              qty: itm?.qty ?? 1,
              price: price,
              discount: discountPrecentage,
              tax: tax,
              hideTax: hideTax,
              itemTaxAmt: itemTaxAmt,
              totalAmount: withoutTaxAmount + itemTaxAmt,
              discountRupee: discountRupee,
            },
            batchItem: [itm],
          };
        });
      // partyIsGstRegisteredTrigger

      if (updatedItems.length > 0) {
        newItems.splice(clickedIndex, 1, ...updatedItems);
      }
    } else if (newItems.length > 1) {
      newItems[newItems.length - 1] = -1;
    }
    form.setFieldsValue({ items: newItems });
    setSelectedBatchData([]);

    console.log("newItems", newItems);

    setForAddBatchData([]);
    handleAllTheTotalValues();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [batchData, triggerBatchData]);

  const handleRowClick = (index: number) => {
    setClickedIndex(index);
  };

  const filterSerial = serial?.filter((itm) => itm !== undefined);

  // useEffect(() => {
  //   const mergedSerialData = [
  //     ...(serialNoData || []),
  //     ...(forAddSerialData || []),
  //   ];
  //   console.log("forAddSerialData", forAddSerialData);
  //   console.log("serialNoData", serialNoData);

  //   if (mergedSerialData?.length && clickedIndex !== null) {
  //     const validItems = mergedSerialData?.filter(
  //       (itm: any) => itm !== undefined
  //     );
  //     const currentValues = form.getFieldValue("items") || [];
  //     if (!currentValues[clickedIndex]) {
  //       currentValues[clickedIndex] = { amount: {} };
  //     }
  //     currentValues[clickedIndex].amount.qty = validItems?.length;
  //     currentValues[clickedIndex].serialItem = validItems;
  //     form.setFieldsValue({ items: currentValues });
  //     setSerialNoData([]);
  //     setSelectedBatchData([]);
  //     setBatchData([]);
  //     setSerial(currentValues[clickedIndex].serialItem);
  //     setForAddSerialData([]);
  //   }
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [triggerSerialData]);

  // useEffect(() => {
  //   const getAllData = form?.getFieldValue(["items"]) || [];
  //   console.log("getAllData", getAllData);

  //   const updatedData = getAllData.map((item: any, idx: number) =>
  //     idx === clickedIndex ? { ...item, batchItem: [] } : item
  //   );
  //   form.setFieldsValue({ items: updatedData });
  //   console.log("updatedData", updatedData);

  //   const flatBatch = updatedData?.flatMap(
  //     (item: any) => item?.batchItem || []
  //   );

  //   const batchQtyObj = flatBatch?.reduce((acc: any, batchItem: any) => {
  //     const batchId = batchItem?.id ? Number(batchItem.id) : 0;
  //     const batchNumber = batchItem?.batchNumber;
  //     const qty = batchItem?.qty ? Number(batchItem.qty) : 0;

  //     if (!isNaN(batchId) && batchNumber) {
  //       const key = `${batchId}-${batchNumber}`;
  //       acc[key] = acc[key] || { id: batchId, batchNumber, qty: 0 };
  //       acc[key].qty += qty;
  //     }

  //     return acc;
  //   }, {});
  //   const batchQtyMap = Object.values(batchQtyObj);
  //   console.log("Final Batch Qty Map:", batchQtyMap);

  //   setFinalBatchQty(batchQtyMap);

  //   // setBatchQty(batchQtyObj);
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [index, form]);

  // get currency list
  useEffect(() => {
    const getCurrencyList = async (
      clientId: string,
      start: number,
      length: number
    ) => {
      await CurrencyServices.getCurrencyList(clientId, start, length)
        .then((res: any) => {
          if (res.result?.items?.length > 0) {
            let data = res.result.items?.map((v: any, i: any) => {
              return {
                label: v?.country?.name,
                value: v?.id,
              };
            });

            setCurrencyList(data);
            // setLoading(false);
          }
        })
        .catch((ex: any) => {
          console.error(ex.message);
          // setLoading(false);
          setCurrencyList([]);
        });
    };

    if (currentClient?.id) {
      getCurrencyList(currentClient?.id, 0, 0);
    }
  }, [currentClient?.id, partyIsGstRegistered]);

  // console.log("settingControl", settingControl);

  const permissionPartyAdd =
    splitPathInVchType === Voucher_Type.SalesVoucher
      ? findUserOnlyOnePremission(
          "Master.Ledger.Customer.Add",
          clientSpecificRole(),
          currentClient?.id
        )
      : findUserOnlyOnePremission(
          "Master.Ledger.Suppliers.Add",
          clientSpecificRole(),
          currentClient?.id
        );

  const permissionBillLedgerAdd =
    splitPathInVchType === Voucher_Type.SalesVoucher
      ? findUserOnlyOnePremission(
          "Master.Ledger.Sales.Add",
          clientSpecificRole(),
          currentClient?.id
        )
      : findUserOnlyOnePremission(
          "Master.Ledger.Purchase.Add",
          clientSpecificRole(),
          currentClient?.id
        );

  const permissionItemAdd = findUserOnlyOnePremission(
    "Master.Item.Add",
    clientSpecificRole(),
    currentClient?.id
  );

  const permissionExpensesAdd = findUserOnlyOnePremission(
    "Master.Ledger.Expenses.Add",
    clientSpecificRole(),
    currentClient?.id
  );

  const permissionCashAdd = findUserOnlyOnePremission(
    "Master.Ledger.Cash.Add",
    clientSpecificRole(),
    currentClient?.id
  );

  const permissionBankAdd = findUserOnlyOnePremission(
    "Master.Ledger.Bank.Add",
    clientSpecificRole(),
    currentClient?.id
  );

  const saveIndexAssetItems = (itemData: any) => {
    console.log("itemData", itemData);
    const itemList = form.getFieldValue("items");
    const currentIndexData = itemList[itemData.index];

    const qty = Utils.getNumber(itemData?.footerTotal?.qty);
    const price = Utils.getNumber(itemData?.footerTotal?.amount);
    const itemTaxAmt = price * (taxRate(currentIndexData) / 100);
    const data = {
      ...currentIndexData,
      selectedInvDetail: itemData?.selectedInvDetail,
      amount: {
        ...currentIndexData.amount,
        qty: qty,
        price: price,
        // itemTaxAmt:
        //   (partyIsGstRegisteredSalesInvoice === CompanyGSTTypes.Overseas ||
        //     partyIsGstRegisteredSalesInvoice === CompanyGSTTypes.SEZ) &&
        // // underLUT &&
        //   splitPathInVchType === Voucher_Type.SalesVoucher
        //     ? 0
        //     : itemTaxAmt(currentIndexData),
        itemTaxAmt:
          (partyIsGstRegisteredSalesInvoice === CompanyGSTTypes.Overseas ||
            partyIsGstRegisteredSalesInvoice === CompanyGSTTypes.SEZ) &&
          splitPathInVchType === Voucher_Type.SalesVoucher
            ? 0
            : itemTaxAmt,

        totalAmount:
          (partyIsGstRegisteredSalesInvoice === CompanyGSTTypes.Overseas ||
            partyIsGstRegisteredSalesInvoice === CompanyGSTTypes.SEZ) &&
          // underLUT &&
          splitPathInVchType === Voucher_Type.SalesVoucher
            ? price
            : price + itemTaxAmt,
        hideTax:
          currentClient?.gstType === CompanyGSTTypes.Regular ||
          updateTimeData.isGSTVoucher ||
          splitPathInVchType !== Voucher_Type.SalesVoucher
            ? {
                value:
                  currentIndexData.amount?.tax?.value ??
                  currentIndexData.amount?.hideTax?.value,
                label:
                  currentIndexData.amount?.tax?.label ??
                  currentIndexData.amount?.hideTax?.label,
                title:
                  currentIndexData.amount?.tax?.title ??
                  currentIndexData.amount?.hideTax?.title,
              }
            : null,
      },
    };
    form.setFieldValue(["items", itemData.index], data);
    handleAllTheTotalValues();
  };

  return (
    <>
      {/* <Col span={20}> */}
      <Layout>
        <Header
          style={{
            background: "#fff",
            top: 0,
            width: "101.6%",
            margin: "0px -14px",
            zIndex: 999,
            height: "45px",
            lineHeight: "45px",
            padding: "0px 24px",
          }}
        >
          <Row justify="space-between">
            <Col>
              <Row gutter={10}>
                <Col className="fs-20 fw-200" style={{ marginRight: "20px" }}>
                  <span style={{ color: themeData.themeData?.themeColor }}>
                    {settingControl?.title}{" "}
                  </span>

                  <Dropdown
                    //overlay={itemsabc}
                    menu={{
                      items:
                        splitPathInVchType === Voucher_Type.SalesVoucher
                          ? AssetDropdownItems()
                          : PurchaseDropdownItems(),
                      selectable: true,
                      defaultSelectedKeys: ["1"],
                    }}
                    trigger={["click"]}
                    autoFocus={true}
                  >
                    <Typography.Link>
                      <Space>
                        <DownOutlined />
                      </Space>
                    </Typography.Link>
                  </Dropdown>
                </Col>

                <Col>
                  <Radio.Group buttonStyle="solid" value={isCashVoucher}>
                    <Radio.Button
                      disabled={isLocked}
                      value={false}
                      onChange={(e) => {
                        setIsCashVoucher(e?.target?.value);

                        if (
                          (updateId || cloneId || draftId) &&
                          editInvBankDetails?.length < 0
                        ) {
                          form.setFieldValue("bankDts", [{}]);
                          setBankAccountAmt(0);
                        } else if (
                          !(updateId || cloneId || draftId) &&
                          !settingControl?.showReceipt
                        ) {
                          form.setFieldValue("bankDts", [{}]);
                          setBankAccountAmt(0);
                        }
                      }}
                    >
                      Credit
                    </Radio.Button>
                    <Radio.Button
                      disabled={isLocked}
                      value={true}
                      onChange={(e) => {
                        setIsCashVoucher(e?.target?.value);
                      }}
                    >
                      Cash
                    </Radio.Button>
                  </Radio.Group>
                </Col>
              </Row>
            </Col>
            <Col>
              <div>
                <Select
                  disabled={isLocked}
                  style={{ width: "180px", marginRight: "6px" }}
                  options={findVoucharCustomizationTemplete(
                    SettingsSections.Asset,
                    companySettings?.setting?.vouchersSettings,
                    IAssetsType.Disposed
                  )}
                  value={selectCustomizationTemplete?.templateId.toString()}
                  onChange={(e: string) => {
                    let selVoucherTemplate =
                      companySettings?.setting?.vouchersSettings?.find(
                        (vchTemp: vouchersSettings) =>
                          vchTemp.id === Utils.getNumber(e)
                      );
                    setSelectCustomizationTemplete({
                      title:
                        splitPathInVchType === Voucher_Type.SalesVoucher
                          ? selVoucherTemplate?.settings?.invoiceSettings
                              ?.titleToBePrint
                          : selVoucherTemplate?.settings?.billSettings
                              ?.titleToBePrint,
                      templateId: selVoucherTemplate?.id!,
                    });
                    // setDefaultEffectedAccount(Utils.getNumber(e));
                  }}
                />

                {
                  // splitPathInVchType === Voucher_Type.PurchaseVoucher &&
                  <>
                    <Select
                      style={{ width: "200px", marginRight: "10px" }}
                      disabled={
                        isLocked ||
                        settingControl.defaultNature !==
                          Voucher_Nature.Regular ||
                        voucherNature === Voucher_Nature.DeemedExport ||
                        voucherNature === Voucher_Nature.ImportExport ||
                        voucherNature === Voucher_Nature.SEZ
                      }
                      options={
                        settingControl.defaultNature !==
                          Voucher_Nature.Regular &&
                        voucherNature === settingControl.defaultNature
                          ? voucherNatureOptions.filter(
                              (vNature: any) =>
                                vNature.value === settingControl.defaultNature
                            )
                          : (settingControl.showRCM ||
                              updateTimeData.showRCM) &&
                            voucherNature !== Voucher_Nature.DeemedExport &&
                            voucherNature !== Voucher_Nature.ImportExport &&
                            voucherNature !== Voucher_Nature.SEZ
                          ? voucherNatureOptions.filter(
                              (vNature: any) =>
                                vNature.value !== Voucher_Nature.DeemedExport &&
                                vNature.value !== Voucher_Nature.ImportExport &&
                                vNature.value !== Voucher_Nature.SEZ
                            )
                          : voucherNatureOptions.filter(
                              (vNature: any) => vNature.value === voucherNature
                            )
                      }
                      defaultValue={Voucher_Nature.Regular}
                      value={voucherNature}
                      onChange={(e: Voucher_Nature) => {
                        // console.log(e);
                        setVoucherNature(e);
                        const roundOffAmount = handleRoundoff(
                          e === Voucher_Nature.RCM
                            ? footerTotal.taxableAmount +
                                footerLedger.ledgerAmount -
                                footerTotal.discount -
                                cashDiscountRs
                            : footerTotal.amount +
                                footerLedger.ledgerTotalAmount -
                                cashDiscountRs,
                          form.getFieldValue("roundoffCheckbox"),
                          settingControl.roundOffType
                        );

                        form.setFieldValue("roundOff", roundOffAmount);
                        setRoundoffAmount(roundOffAmount);
                      }}
                    />
                  </>
                  //
                }
              </div>
            </Col>
          </Row>
        </Header>

        <Content>
          <div
            style={{
              maxHeight: "78vh",
              overflowY: "scroll",
              overflowX: "hidden",
              padding: "10px",
            }}
          >
            <Spin spinning={loading} indicator={<LoadingOutlined />}>
              <div>
                <>
                  <Form
                    labelAlign="left"
                    labelCol={{ lg: 8, xs: 24, sm: 7 }}
                    wrapperCol={{ lg: 15, xs: 24, sm: 16 }}
                    requiredMark={true}
                    form={form}
                    disabled={isLocked}
                    autoComplete="off"
                    name="salesInvoice"
                    // requiredMark={false}
                    initialValues={{
                      supplyState: currentCustomerState,
                      roundoffCheckbox: settingControl.autoRoundOff,

                      showFreightInsLedgers: showFreightInsurance,
                      // isPurchaseJVVoucher: false,
                      underLUT: false,
                      items: [
                        {
                          itcEligibilityType:
                            splitPathInVchType === Voucher_Type.PurchaseVoucher
                              ? ITCEligibility_Type.Available
                              : null,
                          amount: { price: 0.0, qty: 0, totalAmount: 0 },
                        },
                      ],
                      cashDiscountDrop: DiscountType.PercentageDiscount,
                      freightInsLedgers: [
                        {
                          gstAmount: 0,
                          totalAmount: 0,
                          itcEligibilityType:
                            splitPathInVchType === Voucher_Type.PurchaseVoucher
                              ? ITCEligibility_Type.Available
                              : null,
                          // amount: 0,
                        },
                      ],
                      // bankDts: location.state?.ledgerId
                      //   ? [
                      //       {
                      //         name: {
                      //           value: location.state?.ledgerId,
                      //         },
                      //         amount:
                      //           location?.state?.BankTransactionData?.moneyIn ||
                      //           location?.state?.BankTransactionData?.moneyOut,
                      //         date:
                      //       },
                      //     ]
                      //   : [{}],

                      bankDts: [{}],
                    }}
                  >
                    <Row
                      justify={"space-between"}
                      style={{ width: "101.3%", overflowY: "scroll" }}
                    >
                      <Col xxl={8} xl={8} lg={12} sm={24}>
                        <Form.Item
                          name="partyLedger"
                          className="mb-3"
                          label={
                            <>
                              <span>Party</span>
                              <span
                                style={{
                                  paddingLeft: "14px",
                                  paddingTop: "2px",
                                }}
                              >
                                {selectedParty && (
                                  <Col
                                    className="fw-500"
                                    style={{
                                      marginLeft: "20px",
                                      marginTop: "3px",
                                    }}
                                  >
                                    <div
                                      style={{
                                        textAlign: "end",
                                        paddingRight: "17px",
                                      }}
                                    >
                                      <Tooltip title="View Party">
                                        <EyeOutlined
                                          onClick={() => {
                                            setApiCallField("New Supplier");
                                            setEditParty({
                                              id: selectedParty,
                                            });
                                            setOpenModel({
                                              type: "addLedger",
                                              param: {
                                                open: true,
                                                ledgerByGroupsType:
                                                  SearchLedgerByGroupsTypes.PartiesOnly,
                                                showName: "Party",
                                              },
                                            });
                                          }}
                                        />
                                      </Tooltip>
                                    </div>
                                  </Col>
                                )}
                              </span>
                            </>
                          }
                          rules={[
                            {
                              required: !isCashVoucher,
                              message: "Select a party",
                            },
                          ]}
                        >
                          <Select
                            ref={inputRef}
                            loading={partyDropDownLoading}
                            showSearch
                            allowClear
                            labelInValue
                            optionFilterProp="children"
                            placeholder="Party's name"
                            style={{ width: "100%" }}
                            disabled={
                              isLocked ||
                              salesOrderId ||
                              purchaseOrderId ||
                              quotationId
                                ? true
                                : false
                            }
                            // loading
                            autoFocus={true}
                            filterOption={(input, option) =>
                              (option?.label?.toString() ?? "")
                                .toLowerCase()
                                .includes(input.toLowerCase())
                            }
                            onChange={(e: any) => {
                              const party = customerOptions.find(
                                (x: ILedgerSearchByGroupNameResponse) =>
                                  x.id === e?.value
                              );
                              if (!e) {
                                setSelectedParty("");
                                setPurchaseOrderRef(null);
                                setPartyIsGstRegisteredSalesInvoiceTrigger(
                                  (x) => x + 1
                                );
                                setPartyIsGstRegisteredSalesInvoice(
                                  CompanyGSTTypes.Regular
                                );
                              }
                              let PanType: PanCardType;
                              if (party?.pan) {
                                if (
                                  party?.pan?.split("")[3]?.toUpperCase() ===
                                    "H" ||
                                  party?.pan?.split("")[3]?.toUpperCase() ===
                                    "P"
                                ) {
                                  PanType = PanCardType.HUF;
                                } else {
                                  PanType = PanCardType.Other;
                                }
                              } else {
                                PanType = PanCardType.notAvailable;
                              }
                              setPartyPanCard(PanType);

                              if (form.getFieldValue("tdsDetail")?.value) {
                                handleAllTheTotalValues(tdsOrTcs, PanType);
                              }

                              form.setFieldValue(
                                ["shippingAddress", "address"],
                                ""
                              );
                              form.setFieldValue(
                                ["shippingAddress", "type"],
                                ""
                              );
                              setIsPartTDSOrTDS({
                                tds: party?.deductTDSinSameVoucher,
                                tcs: party?.ledgerTCSApplicability,
                              });
                              setTdsOrTcs(
                                party?.ledgerTCSApplicability ? 1 : 0
                              );

                              // Party Wise Tcs & Tds condition
                              if (party?.ledgerTCSApplicability) {
                                setTotalTcs(totalTcs);
                                setTcsTdsPercentage(tcsTdsPercentage);

                                form.setFieldValue(
                                  "tcsDetail",
                                  form.getFieldValue("tcsDetail")
                                );
                                setTotalTds(0);
                                handleAllTheTotalValues();
                              } else if (party?.tdsDeductible) {
                                // &&
                                // settingControl?.showTcsTds
                                setTotalTcs(0);
                                setTotalTds(totalTds);
                                setTcsTdsPercentage(tcsTdsPercentage);
                                // setTdsPostDetail({
                                //   formNo: tdsSelect.form,
                                //   transactionType: tdsSelect.transactionType,
                                // });
                                form.setFieldValue(
                                  "tdsDetail",
                                  form.getFieldValue("tdsDetail")
                                );
                                handleAllTheTotalValues();
                              } else {
                                setTotalTds(0);
                                setTotalTcs(0);
                                // form.setFieldValue("tdsDetail", {});
                                // setTcsTdsPercentage(0);
                              }
                              CustomerSelect(e?.value);
                            }}
                            options={customerOptions?.map(
                              (value: ILedgerSearchByGroupNameResponse) => ({
                                value: value?.id,
                                label: value?.ledgerName.concat(
                                  value?.aliasName
                                    ? `${" (" + value?.aliasName + ")"}`
                                    : ""
                                ),
                                title: "",
                              })
                            )}
                            dropdownRender={(customerOptions) => (
                              <>
                                {customerOptions}
                                <>
                                  {permissionPartyAdd && (
                                    <>
                                      <Divider style={{ margin: "5px 0px" }} />
                                      <Button
                                        style={{ width: "100%" }}
                                        icon={<PlusOutlined />}
                                        type="link"
                                        onClick={() => {
                                          setEditParty({ id: "" });
                                          setApiCallField("New Supplier");
                                          setOpenModel({
                                            type: "addLedger",
                                            param: {
                                              open: true,
                                              defaultGroup:
                                                splitPathInVchType ===
                                                Voucher_Type.SalesVoucher
                                                  ? {
                                                      id: "6603afaa99242bad67d446cd",
                                                      ledgerName:
                                                        "Trade Receivables - Sundry Debtors",
                                                      parent:
                                                        "65af9ce61a48db26effbb598",
                                                    }
                                                  : {
                                                      id: "6603afe599242bad67d446d3",
                                                      ledgerName:
                                                        "Trade Payables - Sundry Creditors",
                                                      parent:
                                                        "65af9df71a48db26effbb5a3",
                                                    },
                                              ledgerByGroupsType:
                                                splitPathInVchType ===
                                                Voucher_Type.SalesVoucher
                                                  ? SearchLedgerByGroupsTypes.DebtorsOnly
                                                  : SearchLedgerByGroupsTypes.CreditorsOnly,
                                              showName:
                                                splitPathInVchType ===
                                                Voucher_Type.SalesVoucher
                                                  ? "Customer"
                                                  : "Supplier",
                                            },
                                          });
                                        }}
                                      >
                                        {splitPathInVchType ===
                                        Voucher_Type.SalesVoucher
                                          ? "Customer"
                                          : "Supplier"}
                                      </Button>
                                    </>
                                  )}
                                </>
                              </>
                            )}
                          />
                        </Form.Item>
                        {(selectedParty ||
                          updateId ||
                          cloneId ||
                          draftId ||
                          salesOrderId ||
                          quotationId ||
                          proformaInvoiceId ||
                          purchaseOrderId) &&
                          (!isPartyCompany ? (
                            <>
                              <Form.Item
                                name={["billingAddress", "address"]}
                                label="Billing Address"
                                className="mb-3"
                                style={{ paddingTop: "4px" }}
                              >
                                <TextArea
                                  placeholder="Billing address"
                                  autoSize={{ minRows: 2, maxRows: 6 }}
                                  onBlur={() => {
                                    if (isSameBillingAddress) {
                                      form.setFieldValue(
                                        ["shippingAddress", "type"],
                                        form.getFieldValue([
                                          "billingAddress",
                                          "type",
                                        ])
                                      );

                                      form.setFieldValue(
                                        ["shippingAddress", "address"],
                                        form.getFieldValue([
                                          "billingAddress",
                                          "address",
                                        ])
                                      );
                                    }
                                  }}
                                />
                              </Form.Item>
                              {(settingControl.showShippingAddress ||
                                updateTimeData.shippingAddress) && (
                                <Form.Item
                                  name={["shippingAddress", "address"]}
                                  label={
                                    <>
                                      <span>Shipping Address</span>
                                      <Tooltip title="Same as Billing address">
                                        <span style={{ paddingLeft: "10px" }}>
                                          <Checkbox
                                            // className="checkBox-custom"
                                            checked={isSameBillingAddress}
                                            onChange={(e) => {
                                              setIsSameBillingAddress(
                                                e.target.checked
                                              );
                                              if (e.target.checked) {
                                                form.setFieldValue(
                                                  ["shippingAddress", "type"],
                                                  form.getFieldValue([
                                                    "billingAddress",
                                                    "type",
                                                  ])
                                                );

                                                form.setFieldValue(
                                                  [
                                                    "shippingAddress",
                                                    "address",
                                                  ],
                                                  form.getFieldValue([
                                                    "billingAddress",
                                                    "address",
                                                  ])
                                                );
                                              }
                                            }}
                                          />
                                        </span>
                                      </Tooltip>
                                    </>
                                  }
                                  className="mb-3"
                                >
                                  <TextArea
                                    autoSize={{ minRows: 2, maxRows: 6 }}
                                    placeholder="Shipping address"
                                    disabled={isLocked || isSameBillingAddress}
                                  />
                                </Form.Item>
                              )}
                            </>
                          ) : (
                            <>
                              <Form.Item
                                name={["billingAddress", "type"]}
                                className="inputBoxMb"
                                label="Billing Address Name"
                              >
                                <Select
                                  showSearch
                                  allowClear
                                  optionFilterProp="children"
                                  placeholder="Select type"
                                  filterOption={false}
                                  className="selectedItem"
                                  labelInValue
                                  options={customerAddress?.map(
                                    (x: any, index: number) => ({
                                      value: x?.addressName,
                                      label: x?.addressName,
                                      title: x?.type,
                                      key: index,
                                    })
                                  )}
                                  onChange={(e: any) =>
                                    customerAddSelect(
                                      e.value,
                                      e.title,
                                      AddressEnum.BillingAddress,
                                      []
                                    )
                                  }
                                />
                              </Form.Item>
                              <Form.Item
                                name={["billingAddress", "address"]}
                                className="inputBoxMb"
                                label="Address"
                                style={{ paddingTop: "4px" }}
                              >
                                <TextArea
                                  placeholder="Billing address"
                                  rows={3}
                                  autoSize={{ minRows: 2, maxRows: 6 }}
                                  onBlur={() => {
                                    if (isSameBillingAddress) {
                                      form.setFieldValue(
                                        ["shippingAddress", "type"],
                                        form.getFieldValue([
                                          "billingAddress",
                                          "type",
                                        ])
                                      );

                                      form.setFieldValue(
                                        ["shippingAddress", "address"],
                                        form.getFieldValue([
                                          "billingAddress",
                                          "address",
                                        ])
                                      );
                                    }
                                  }}
                                />
                              </Form.Item>

                              {/* Shipping Address TextArea */}
                              {(settingControl.showShippingAddress ||
                                updateTimeData.shippingAddress) && (
                                <>
                                  <Row>
                                    <Col span={8}>
                                      <span>Shipping Address</span>
                                    </Col>
                                    <Col
                                      span={16}
                                      style={{ justifyContent: "end" }}
                                    >
                                      <Tooltip title="Same as Billing address">
                                        <span>
                                          <Checkbox
                                            checked={isSameBillingAddress}
                                            onChange={(e) => {
                                              setIsSameBillingAddress(
                                                e.target.checked
                                              );
                                              if (e.target.checked) {
                                                form.setFieldValue(
                                                  ["shippingAddress", "type"],
                                                  form.getFieldValue([
                                                    "billingAddress",
                                                    "type",
                                                  ])
                                                );

                                                form.setFieldValue(
                                                  [
                                                    "shippingAddress",
                                                    "address",
                                                  ],
                                                  form.getFieldValue([
                                                    "billingAddress",
                                                    "address",
                                                  ])
                                                );
                                              }
                                            }}
                                          />
                                        </span>
                                      </Tooltip>
                                    </Col>
                                  </Row>
                                  <Form.Item
                                    name={["shippingAddress", "type"]}
                                    className="inputBoxMb"
                                    label="Address Name"
                                  >
                                    <Select
                                      disabled={
                                        isLocked ||
                                        (isSameBillingAddress && true)
                                      }
                                      showSearch
                                      allowClear
                                      optionFilterProp="children"
                                      placeholder="Select type"
                                      filterOption={false}
                                      className="selectedItem"
                                      labelInValue
                                      options={customerAddress?.map(
                                        (x: any, index: number) => ({
                                          value: x?.addressName,
                                          label: x?.addressName,
                                          title: x?.type,
                                          key: index,
                                        })
                                      )}
                                      onChange={(e: any) =>
                                        customerAddSelect(
                                          e.value,
                                          e.title,
                                          AddressEnum.ShippingAddress,
                                          []
                                        )
                                      }
                                    />
                                  </Form.Item>
                                  <Form.Item
                                    label="Address"
                                    name={["shippingAddress", "address"]}
                                    className="inputBoxMb"
                                    style={{ paddingTop: "4px" }}
                                  >
                                    <TextArea
                                      autoSize={{
                                        minRows: 2,
                                        maxRows: 6,
                                      }}
                                      placeholder="Shipping address"
                                      disabled={
                                        isLocked ||
                                        (isSameBillingAddress && true)
                                      }
                                    />
                                  </Form.Item>
                                </>
                              )}
                            </>
                          ))}
                      </Col>
                      <Col xxl={8} xl={8} lg={12} sm={24}>
                        <Form.Item
                          name="number"
                          label={
                            <>
                              <span>
                                {splitPathInVchType ===
                                Voucher_Type.SalesVoucher
                                  ? " Invoice No. "
                                  : "Bill No. "}
                              </span>
                              <span
                                style={{
                                  paddingLeft: "12px",
                                  cursor: "pointer",
                                }}
                              >
                                {" "}
                                <ReloadOutlined
                                  onClick={() =>
                                    setRefreshNumber(!refreshNumber)
                                  }
                                  style={{ fontSize: "12px" }}
                                />
                              </span>
                            </>
                          }
                          style={{ width: "100%" }}
                          className="mb-3"
                          rules={[
                            {
                              required: true,
                              message: "Please enter invoice No.",
                            },
                          ]}
                        >
                          {voucherNumberLoader ? (
                            <Skeleton.Input
                              active={true}
                              size="default"
                              block={false}
                              className="responsive-skeleton-input"
                              style={{ width: "100%" }}
                            />
                          ) : (
                            <Input
                              disabled
                              value="Invoice No."
                              style={{
                                width: "100%",
                                backgroundColor: `${themeData.themeData?.themeColor}40`,
                              }}
                            />
                          )}
                        </Form.Item>

                        {splitPathInVchType ===
                          Voucher_Type.PurchaseVoucher && (
                          <>
                            <Form.Item
                              label="Invoice Ref. No."
                              name="supplierInvoiceRef"
                              className="mb-3"
                            >
                              <Input />
                            </Form.Item>

                            <Form.Item
                              name="supplierInvoiceDate"
                              label="Invoice Ref. Date"
                              className="mb-3"
                            >
                              <DatePicker
                                format="DD/MM/YYYY"
                                style={{ width: "100%" }}
                                allowClear={true}
                                disabledDate={(current: any) =>
                                  current <
                                    dayjs(currentClient?.financialYearBegin) ||
                                  current >=
                                    dayjs(
                                      currentClient?.financialYearBegin
                                    ).add(2, "year")
                                }
                              />
                            </Form.Item>
                          </>
                        )}
                        {/* <Form.Item
                          name="effectiveLedger"
                          label={
                            <>
                              <span>
                                {splitPathInVchType ===
                                Voucher_Type.SalesVoucher
                                  ? "Sales Ledger"
                                  : "Purchase Ledger"}
                              </span>
                            </>
                          }
                          className="mb-3"
                          rules={[
                            {
                              required: mode ? false : true,
                              message: `Please select ${
                                splitPathInVchType === Voucher_Type.SalesVoucher
                                  ? "sales ledger"
                                  : "purchase ledger"
                              }`,
                            },
                          ]}
                        >
                          <Select
                            disabled={isLocked || mode}
                            loading={ledgerDropDownLoading}
                            labelInValue
                            showSearch
                            allowClear={false}
                            placeholder="Select ledger"
                            placement="bottomLeft"
                            optionFilterProp="children"
                            filterOption={(input, option) =>
                              (option?.label?.toString() ?? "")
                                .toLowerCase()
                                .includes(input.toLowerCase())
                            }
                            options={effectiveLedger?.map((x: any) => ({
                              value: x?.id,
                              label: x?.ledgerName.concat(
                                x?.aliasName
                                  ? `${" (" + x?.aliasName + ")"}`
                                  : ""
                              ),
                            }))}
                            dropdownRender={(effectiveLedgerOptions) => (
                              <>
                                {effectiveLedgerOptions}
                                {permissionBillLedgerAdd && (
                                  <>
                                    <Divider />
                                    <Button
                                      style={{ width: "100%" }}
                                      icon={<PlusOutlined />}
                                      type="link"
                                      onClick={() => {
                                        setEditParty({ id: "" });
                                        setOpenModel({
                                          type: "addLedger",
                                          param: {
                                            open: true,
                                            defaultGroup:
                                              splitPathInVchType ===
                                              Voucher_Type.SalesVoucher
                                                ? {
                                                    id: "6603b14799242bad67d446ee",
                                                    ledgerName:
                                                      "Domestic Sales",
                                                    parent:
                                                      "65af9be21a48db26effbb591",
                                                  }
                                                : {
                                                    id: "6603b13f99242bad67d446ed",
                                                    ledgerName:
                                                      "Domestic Purchases",
                                                    parent:
                                                      "65af9b7d1a48db26effbb58e",
                                                  },
                                            ledgerByGroupsType:
                                              splitPathInVchType ===
                                              Voucher_Type.SalesVoucher
                                                ? SearchLedgerByGroupsTypes.Sales
                                                : SearchLedgerByGroupsTypes.Purchase,
                                            showName:
                                              splitPathInVchType ===
                                              Voucher_Type.SalesVoucher
                                                ? "Sale"
                                                : "Purchase",
                                          },
                                        });
                                      }}
                                    >
                                      New Ledger
                                    </Button>
                                  </>
                                )}
                              </>
                            )}
                          />
                        </Form.Item> */}
                        {((splitPathInVchType === Voucher_Type.SalesVoucher &&
                          partyIsGstRegisteredSalesInvoice !==
                            CompanyGSTTypes.Overseas) ||
                          (splitPathInVchType ===
                            Voucher_Type.PurchaseVoucher &&
                            partyIsGstRegistered !==
                              CompanyGSTTypes.Overseas)) && (
                          <Form.Item
                            name="supplyState"
                            className="mb-3"
                            label={
                              <>
                                <span>
                                  {splitPathInVchType ===
                                  Voucher_Type.SalesVoucher
                                    ? "Place of Supply"
                                    : "Origin of Supply"}
                                </span>
                              </>
                            }
                            rules={[
                              {
                                required: true,
                                message:
                                  splitPathInVchType ===
                                  Voucher_Type.SalesVoucher
                                    ? "Place of supply is required"
                                    : "Origin of supply is required",
                              },
                            ]}
                          >
                            <Select
                              showSearch
                              allowClear={false}
                              placeholder="Select State"
                              placement="bottomLeft"
                              optionFilterProp="children"
                              filterOption={(input, option) =>
                                (option?.label ?? "")
                                  .toLowerCase()
                                  .includes(input.toLowerCase())
                              }
                              onSelect={(val) => {
                                console.log("val", val);
                                setPurchasePartyState(val);
                              }}
                              options={Object?.entries(stateOptions)?.map(
                                ([key, x]: any) => ({
                                  value: x?.id,
                                  label: x?.name,
                                  title: "",
                                })
                              )}
                            />
                          </Form.Item>
                        )}

                        {/* {selectedParty && (
                          <Form.Item
                            name="purchaseOrderRef"
                            className="mb-3"
                            label={
                              <>
                                <span>
                                  {splitPathInVchType ===
                                  Voucher_Type.SalesVoucher
                                    ? "Sales Order No."
                                    : "Purchase Order No."}{" "}
                                </span>
                              </>
                            }
                          >
                            <Select
                              disabled={
                                isLocked ||
                                salesOrderId ||
                                quotationId ||
                                purchaseOrderId
                                  ? true
                                  : false
                              }
                              loading={orderDropDownLoading}
                              showSearch
                              allowClear
                              placeholder="Select "
                              placement="bottomLeft"
                              optionFilterProp="children"
                              filterOption={(input, option) =>
                                (option?.label ?? "")
                                  .toLowerCase()
                                  .includes(input.toLowerCase())
                              }
                              onChange={(e: any) => {
                                if (e === undefined || e === null) {
                                  setPurchaseOrderRef(e);
                                  setPurchaseOrderRefTrigger(0);
                                  form.setFieldValue("items", [
                                    {
                                      amount: {
                                        price: 0.0,
                                        qty: 0,
                                        totalAmount: 0,
                                      },
                                    },
                                  ]);
                                  form.setFieldValue("freightInsLedgers", [
                                    {
                                      // gstRate: 0,
                                      gstAmount: 0,
                                      totalAmount: 0,
                                      amount: 0,
                                    },
                                  ]);
                                  setFooterTotal({
                                    qty: 0,
                                    unitPrice: 0,
                                    taxableAmount: 0,
                                    discount: 0,
                                    gst: 0,
                                    amount: 0,
                                  });
                                  setFooterLedger({
                                    ledgerAmount: 0,
                                    ledgerGstAmount: 0,
                                    ledgerTotalAmount: 0,
                                  });
                                } else {
                                  setPurchaseOrderRef(e);
                                  setPurchaseOrderRefTrigger((x) => x + 1);
                                }
                              }}
                              options={orderListOptions?.map((x: any) => ({
                                value: x?.voucherId,
                                label: x?.voucherNumber,
                              }))}
                            />
                          </Form.Item>
                        )} */}
                        {(settingControl.showContactDetail ||
                          updateTimeData.contactDetails) && (
                          <>
                            <Form.Item
                              label="Contact Name"
                              name="contactName"
                              className="mb-3"
                            >
                              <Input />
                            </Form.Item>
                          </>
                        )}
                      </Col>

                      <Col xxl={8} xl={8} lg={12} sm={24}>
                        <Form.Item name="date" className="mb-3" label="Date">
                          <DatePicker
                            format="DD/MM/YYYY"
                            style={{ width: "100%" }}
                            allowClear={false}
                            disabledDate={(current: any) =>
                              purchaseOrderDate
                                ? current <
                                  dayjs(purchaseOrderDate).startOf("day")
                                : current <
                                    dayjs(currentClient?.financialYearBegin) ||
                                  current >=
                                    dayjs(
                                      currentClient?.financialYearBegin
                                    ).add(2, "year")
                            }
                            onChange={(val) => {
                              if (dueOnParty) {
                                form.setFieldValue(
                                  "dueDate",
                                  dayjs(val).add(dueOnParty, "d")
                                );
                              } else {
                                form.setFieldValue(
                                  "dueDate",
                                  dayjs(val).add(dueOnSetting, "d")
                                );
                              }
                              setDateFiled(dayjs(val).toISOString());
                            }}
                          />
                        </Form.Item>
                        <Form.Item
                          name="dueDate"
                          className="mb-3"
                          label="Due Date"
                        >
                          <DatePicker
                            disabledDate={(current) =>
                              // current &&
                              current <
                              form.getFieldValue("date")?.startOf("day")
                            }
                            allowClear={false}
                            format="DD/MM/YYYY"
                            style={{ width: "100%" }}
                            open={isOpenDueDate}
                            onOpenChange={(x) => setIsDueDate(x)}
                            // onBlur={() => setIsDueDate((x) => !x)}
                            // onClick={() => {
                            //   setIsDueDate((x) => !x);
                            // }}
                            onChange={() => setIsDueDate(false)}
                            // onChange={(e) =>
                            //   inputRef
                            //     ? setIsDueDate(false)
                            //     : setIsDueDate(true)
                            // }
                            presets={
                              windowWidth > 550
                                ? [
                                    {
                                      label: "Tomorrow",
                                      value: dayjs().add(1, "d"),
                                    },
                                    {
                                      label: "After 7 days",
                                      value: dayjs().add(7, "d"),
                                    },
                                    {
                                      label: "After 15 days",
                                      value: dayjs().add(15, "d"),
                                    },
                                    {
                                      label: "After 30 days",
                                      value: dayjs().add(30, "d"),
                                    },
                                    {
                                      label: "After 45 days",
                                      value: dayjs().add(45, "d"),
                                    },
                                    {
                                      label: "After 60 days",
                                      value: dayjs().add(60, "d"),
                                    },
                                    {
                                      label: "After 90 days",
                                      value: dayjs().add(90, "d"),
                                    },
                                    {
                                      label: "After 180 days",
                                      value: dayjs().add(180, "d"),
                                    },
                                  ]
                                : []
                            }
                            renderExtraFooter={() => (
                              <Space
                                style={{
                                  display: "flex",

                                  justifyContent: "space-around",
                                }}
                              >
                                <InputNumber
                                  placeholder="After"
                                  style={{ width: "60px" }}
                                  controls={false}
                                  onChange={(e) =>
                                    setPresetsDueDate({
                                      ...presetsDueDate,
                                      label: e,
                                    })
                                  }
                                  // onBlur={(e) => {
                                  //   e.relatedTarget === null
                                  //     ? setIsDueDate(false)
                                  //     : setIsDueDate(true);
                                  // }}
                                  onClick={() =>
                                    inputRef.current && inputRef.current.focus()
                                  }
                                  ref={inputRef}
                                />

                                <Select
                                  allowClear
                                  // onBlur={(e) => {
                                  //   e.relatedTarget === null
                                  //     ? setIsDueDate(false)
                                  //     : setIsDueDate(true);
                                  // }}
                                  style={{ width: "100px" }}
                                  onChange={(e: any) => {
                                    setPresetsDueDate({
                                      ...presetsDueDate,
                                      value: e,
                                    });
                                  }}
                                  options={[
                                    { value: "d", label: "Days", title: "" },
                                    { value: "w", label: "Weeks", title: "" },
                                    {
                                      value: "month",
                                      label: "Months",
                                      title: "",
                                    },
                                    {
                                      value: "year",
                                      label: "Years",
                                      title: "",
                                    },
                                  ]}
                                />

                                <Tooltip title="Save" placement="bottom">
                                  <Button
                                    type="primary"
                                    onClick={() => {
                                      setDueDateTrigger((x) => x + 1);
                                      setIsDueDate(false);
                                    }}
                                    icon={<SaveOutlined />}
                                  />
                                </Tooltip>
                                <Tooltip title="Cancel" placement="right">
                                  <Button
                                    onClick={() => {
                                      setIsDueDate(false);
                                    }}
                                    icon={<CloseOutlined />}
                                  />
                                </Tooltip>
                              </Space>
                            )}
                          />
                        </Form.Item>

                        {(partyIsGstRegistered === CompanyGSTTypes.Overseas ||
                          partyIsGstRegisteredSalesInvoice ===
                            CompanyGSTTypes.Overseas) && (
                          <Form.Item label="Export Details" className="mb-3">
                            <Button
                              icon={<PlusOutlined />}
                              style={{
                                width: "100%",
                                backgroundColor: "ButtonFace",
                              }}
                              onClick={() =>
                                setOpenModel({
                                  type: "addExportDetail",
                                  param: { open: true },
                                })
                              }
                            >
                              Export Details
                            </Button>
                          </Form.Item>
                        )}
                        {(partyIsGstRegistered === CompanyGSTTypes.Overseas ||
                          partyIsGstRegisteredSalesInvoice ===
                            CompanyGSTTypes.Overseas ||
                          partyIsGstRegistered === CompanyGSTTypes.SEZ ||
                          partyIsGstRegisteredSalesInvoice ===
                            CompanyGSTTypes.SEZ) && (
                          <>
                            <Form.Item
                              name="underLUT"
                              className="mb-3"
                              label="Under LUT"
                              valuePropName="checked"
                            >
                              <Checkbox
                                value={underLUT}
                                onChange={(e) => setUnderLUT(e.target.checked)}
                              />
                            </Form.Item>

                            <Form.Item
                              name="currency"
                              className="mb-3"
                              label="Currency"
                            >
                              <Select
                                allowClear
                                showSearch
                                filterOption={(input, option) =>
                                  (option?.label ?? "")
                                    .toLowerCase()
                                    .includes(input.toLowerCase())
                                }
                                options={currencyList}
                                onChange={(value, option) => {
                                  form.setFieldsValue({
                                    currency: {
                                      value: option.value,
                                      label: option.label,
                                    },
                                  });
                                }}
                              />
                            </Form.Item>

                            <Form.Item
                              name="conversionRate"
                              className="mb-3"
                              label="Conversion rate"
                            >
                              <InputNumber
                                controls={false}
                                precision={2}
                                style={{ width: "100%" }}
                                onFocus={(e) => {
                                  handleInputFocus(e, form);
                                }}
                                onKeyPress={handleDecimalValues}
                              />
                            </Form.Item>
                          </>
                        )}

                        {(settingControl.showDispatchDetail ||
                          updateTimeData.showDispatchDetail) && (
                          <Form.Item
                            label={
                              splitPathInVchType ===
                              Voucher_Type.PurchaseVoucher
                                ? "Receipt Note"
                                : "Despatch Details"
                            }
                            className="mb-3"
                          >
                            <Button
                              icon={<PlusOutlined />}
                              style={{
                                width: "100%",
                                backgroundColor: "ButtonFace",
                              }}
                              onClick={() =>
                                setOpenModel({
                                  type: "addDespatchDetail",
                                  param: { open: true },
                                })
                              }
                            >
                              {splitPathInVchType ===
                              Voucher_Type.PurchaseVoucher
                                ? "Add Receipt Note"
                                : " Add Despatch Details"}
                            </Button>
                          </Form.Item>
                        )}

                        {(settingControl.showContactDetail ||
                          updateTimeData.contactDetails) && (
                          <Form.Item
                            label="Phone No."
                            name="contactNo"
                            className="mb-3"
                            rules={[
                              {
                                min: 10,
                                max: 10,
                                message: "Phone No. must be 10 digits long",
                              },
                            ]}
                          >
                            <Input
                              placeholder="9876543210"
                              onKeyPress={(e) =>
                                !/[0-9]/.test(e.key) && e.preventDefault()
                              }
                            />
                          </Form.Item>
                        )}

                        {(settingControl.showFreightType ||
                          updateTimeData.showFreightType) && (
                          <Form.Item
                            name="freightType"
                            label="Freight Type"
                            className="mb-3"
                          >
                            <Select
                              // disabled={salesOrderId ? true : false}
                              allowClear
                              showSearch
                              filterOption={(input, option) =>
                                (option?.label ?? "")
                                  .toLowerCase()
                                  .includes(input.toLowerCase())
                              }
                              options={FreightTypeOptions}
                            />
                          </Form.Item>
                        )}
                      </Col>
                    </Row>

                    <div style={{ width: "100%" }}>
                      {/* Item Table */}
                      <div
                        // className="tableWrapper"
                        style={{ overflowY: "auto", marginTop: "0px" }}
                      >
                        <Row
                          style={{
                            marginTop: "15px",
                            width: "100%",
                            backgroundColor: "white",
                            padding: "3px 5px",
                            fontSize: "15px",
                            borderRadius: "8px",
                            fontWeight: "bolder",
                          }}
                        >
                          <Col style={{ alignContent: "center" }} span={12}>
                            <span>Item Detail</span>
                          </Col>

                          {/* {(settingControl.discountPolicy ===
                            Discount_Policy.TradenCashDiscount ||
                            settingControl.discountPolicy ===
                              Discount_Policy.OnlyTradeDiscount ||
                            updateTimeData.tradeDiscount) &&
                            !mode && (
                              <Col span={12}>
                                <Row gutter={6} justify={"end"}>
                                  <Col style={{ paddingTop: "4px" }}>
                                    <span>Discount (%)</span>
                                  </Col>

                                  <Col>
                                    <Form.Item
                                      className="discountInput inputBoxMb"
                                      name="discount"
                                    >
                                      <InputNumber
                                        placeholder="0.0"
                                        controls={false}
                                        min={0.0}
                                        max={100}
                                        precision={2}
                                        style={{
                                          width: "160px",
                                        }}
                                        onChange={(e: any) => {
                                          handleItemsAllDiscount(e);
                                        }}
                                        onFocus={(e) => {
                                          handleInputFocus(e, form);
                                        }}
                                        onKeyPress={handleDecimalValues}
                                      />
                                    </Form.Item>
                                  </Col>
                                </Row>
                              </Col>
                            )} */}
                        </Row>
                        <div>
                          <table
                            className="AddPageTabelDesign"
                            style={{
                              fontSize: windowWidth <= 1024 ? "10.3px" : "",
                              width: "100%",
                            }}
                          >
                            {mode ? (
                              <thead>
                                {" "}
                                <tr>
                                  <th rowSpan={1} style={{ width: "5%" }}>
                                    S.No.
                                  </th>
                                  <th
                                    rowSpan={2}
                                    style={{
                                      width: "30%",
                                      borderLeft:
                                        "1px solid rgb(240, 245, 255)",
                                    }}
                                  ></th>
                                  <th rowSpan={2} style={{ width: "9%" }}>
                                    Price
                                  </th>
                                  {((splitPathInVchType ===
                                    Voucher_Type.SalesVoucher &&
                                    (currentClient?.gstType ===
                                      CompanyGSTTypes.Regular ||
                                      updateTimeData.isGSTVoucher)) ||
                                    (splitPathInVchType !==
                                      Voucher_Type.SalesVoucher &&
                                      partyIsGstRegistered ===
                                        CompanyGSTTypes.Regular)) && (
                                    <th colSpan={2} style={{ width: "15%" }}>
                                      GST
                                    </th>
                                  )}
                                  <th
                                    colSpan={2}
                                    rowSpan={2}
                                    style={{
                                      width: "14%",
                                    }}
                                  >
                                    Gross Amount
                                  </th>
                                </tr>
                              </thead>
                            ) : (
                              <thead>
                                <tr>
                                  <th
                                    // colSpan={2}
                                    rowSpan={2}
                                    style={{ width: "5%" }}
                                  >
                                    S.No.
                                  </th>
                                  <th
                                    rowSpan={2}
                                    style={{
                                      width: "30%",
                                      borderLeft:
                                        "1px solid rgb(240, 245, 255)",
                                    }}
                                  >
                                    <Row
                                      justify={"space-between"}
                                      style={{ padding: "0px 5px" }}
                                    >
                                      <Col
                                        span={12}
                                        style={{ textAlign: "start" }}
                                      >
                                        <span>Item(s)</span>
                                      </Col>
                                      {itemSetting?.isBarcode && (
                                        <Col
                                          span={12}
                                          style={{ textAlign: "end" }}
                                        >
                                          <Checkbox
                                            onChange={(e) =>
                                              SetIsBarCodeSearch(
                                                e?.target?.checked
                                              )
                                            }
                                          >
                                            <Tooltip
                                              title={"Search by Bar Code"}
                                            >
                                              <BarcodeOutlined
                                                style={{
                                                  fontSize: "20px",
                                                  marginTop: "4px",
                                                }}
                                              />
                                            </Tooltip>{" "}
                                          </Checkbox>
                                        </Col>
                                      )}
                                    </Row>
                                  </th>
                                  {/* {(companySettings?.setting?.item
                                    ?.batchTracking ||
                                    companySettings?.setting?.item
                                      ?.serialTracking) && ( */}
                                  <th rowSpan={3} style={{ width: "3%" }}>
                                    Add
                                  </th>
                                  {/* )} */}
                                  <th rowSpan={3} style={{ width: "7%" }}>
                                    Qty
                                  </th>

                                  <th rowSpan={2} style={{ width: "9%" }}>
                                    Total Price
                                  </th>
                                  {/* {(settingControl.discountPolicy ===
                                    Discount_Policy.TradenCashDiscount ||
                                    settingControl.discountPolicy ===
                                      Discount_Policy.OnlyTradeDiscount ||
                                    updateTimeData.tradeDiscount) && (
                                    <th colSpan={2} style={{ width: "15%" }}>
                                      Discount
                                    </th>
                                  )} */}
                                  {((splitPathInVchType ===
                                    Voucher_Type.SalesVoucher &&
                                    (currentClient?.gstType ===
                                      CompanyGSTTypes.Regular ||
                                      updateTimeData.isGSTVoucher)) ||
                                    (splitPathInVchType !==
                                      Voucher_Type.SalesVoucher &&
                                      partyIsGstRegistered ===
                                        CompanyGSTTypes.Regular)) && (
                                    <th colSpan={2} style={{ width: "15%" }}>
                                      GST
                                    </th>
                                  )}
                                  <th
                                    colSpan={2}
                                    rowSpan={2}
                                    style={{
                                      width: "14%",
                                    }}
                                  >
                                    <Col span={13}>
                                      <span>Gross Amount</span>
                                    </Col>
                                  </th>
                                </tr>
                                {/* Discount */}
                                <tr>
                                  {/* {(settingControl.discountPolicy ===
                                    Discount_Policy.TradenCashDiscount ||
                                    settingControl.discountPolicy ===
                                      Discount_Policy.OnlyTradeDiscount ||
                                    updateTimeData.tradeDiscount) && (
                                    <>
                                      <th style={{ width: "5%" }}>%</th>
                                      <th style={{ width: "5%" }}>₹</th>
                                    </>
                                  )} */}
                                  {((splitPathInVchType ===
                                    Voucher_Type.SalesVoucher &&
                                    (currentClient?.gstType ===
                                      CompanyGSTTypes.Regular ||
                                      updateTimeData.isGSTVoucher)) ||
                                    (splitPathInVchType !==
                                      Voucher_Type.SalesVoucher &&
                                      partyIsGstRegistered ===
                                        CompanyGSTTypes.Regular)) && (
                                    <>
                                      <th style={{ width: "6%" }}>%</th>
                                      <th style={{ width: "6%" }}>₹</th>
                                    </>
                                  )}
                                </tr>
                              </thead>
                            )}

                            <tbody>
                              {!mode && (
                                <>
                                  <Form.List name="items">
                                    {(fields, { add, remove, move }) => {
                                      return (
                                        <>
                                          {confirmation && (
                                            <ConfirmationModal
                                              open={confirmation}
                                              text={`Do you really want to delete this item "${form.getFieldValue(
                                                [
                                                  "items",
                                                  deleteItemList,
                                                  "id",
                                                  "label",
                                                ]
                                              )}" ?`}
                                              // text="Do you really want to delete this row?"
                                              onNo={() =>
                                                setConfirmation(false)
                                              }
                                              onYes={() => {
                                                setSelectAssetItem((prev) => {
                                                  const newDisabledInputs = [
                                                    ...prev,
                                                  ];
                                                  newDisabledInputs.splice(
                                                    deleteItemList,
                                                    1
                                                  );
                                                  return newDisabledInputs;
                                                });
                                                remove(deleteItemList);
                                                handleDeleteRowButton();
                                                setItemLength(
                                                  fields?.length - 2
                                                );
                                              }}
                                            />
                                          )}

                                          {fields?.map(
                                            (
                                              { key, name, ...restField },
                                              index
                                            ) => {
                                              return (
                                                <tr key={key}>
                                                  <td
                                                    align="center"
                                                    style={{
                                                      verticalAlign: "top",
                                                    }}
                                                  >
                                                    {fields?.length !==
                                                      index + 1 && (
                                                      <div>{index + 1}.</div>
                                                    )}
                                                  </td>
                                                  {/* <td
                                                    align="center"
                                                    style={{
                                                      verticalAlign: "top",
                                                    }}
                                                  >
                                                    {fields.length !==
                                                      index + 1 &&
                                                      form?.getFieldValue([
                                                        "items",
                                                        name,
                                                      ])?.id?.value && (
                                                        <Form.Item
                                                          name={[
                                                            name,
                                                            "isService",
                                                          ]}
                                                          className="m-0"
                                                          {...restField}
                                                          wrapperCol={{
                                                            xl: 25,
                                                          }}
                                                        >
                                                          {form.getFieldValue([
                                                            "items",
                                                            index,
                                                            "isService",
                                                          ]) ? (
                                                            <Tooltip
                                                              title="Service"
                                                              placement="left"
                                                              color="#1d39c4"
                                                            >
                                                              <Avatar
                                                                style={{
                                                                  cursor:
                                                                    "pointer",
                                                                  verticalAlign:
                                                                    "middle",
                                                                  color:
                                                                    "#1d39c4",
                                                                  backgroundColor:
                                                                    "#f0f5ff",
                                                                  borderColor:
                                                                    "#adc6ff",
                                                                  fontWeight:
                                                                    "bold",
                                                                }}
                                                                size="small"
                                                              >
                                                                S
                                                              </Avatar>
                                                            </Tooltip>
                                                          ) : (
                                                            <Tooltip
                                                              title="Goods"
                                                              placement="left"
                                                              color="#389e0d"
                                                            >
                                                              <Avatar
                                                                style={{
                                                                  cursor:
                                                                    "pointer",
                                                                  verticalAlign:
                                                                    "middle",
                                                                  color:
                                                                    "#389e0d",
                                                                  backgroundColor:
                                                                    "#f6ffed",
                                                                  borderColor:
                                                                    "#b7eb8f",
                                                                  fontWeight:
                                                                    "bold",
                                                                }}
                                                                size="small"
                                                              >
                                                                G
                                                              </Avatar>
                                                            </Tooltip>
                                                            // </Row>
                                                          )}
                                                        </Form.Item>
                                                      )}

                                                   {fields.length !==
                                                      index + 1 &&
                                                      form?.getFieldValue([
                                                        "items",
                                                        name,
                                                      ])?.id?.value && (
                                                        <>
                                                          <Form.Item
                                                            name={[
                                                              name,
                                                              "isTaxable",
                                                            ]}
                                                            className="m-0"
                                                            {...restField}
                                                            wrapperCol={{
                                                              xl: 25,
                                                            }}
                                                          >
                                                            {form.getFieldValue(
                                                              [
                                                                "items",
                                                                index,
                                                                "isTaxable",
                                                              ]
                                                            ) ? (
                                                              <Tooltip
                                                                title="Inclusive Tax"
                                                                color="#08979C"
                                                              >
                                                                <Avatar
                                                                  style={{
                                                                    cursor:
                                                                      "pointer",
                                                                    verticalAlign:
                                                                      "middle",
                                                                    color:
                                                                      "#08979C",
                                                                    backgroundColor:
                                                                      "#E6FFFB",
                                                                    borderColor:
                                                                      "rgb(127 231 235)",
                                                                    fontWeight:
                                                                      "bold",
                                                                  }}
                                                                  size="small"
                                                                >
                                                                  IT
                                                                </Avatar>
                                                              </Tooltip>
                                                            ) : (
                                                              <Tooltip
                                                                title="Exclusive Tax"
                                                                color="#531DAB"
                                                              >
                                                                <Avatar
                                                                  style={{
                                                                    cursor:
                                                                      "pointer",
                                                                    textAlign:
                                                                      "center",
                                                                    color:
                                                                      "#531DAB",
                                                                    backgroundColor:
                                                                      "#F9F0FF",
                                                                    borderColor:
                                                                      "rgb(193 166 239)",
                                                                    fontWeight:
                                                                      "bold",
                                                                  }}
                                                                  size="small"
                                                                >
                                                                  ET
                                                                </Avatar>
                                                              </Tooltip>
                                                              // </Row>
                                                            )}
                                                          </Form.Item>
                                                        </>
                                                      )}
                                                  </td> */}
                                                  {/* Item(s)  */}
                                                  <td
                                                    style={{
                                                      verticalAlign: "top",
                                                    }}
                                                  >
                                                    <Form.Item
                                                      name={[name, "id"]}
                                                      className="m-0"
                                                      {...restField}
                                                      wrapperCol={{
                                                        xl: 25,
                                                      }}
                                                      rules={[
                                                        {
                                                          required:
                                                            name ===
                                                              fields.length -
                                                                1 &&
                                                            fields.length !== 1
                                                              ? false
                                                              : true,
                                                          message:
                                                            "Please select item!",
                                                        },
                                                      ]}
                                                    >
                                                      <Select
                                                        labelInValue
                                                        onSelect={(
                                                          selectedValue: any
                                                        ) => {
                                                          // const selectedItem =
                                                          //   itemsOption?.find(
                                                          //     (itm: any) =>
                                                          //       itm?.id ===
                                                          //       selectedValue
                                                          //   );
                                                          // setCheckedType(
                                                          //   selectedItem
                                                          // );
                                                          // setIndex(index);
                                                          // setBatchItmId(
                                                          //   selectedItem?.id
                                                          // );
                                                          // setItmData(
                                                          //   selectedItem
                                                          //     ?.serialItem
                                                          //     ?.length > 0
                                                          //     ? selectedItem?.serialItem
                                                          //     : selectedItem?.batchItem
                                                          // );
                                                          // splitPathInVchType ===
                                                          // Voucher_Type.PurchaseVoucher
                                                          //   ? setOpenModel({
                                                          //       type:
                                                          //         selectedItem?.trackingType ===
                                                          //         Item_Nature.Serial
                                                          //           ? "serialNo"
                                                          //           : selectedItem?.trackingType ===
                                                          //             Item_Nature.Batch
                                                          //           ? "batchItem"
                                                          //           : "",
                                                          //       param: {
                                                          //         open: true,
                                                          //       },
                                                          //     })
                                                          //   : setOpenModel({
                                                          //       type:
                                                          //         selectedItem
                                                          //           ?.serialItem
                                                          //           ?.length > 0
                                                          //           ? "serialNo"
                                                          //           : selectedItem
                                                          //               ?.batchItem
                                                          //               ?.length >
                                                          //             0
                                                          //           ? "batchItem"
                                                          //           : "",
                                                          //       param: {
                                                          //         open: true,
                                                          //       },
                                                          //     });
                                                        }}
                                                        bordered={false}
                                                        loading={
                                                          itemDropDownLoading
                                                        }
                                                        variant="filled"
                                                        className="variantFilledSelect"
                                                        onSearch={(e: any) => {
                                                          // debugger
                                                          if (isBarCodeSearch) {
                                                            setBarCodeSearch(e);
                                                          } else {
                                                            setItemSearch(e);
                                                          }
                                                        }}
                                                        showSearch
                                                        // .ant-select-selector
                                                        placeholder="Search for item"
                                                        optionFilterProp="children"
                                                        filterOption={false}
                                                        popupMatchSelectWidth={
                                                          false
                                                        }
                                                        disabled={
                                                          isLocked ||
                                                          salesOrderId ||
                                                          purchaseOrderId ||
                                                          quotationId ||
                                                          purchaseOrderRef
                                                            ? true
                                                            : false
                                                        }
                                                        listItemHeight={1}
                                                        style={{
                                                          backgroundColor:
                                                            "white",
                                                          minWidth: "100%",
                                                          maxWidth: "240px",
                                                        }}
                                                        dropdownStyle={{
                                                          width: "250px",
                                                        }}
                                                        placement="bottomRight"
                                                        notFoundContent={
                                                          <Empty
                                                            image={
                                                              Empty.PRESENTED_IMAGE_SIMPLE
                                                            }
                                                            description={
                                                              <span>
                                                                No item found.
                                                              </span>
                                                            }
                                                          />
                                                        }
                                                        onClick={() => {
                                                          // const getData =
                                                          //   form?.getFieldValue(
                                                          //     ["items", name]
                                                          //   );
                                                          // if (
                                                          //   getData?.batchItem ||
                                                          //   (getData?.serialItem &&
                                                          //     getData?.id
                                                          //       ?.value ===
                                                          //       batchItmId) ||
                                                          //   getData
                                                          //     ?.batchItem?.[0]
                                                          //     ?.trackingType ===
                                                          //     Item_Nature.Batch ||
                                                          //   getData?.trackingType ===
                                                          //     Item_Nature?.Serial
                                                          // ) {
                                                          //   setBatchItmId(
                                                          //     getData?.id?.value
                                                          //   );
                                                          //   setSelectedBatchData(
                                                          //     getData
                                                          //   );
                                                          // }
                                                          // const sNo =
                                                          //   getData?.serialItem?.map(
                                                          //     (itm: any) =>
                                                          //       itm.serialNumber
                                                          //   ) || [];
                                                          // const updatedAllSerial =
                                                          //   filterSerial.filter(
                                                          //     (
                                                          //       serialItem: any
                                                          //     ) =>
                                                          //       !sNo.includes(
                                                          //         serialItem.serialNumber
                                                          //       )
                                                          //   );
                                                          // setSerial(
                                                          //   updatedAllSerial
                                                          // );
                                                          // setAlReadySelectedData(
                                                          //   []
                                                          // );
                                                          // setNewItem({
                                                          //   data: {},
                                                          //   isSaved: false,
                                                          // });
                                                          // handleRowClick(index);
                                                        }}
                                                        onChange={(e: any) => {
                                                          if (
                                                            fields.length ===
                                                            index + 1
                                                          )
                                                            add();
                                                          itemSelect(
                                                            e.value,
                                                            index
                                                          );
                                                          setRefreshDeleteBatch(
                                                            (x: boolean) => !x
                                                          );
                                                        }}
                                                        optionRender={(itm) => (
                                                          <div>
                                                            <Row
                                                              justify={
                                                                "space-between"
                                                              }
                                                            >
                                                              <Col>
                                                                <p
                                                                  style={{
                                                                    fontWeight:
                                                                      "bold",
                                                                    color:
                                                                      "dimgray",
                                                                  }}
                                                                >
                                                                  {itm?.label}
                                                                </p>
                                                              </Col>
                                                            </Row>
                                                            <div>
                                                              {itm.data
                                                                ?.hsnCode && (
                                                                <span>
                                                                  <span
                                                                    style={{
                                                                      fontWeight:
                                                                        "500",
                                                                      color:
                                                                        "dimgray",
                                                                    }}
                                                                  >
                                                                    HSN Code -
                                                                  </span>
                                                                  {
                                                                    itm.data
                                                                      .hsnCode
                                                                  }
                                                                </span>
                                                              )}
                                                              {itm.data
                                                                ?.sacCode && (
                                                                <span>
                                                                  <span
                                                                    style={{
                                                                      fontWeight:
                                                                        "500",
                                                                      color:
                                                                        "dimgray",
                                                                    }}
                                                                  >
                                                                    SAC Code -
                                                                  </span>
                                                                  {
                                                                    itm.data
                                                                      ?.sacCode
                                                                  }
                                                                </span>
                                                              )}
                                                              {itm.data
                                                                ?.description && (
                                                                <span>
                                                                  <span
                                                                    style={{
                                                                      fontWeight:
                                                                        "500",
                                                                      color:
                                                                        "dimgray",
                                                                    }}
                                                                  >
                                                                    {" "}
                                                                    Des. -
                                                                  </span>
                                                                  {
                                                                    itm.data
                                                                      ?.description
                                                                  }
                                                                </span>
                                                              )}
                                                            </div>
                                                          </div>
                                                          //   ),
                                                          // </Space>
                                                        )}
                                                        options={itemFilterOptions
                                                          ?.filter(
                                                            (option: any) =>
                                                              !selectAssetItem.includes(
                                                                option.id
                                                              )
                                                          )
                                                          ?.map(
                                                            (
                                                              itm: any,
                                                              index: number
                                                            ) => ({
                                                              value: itm?.id,
                                                              disabled:
                                                                isLocked,

                                                              // id: itm?.id,
                                                              hsnCode:
                                                                itm?.hsnCode,
                                                              sacCode:
                                                                itm?.sacCode,
                                                              description:
                                                                itm?.description,
                                                              label:
                                                                itm?.assetName,
                                                              title: "",
                                                            })
                                                          )}
                                                        dropdownRender={(
                                                          itemsOption
                                                        ) => (
                                                          <>
                                                            {itemsOption}

                                                            {permissionItemAdd && (
                                                              <>
                                                                {/* <Divider
                                                                  style={{
                                                                    margin:
                                                                      "5px 0px",
                                                                  }}
                                                                />
                                                                <Button
                                                                  style={{
                                                                    width:
                                                                      "100%",
                                                                  }}
                                                                  icon={
                                                                    <PlusOutlined />
                                                                  }
                                                                  type="link"
                                                                  onClick={() => {
                                                                    setItemId(
                                                                      null
                                                                    );
                                                                    setOpenModel(
                                                                      {
                                                                        type: "addItem",
                                                                        param: {
                                                                          open: true,
                                                                        },
                                                                      }
                                                                    );
                                                                    setNewItem({
                                                                      data: {},
                                                                      isSaved:
                                                                        false,
                                                                    });
                                                                    setItemFields(
                                                                      {
                                                                        field:
                                                                          fields,
                                                                        index:
                                                                          index,
                                                                      }
                                                                    );
                                                                  }}
                                                                >
                                                                  New Item
                                                                </Button> */}
                                                              </>
                                                            )}
                                                          </>
                                                        )}
                                                      />
                                                    </Form.Item>
                                                    {(settingControl.showItemDescription ||
                                                      updateTimeData.showItemDescription) && (
                                                      <div
                                                        style={{
                                                          width: "100%",
                                                          justifyContent:
                                                            "space-between",
                                                          display: "flex",
                                                        }}
                                                      >
                                                        <div
                                                          style={{
                                                            width: "100%",
                                                          }}
                                                        >
                                                          <Form.Item
                                                            className="m-0"
                                                            {...restField}
                                                            name={[
                                                              name,
                                                              "description",
                                                            ]}
                                                            wrapperCol={{
                                                              xl: 25,
                                                            }}
                                                          >
                                                            <Input
                                                              variant="filled"
                                                              disabled={
                                                                isLocked ||
                                                                fields.length ===
                                                                  index + 1
                                                              }
                                                              style={{
                                                                fontSize:
                                                                  "12px",
                                                                // width: "100%",
                                                              }}
                                                              placeholder="Description"
                                                              bordered={false}
                                                            />
                                                          </Form.Item>
                                                        </div>

                                                        {/* <div
                                                          style={{
                                                            textAlign: "center",
                                                          }}
                                                        >
                                                          <Button
                                                            style={{
                                                              backgroundColor:
                                                                fields.length ===
                                                                index + 1
                                                                  ? `${themeData.themeData?.themeColor}40`
                                                                  : "#ececec",
                                                              border: "none",
                                                              padding:
                                                                "14px 6px 13px 6px",
                                                              marginLeft: "1px",
                                                              marginTop: "2px",
                                                            }}
                                                            onClick={() => {
                                                              const getData =
                                                                form?.getFieldValue(
                                                                  [
                                                                    "items",
                                                                    name,
                                                                  ]
                                                                );
                                                              setItemId(
                                                                getData?.id
                                                                  ?.value
                                                              );
                                                              setOpenModel({
                                                                type: "addItem",
                                                                param: {
                                                                  open: getData
                                                                    ?.id?.value
                                                                    ? true
                                                                    : false,
                                                                },
                                                              });
                                                            }}
                                                            disabled={
                                                              isLocked ||
                                                              fields.length ===
                                                                index + 1
                                                            }
                                                            size="small"
                                                          >
                                                            <EditOutlined
                                                              style={{
                                                                fontSize:
                                                                  "13px",
                                                                cursor:
                                                                  "pointer",
                                                              }}
                                                            />
                                                          </Button>
                                                        </div>
                                                        */}
                                                      </div>
                                                    )}
                                                  </td>
                                                  {/* Type */}
                                                  {/* {(itemSetting?.batchTracking ||
                                                    itemSetting?.serialTracking) && ( */}
                                                  <td align="center">
                                                    {form.getFieldValue([
                                                      "items",
                                                      index,
                                                    ])?.serialItem?.length >
                                                      0 ||
                                                    form.getFieldValue([
                                                      "items",
                                                      index,
                                                    ])?.trackingType ===
                                                      Item_Nature?.Serial ? (
                                                      <Tooltip
                                                        title="Serial Item"
                                                        placement="top"
                                                      >
                                                        <Tag
                                                          style={{
                                                            cursor: "pointer",
                                                            margin: "m-0",
                                                          }}
                                                          onClick={() => {
                                                            setRefreshDeleteBatch(
                                                              (x: boolean) => !x
                                                            );
                                                            handleRowClick(
                                                              index
                                                            );
                                                            setIndex(index);
                                                            const getData =
                                                              form?.getFieldValue(
                                                                ["items", name]
                                                              );
                                                            // console.log(
                                                            //   "getDatas",
                                                            //   getData
                                                            // );
                                                            setBatchItmId(
                                                              getData?.id?.value
                                                            );
                                                            if (
                                                              (getData?.batchItem &&
                                                                getData?.id
                                                                  ?.value ===
                                                                  batchItmId) ||
                                                              (getData?.serialItem &&
                                                                getData?.id
                                                                  ?.value ===
                                                                  batchItmId) ||
                                                              getData
                                                                ?.batchItem?.[0]
                                                                ?.trackingType ===
                                                                Item_Nature.Batch ||
                                                              getData?.trackingType ===
                                                                Item_Nature.Serial
                                                            ) {
                                                              setSelectedBatchData(
                                                                getData
                                                              );
                                                            }
                                                            setOpenModel({
                                                              type: "serialNo",
                                                              param: {
                                                                open: true,
                                                              },
                                                            });
                                                          }}
                                                        >
                                                          S
                                                        </Tag>
                                                      </Tooltip>
                                                    ) : form.getFieldValue([
                                                        "items",
                                                        name,
                                                      ])?.batchItem?.length >
                                                        0 ||
                                                      form.getFieldValue([
                                                        "items",
                                                        index,
                                                      ])?.trackingType ===
                                                        Item_Nature?.Batch ? (
                                                      <Tooltip
                                                        title="Batch Item"
                                                        placement="top"
                                                      >
                                                        <Tag
                                                          style={{
                                                            cursor: "pointer",
                                                          }}
                                                          onClick={() => {
                                                            setRefreshDeleteBatch(
                                                              (x: boolean) => !x
                                                            );
                                                            handleRowClick(
                                                              index
                                                            );
                                                            setIndex(index);
                                                            const getData =
                                                              form?.getFieldValue(
                                                                ["items", name]
                                                              );
                                                            console.log(
                                                              "getDatas",
                                                              getData
                                                            );
                                                            setBatchItmId(
                                                              getData?.id?.value
                                                            );
                                                            if (
                                                              getData?.batchItem ||
                                                              (getData?.serialItem &&
                                                                getData?.id
                                                                  ?.value ===
                                                                  batchItmId) ||
                                                              getData
                                                                ?.batchItem?.[0]
                                                                ?.trackingType ===
                                                                Item_Nature.Batch ||
                                                              getData?.trackingType ===
                                                                Item_Nature.Serial
                                                            ) {
                                                              setSelectedBatchData(
                                                                getData
                                                              );
                                                            }
                                                            setOpenModel({
                                                              type: "batchItem",
                                                              param: {
                                                                open: true,
                                                              },
                                                            });
                                                          }}
                                                        >
                                                          B
                                                        </Tag>
                                                      </Tooltip>
                                                    ) : form?.getFieldValue([
                                                        "items",
                                                        name,
                                                      ])?.id?.value ? (
                                                      <Tooltip
                                                        title="Add Disposed Item"
                                                        placement="top"
                                                      >
                                                        <Tag
                                                          style={{
                                                            cursor: "pointer",
                                                          }}
                                                          onClick={() => {
                                                            setRefreshDeleteBatch(
                                                              (x: boolean) => !x
                                                            );
                                                            handleRowClick(
                                                              index
                                                            );
                                                            setIndex(index);
                                                            const getData =
                                                              form?.getFieldValue(
                                                                ["items", name]
                                                              );
                                                            console.log(
                                                              "getDatas",
                                                              getData
                                                            );
                                                            // setBatchItmId(
                                                            //   getData?.id?.value
                                                            // );
                                                            // if (
                                                            //   getData?.batchItem ||
                                                            //   (getData?.serialItem &&
                                                            //     getData?.id
                                                            //       ?.value ===
                                                            //       batchItmId) ||
                                                            //   getData
                                                            //     ?.batchItem?.[0]
                                                            //     ?.trackingType ===
                                                            //     Item_Nature.Batch ||
                                                            //   getData?.trackingType ===
                                                            //     Item_Nature.Serial
                                                            // ) {
                                                            //   setSelectedBatchData(
                                                            //     getData
                                                            //   );
                                                            // }
                                                            setOpenModel({
                                                              type: "normalAssetItem",
                                                              param: {
                                                                open: true,
                                                                index: index,
                                                              },
                                                            });
                                                          }}
                                                        >
                                                          +
                                                        </Tag>
                                                      </Tooltip>
                                                    ) : (
                                                      <></>
                                                    )}
                                                  </td>
                                                  {/* )} */}
                                                  {/* Qty */}
                                                  <td
                                                    style={{
                                                      verticalAlign: "top",
                                                    }}
                                                  >
                                                    <Form.Item
                                                      className="m-0"
                                                      {...restField}
                                                      name={[
                                                        name,
                                                        "amount",
                                                        "qty",
                                                      ]}
                                                      initialValue={0.0}
                                                      wrapperCol={{
                                                        xl: 25,
                                                      }}
                                                    >
                                                      <InputNumber
                                                        variant="filled"
                                                        bordered={false}
                                                        precision={
                                                          form.getFieldValue([
                                                            "items",
                                                            index,
                                                          ])?.amount?.unit
                                                            ?.unitType === 3 ||
                                                          form.getFieldValue([
                                                            "items",
                                                            index,
                                                          ])?.amount?.unit
                                                            ?.unitType == null
                                                            ? 0
                                                            : 3
                                                        }
                                                        step={1}
                                                        disabled={
                                                          true
                                                          // isLocked ||
                                                          // fields.length ===
                                                          //   index + 1 ||
                                                          // form.getFieldValue([
                                                          //   "items",
                                                          //   index,
                                                          // ])?.batchItem
                                                          //   ?.length ||
                                                          // form.getFieldValue([
                                                          //   "items",
                                                          //   index,
                                                          // ])?.serialItem
                                                          //   ?.length ||
                                                          // form.getFieldValue([
                                                          //   "items",
                                                          //   index,
                                                          // ])?.trackingType ===
                                                          //   Item_Nature.Batch ||
                                                          // form.getFieldValue([
                                                          //   "items",
                                                          //   index,
                                                          // ])?.trackingType ===
                                                          //   Item_Nature.Serial
                                                        }
                                                        min={0}
                                                        style={{
                                                          width: "100%",
                                                          backgroundColor:
                                                            // fields.length ===
                                                            //   index + 1 ||
                                                            // form.getFieldValue([
                                                            //   "items",
                                                            //   index,
                                                            // ])?.batchItem
                                                            //   ?.length ||
                                                            // form.getFieldValue([
                                                            //   "items",
                                                            //   index,
                                                            // ])?.serialItem
                                                            //   ?.length ||
                                                            // form.getFieldValue([
                                                            //   "items",
                                                            //   index,
                                                            // ])?.trackingType ===
                                                            //   Item_Nature.Batch ||
                                                            // form.getFieldValue([
                                                            //   "items",
                                                            //   index,
                                                            // ])?.trackingType ===
                                                            //   Item_Nature.Serial
                                                            //   ?
                                                            `${themeData.themeData?.themeColor}40`,
                                                          // : "#FFFFFF",
                                                        }}
                                                        controls={false}
                                                        className="inputNumberTextEnd"
                                                        onChange={(e: any) => {
                                                          handleItemsNetAmmount(
                                                            index
                                                          );
                                                        }}
                                                        onFocus={(e) => {
                                                          handleInputFocus(
                                                            e,
                                                            form
                                                          );
                                                        }}
                                                        onKeyPress={
                                                          handleDecimalValues
                                                        }
                                                      />
                                                    </Form.Item>
                                                    {/* Unit */}
                                                    {/* {selectedInput.includes(
                                                      "unit"
                                                    ) && (
                                                      <Form.Item
                                                        name={[
                                                          name,
                                                          "amount",
                                                          "unit",
                                                        ]}
                                                        className="m-0"
                                                        {...restField}
                                                        wrapperCol={{
                                                          xl: 25,
                                                        }}
                                                      >
                                                        <Select
                                                          bordered={false}
                                                          // variant="filled"
                                                          disabled
                                                          labelInValue
                                                          showSearch
                                                          popupMatchSelectWidth={
                                                            false
                                                          }
                                                          style={{
                                                            minWidth: "100%",
                                                            maxWidth: "240px",
                                                            backgroundColor: `${themeData.themeData?.themeColor}40`,
                                                          }}
                                                          placement="bottomRight"
                                                        />
                                                      </Form.Item>
                                                    )} */}
                                                  </td>
                                                  {/* Total Price */}
                                                  <td
                                                    style={{
                                                      verticalAlign: "top",
                                                      overflow: "unset",
                                                    }}
                                                  >
                                                    <Form.Item
                                                      className="m-0"
                                                      {...restField}
                                                      name={[
                                                        name,
                                                        "amount",
                                                        "price",
                                                      ]}
                                                      initialValue={0.0}
                                                      wrapperCol={{
                                                        xl: 25,
                                                      }}
                                                    >
                                                      <InputNumber
                                                        bordered={false}
                                                        variant="filled"
                                                        disabled={
                                                          true
                                                          // isLocked ||
                                                          // salesOrderId ||
                                                          // purchaseOrderId ||
                                                          // quotationId ||
                                                          // form.getFieldValue([
                                                          //   "items",
                                                          //   index,
                                                          // ])?.batchItem
                                                          //   ?.length ||
                                                          // form.getFieldValue([
                                                          //   "items",
                                                          //   index,
                                                          // ])?.serialItem
                                                          //   ?.length ||
                                                          // form.getFieldValue([
                                                          //   "items",
                                                          //   index,
                                                          // ])?.trackingType ===
                                                          //   Item_Nature.Batch ||
                                                          // form.getFieldValue([
                                                          //   "items",
                                                          //   index,
                                                          // ])?.trackingType ===
                                                          //   Item_Nature.Serial
                                                          //   ? true
                                                          //   : fields.length ===
                                                          //     index + 1
                                                        }
                                                        min={0}
                                                        step={0.01}
                                                        precision={2}
                                                        style={{
                                                          width: "100%",
                                                          backgroundColor:
                                                            // fields.length ===
                                                            //   index + 1 ||
                                                            // salesOrderId ||
                                                            // purchaseOrderId ||
                                                            // quotationId ||
                                                            // form.getFieldValue([
                                                            //   "items",
                                                            //   index,
                                                            // ])?.batchItem
                                                            //   ?.length ||
                                                            // form.getFieldValue([
                                                            //   "items",
                                                            //   index,
                                                            // ])?.serialItem
                                                            //   ?.length ||
                                                            // form.getFieldValue([
                                                            //   "items",
                                                            //   index,
                                                            // ])?.trackingType ===
                                                            //   Item_Nature.Batch ||
                                                            // form.getFieldValue([
                                                            //   "items",
                                                            //   index,
                                                            // ])?.trackingType ===
                                                            //   Item_Nature.Serial
                                                            //   ?
                                                            `${themeData.themeData?.themeColor}40`,
                                                          // : "#FFFFFF",
                                                        }}
                                                        controls={false}
                                                        className="inputNumberTextEnd"
                                                        onKeyPress={
                                                          handleDecimalValues
                                                        }
                                                        onChange={() =>
                                                          handleItemsNetAmmount(
                                                            index
                                                          )
                                                        }
                                                        onFocus={(e) => {
                                                          var getData =
                                                            form.getFieldValue([
                                                              "items",
                                                              index,
                                                            ]);
                                                          handleInputFocus(
                                                            e,
                                                            form
                                                          );
                                                          setShowPriceHistory(
                                                            (prev: any) => {
                                                              let newValues = [
                                                                ...prev,
                                                              ];
                                                              newValues[index] =
                                                                true;
                                                              return newValues;
                                                            }
                                                          );
                                                          handlePriceHistoryData(
                                                            getData?.id?.value
                                                          );
                                                        }}
                                                        onBlur={(e) => {
                                                          setShowPriceHistory(
                                                            (prev: any) => {
                                                              let newValues = [
                                                                ...prev,
                                                              ];
                                                              newValues[index] =
                                                                false;
                                                              return newValues;
                                                            }
                                                          );
                                                          setShowPriceHistoryData(
                                                            []
                                                          );
                                                        }}
                                                      />
                                                    </Form.Item>
                                                    {showPriceHistory[index] &&
                                                      settingControl?.showPriceHistory &&
                                                      splitPathInVchType ===
                                                        Voucher_Type.PurchaseVoucher && (
                                                        <ShowPriceHistoryDataView
                                                          data={
                                                            showPriceHistoryData ??
                                                            []
                                                          }
                                                          themeColor={`${themeData.themeData?.themeColor}40`}
                                                          loading={
                                                            showPriceHistoryLoading
                                                          }
                                                        />
                                                      )}
                                                  </td>
                                                  {/* Discount */}
                                                  {/* {(settingControl.discountPolicy ===
                                                    Discount_Policy.TradenCashDiscount ||
                                                    settingControl.discountPolicy ===
                                                      Discount_Policy.OnlyTradeDiscount ||
                                                    updateTimeData.tradeDiscount) && (
                                                    <>
                                                      <td
                                                        style={{
                                                          verticalAlign: "top",
                                                        }}
                                                      >
                                                        <Form.Item
                                                          className="m-0"
                                                          {...restField}
                                                          name={[
                                                            name,
                                                            "amount",
                                                            "discount",
                                                          ]}
                                                          wrapperCol={{
                                                            xl: 25,
                                                          }}
                                                        >
                                                          <InputNumber
                                                            variant="filled"
                                                            bordered={false}
                                                            precision={2}
                                                            disabled={
                                                              isLocked ||
                                                              fields.length ===
                                                                index + 1
                                                            }
                                                            className="inputNumberTextEnd"
                                                            style={{
                                                              width: "100%",
                                                              backgroundColor:
                                                                fields.length ===
                                                                index + 1
                                                                  ? `${themeData.themeData?.themeColor}40`
                                                                  : "#FFFFFF",
                                                            }}
                                                            controls={false}
                                                            min={0}
                                                            max={100}
                                                            onKeyPress={
                                                              handleDecimalValues
                                                            }
                                                            onChange={() =>
                                                              handleItemsNetAmmount(
                                                                index
                                                              )
                                                            }
                                                            onFocus={(e) => {
                                                              handleInputFocus(
                                                                e,
                                                                form
                                                              );
                                                            }}
                                                          />
                                                        </Form.Item>
                                                      </td>
                                                      <td
                                                        style={{
                                                          verticalAlign: "top",
                                                        }}
                                                      >
                                                        <Form.Item
                                                          className="m-0"
                                                          {...restField}
                                                          name={[
                                                            name,
                                                            "amount",
                                                            "discountRupee",
                                                          ]}
                                                          initialValue={0}
                                                          wrapperCol={{
                                                            xl: 25,
                                                          }}
                                                        >
                                                          <InputNumber
                                                            variant="filled"
                                                            bordered={false}
                                                            precision={2}
                                                            disabled={
                                                              isLocked ||
                                                              fields.length ===
                                                                index + 1
                                                            }
                                                            min={0}
                                                            step={0.01}
                                                            style={{
                                                              width: "100%",
                                                              backgroundColor:
                                                                fields.length ===
                                                                index + 1
                                                                  ? `${themeData.themeData?.themeColor}40`
                                                                  : "#FFFFFF",
                                                            }}
                                                            controls={false}
                                                            // disabled
                                                            className="inputNumberTextEnd"
                                                            max={returnNetAmount(
                                                              index,
                                                              form.getFieldValue(
                                                                ["items"]
                                                              )
                                                            )}
                                                            onKeyPress={
                                                              handleDecimalValues
                                                            }
                                                            onChange={() => {
                                                              onDiscountAmountChange(
                                                                index
                                                              );
                                                            }}
                                                            onFocus={(e) => {
                                                              handleInputFocus(
                                                                e,
                                                                form
                                                              );
                                                            }}
                                                          />
                                                        </Form.Item>
                                                      </td>
                                                    </>
                                                  )} */}
                                                  {/* GST */}
                                                  {((splitPathInVchType ===
                                                    Voucher_Type.SalesVoucher &&
                                                    (currentClient?.gstType ===
                                                      CompanyGSTTypes.Regular ||
                                                      updateTimeData.isGSTVoucher)) ||
                                                    (splitPathInVchType !==
                                                      Voucher_Type.SalesVoucher &&
                                                      partyIsGstRegistered ===
                                                        CompanyGSTTypes.Regular)) && (
                                                    <>
                                                      <td
                                                        style={{
                                                          verticalAlign: "top",
                                                        }}
                                                      >
                                                        <Form.Item
                                                          name={[
                                                            name,
                                                            "amount",
                                                            "tax",
                                                          ]}
                                                          className="m-0"
                                                          {...restField}
                                                          wrapperCol={{
                                                            xl: 25,
                                                          }}
                                                        >
                                                          <Select
                                                            // variant="filled"
                                                            bordered={false}
                                                            // disabled
                                                            labelInValue
                                                            placeholder="GST %"
                                                            disabled={
                                                              isLocked ||
                                                              fields.length ===
                                                                index + 1 ||
                                                              splitPathInVchType ===
                                                                Voucher_Type.SalesVoucher
                                                            }
                                                            popupMatchSelectWidth={
                                                              false
                                                            }
                                                            style={{
                                                              minWidth: "100%",
                                                              maxWidth: "100px",
                                                              backgroundColor:
                                                                fields.length ===
                                                                  index + 1 ||
                                                                splitPathInVchType ===
                                                                  Voucher_Type.SalesVoucher
                                                                  ? `${themeData.themeData?.themeColor}40`
                                                                  : "#FFFFFF",
                                                            }}
                                                            placement="bottomRight"
                                                            onChange={() => {
                                                              handleItemsNetAmmount(
                                                                index
                                                              );
                                                            }}
                                                            options={gstOption?.map(
                                                              (gst: any) => ({
                                                                title: gst.rate,
                                                                value: gst.id,
                                                                label: gst.name,
                                                              })
                                                            )}
                                                          />
                                                        </Form.Item>
                                                        {splitPathInVchType ===
                                                          Voucher_Type.PurchaseVoucher && (
                                                          <Form.Item
                                                            name={[
                                                              name,
                                                              "itcEligibilityType",
                                                            ]}
                                                            className="m-0"
                                                            {...restField}
                                                            wrapperCol={{
                                                              xl: 25,
                                                            }}
                                                          >
                                                            <Select
                                                              bordered={false}
                                                              // variant="filled"
                                                              popupMatchSelectWidth={
                                                                false
                                                              }
                                                              disabled={
                                                                isLocked ||
                                                                fields.length ===
                                                                  index + 1
                                                              }
                                                              style={{
                                                                minWidth:
                                                                  "100%",
                                                                maxWidth:
                                                                  "100px",
                                                              }}
                                                              placement="bottomRight"
                                                              options={
                                                                ITCEligibilityTypeOptions
                                                              }
                                                            />
                                                          </Form.Item>
                                                        )}
                                                      </td>

                                                      <td
                                                        style={{
                                                          verticalAlign: "top",
                                                        }}
                                                      >
                                                        <Tooltip
                                                          title={form.getFieldValue(
                                                            [
                                                              "items",
                                                              index,
                                                              "amount",
                                                              "itemTaxAmt",
                                                            ]
                                                          )}
                                                          placement="top"
                                                        >
                                                          <Form.Item
                                                            className="m-0"
                                                            {...restField}
                                                            wrapperCol={{
                                                              xl: 25,
                                                            }}
                                                            name={[
                                                              name,
                                                              "amount",
                                                              "itemTaxAmt",
                                                            ]}
                                                          >
                                                            <InputNumber
                                                              variant="filled"
                                                              disabled
                                                              formatter={(
                                                                value: any
                                                              ) =>
                                                                value
                                                                  ? Utils.getFormattedNumber(
                                                                      value
                                                                    )
                                                                  : "0.00"
                                                              }
                                                              // bordered={false}
                                                              // step={0.01}
                                                              style={{
                                                                width: "100%",
                                                                backgroundColor: `${themeData.themeData?.themeColor}40`,
                                                              }}
                                                              // controls={false}
                                                              className="inputNumberTextEnd"
                                                            />
                                                          </Form.Item>
                                                        </Tooltip>
                                                      </td>
                                                    </>
                                                  )}
                                                  {/* Total Amount (Gross Amount) */}
                                                  <td
                                                    style={{
                                                      verticalAlign: "top",
                                                    }}
                                                  >
                                                    <Form.Item
                                                      className="m-0"
                                                      {...restField}
                                                      wrapperCol={{
                                                        xl: 25,
                                                      }}
                                                      name={[
                                                        name,
                                                        "amount",
                                                        "totalAmount",
                                                      ]}
                                                      initialValue={0}
                                                    >
                                                      <InputNumber
                                                        variant="filled"
                                                        bordered={false}
                                                        disabled={
                                                          true
                                                          // isLocked ||
                                                          // salesOrderId ||
                                                          // purchaseOrderId ||
                                                          // quotationId
                                                          //   ? true
                                                          //   : fields.length ===
                                                          //     index + 1
                                                        }
                                                        // min={0}
                                                        precision={2}
                                                        step={0.01}
                                                        style={{
                                                          width: "100%",
                                                          backgroundColor:
                                                            // fields.length ===
                                                            //   index + 1 ||
                                                            // salesOrderId ||
                                                            // purchaseOrderId ||
                                                            // quotationId
                                                            //   ?
                                                            `${themeData.themeData?.themeColor}40`,
                                                          // : "#FFFFFF",
                                                        }}
                                                        controls={false}
                                                        className="inputNumberTextEnd"
                                                        onKeyPress={
                                                          handleDecimalValues
                                                        }
                                                        // onChange={(value) => {
                                                        //   onItemsTotalAmountChange(
                                                        //     index
                                                        //   );
                                                        // }}
                                                        onFocus={(e) => {
                                                          handleInputFocus(
                                                            e,
                                                            form
                                                          );
                                                        }}
                                                      />
                                                    </Form.Item>
                                                  </td>
                                                  <td
                                                    style={{
                                                      width: 24,
                                                      verticalAlign: "top",
                                                      textAlign: "center",
                                                    }}
                                                  >
                                                    {fields.length !==
                                                      index + 1 && (
                                                      <img
                                                        className="cursor mx-1"
                                                        onClick={() => {
                                                          setConfirmation(true);

                                                          const getData =
                                                            form?.getFieldValue(
                                                              ["items", name]
                                                            );
                                                          const sNo =
                                                            getData?.serialItem?.map(
                                                              (itm: any) =>
                                                                itm.serialNumber
                                                            ) || [];
                                                          const updatedAllSerial =
                                                            filterSerial.filter(
                                                              (
                                                                serialItem: any
                                                              ) =>
                                                                !sNo.includes(
                                                                  serialItem.serialNumber
                                                                )
                                                            );

                                                          setSerial(
                                                            updatedAllSerial
                                                          );

                                                          const bNo =
                                                            getData?.batchItem?.map(
                                                              (itm: any) =>
                                                                itm.batchNumber
                                                            ) || [];

                                                          console.log(
                                                            " bNo:",
                                                            bNo
                                                          );

                                                          const addedBatch =
                                                            addBatches?.filter(
                                                              (batchItm: any) =>
                                                                !bNo.includes(
                                                                  batchItm?.batchNumber
                                                                )
                                                            );
                                                          setAddBatches(
                                                            addedBatch
                                                          );

                                                          setDeleteItemList(
                                                            name
                                                          );
                                                        }}
                                                        src={deleteImg}
                                                        alt="Delete"
                                                      />
                                                    )}
                                                  </td>
                                                </tr>
                                              );
                                            }
                                          )}
                                        </>
                                      );
                                    }}
                                  </Form.List>
                                  {/* Other Expenses */}
                                  <tr>
                                    <td colSpan={2}>
                                      <div
                                        style={{
                                          display: "flex",
                                          justifyContent: "space-between",
                                        }}
                                      >
                                        {/* <div>
                                          {(settingControl.showOtherCharges ||
                                            updateTimeData.friInsuranceOtherCharge) && (
                                            <Button
                                              icon={<PlusOutlined />}
                                              size="small"
                                              style={{
                                                backgroundColor: "ButtonFace",
                                              }}
                                              onClick={() => {
                                                setShowFreightInsurance(true);
                                                setSelectedOtherExpenses([]);
                                                setFooterLedger({
                                                  ledgerAmount: 0,
                                                  ledgerGstAmount: 0,
                                                  ledgerTotalAmount: 0,
                                                });

                                                form.setFieldValue(
                                                  ["freightInsLedgers"],
                                                  [
                                                    {
                                                      // gstRate: 0,
                                                      gstAmount: 0,
                                                      totalAmount: 0,
                                                      amount: 0,
                                                    },
                                                  ]
                                                );
                                              }}
                                              disabled={
                                                isLocked || showFreightInsurance
                                              }
                                            >
                                              Other Expenses
                                            </Button>
                                          )}
                                        </div> */}

                                        <div
                                          style={{
                                            fontWeight: "bold",
                                          }}
                                        >
                                          Sub Total
                                        </div>
                                      </div>
                                    </td>
                                    {/* {(itemSetting?.batchTracking ||
                                      itemSetting?.serialTracking) &&  */}
                                    <td></td>
                                    <td
                                      colSpan={1}
                                      className="textEnd pe-14"
                                      style={{ fontWeight: "bold" }}
                                    >
                                      {Utils.getFormattedNumber(
                                        footerTotal.qty
                                      )}
                                    </td>
                                    <td></td>
                                    {/* Discount */}
                                    {/* {(settingControl.discountPolicy ===
                                      Discount_Policy.TradenCashDiscount ||
                                      settingControl.discountPolicy ===
                                        Discount_Policy.OnlyTradeDiscount ||
                                      updateTimeData.tradeDiscount) && (
                                      <>
                                        <td></td>
                                        <td
                                          className="textEnd pe-12"
                                          style={{ fontWeight: "bold" }}
                                        >
                                          {" "}
                                          {Utils.getFormattedNumber(
                                            footerTotal.discount
                                          )}
                                        </td>
                                      </>
                                    )} */}
                                    <td></td>
                                    {((splitPathInVchType ===
                                      Voucher_Type.SalesVoucher &&
                                      (currentClient?.gstType ===
                                        CompanyGSTTypes.Regular ||
                                        updateTimeData.isGSTVoucher)) ||
                                      (splitPathInVchType !==
                                        Voucher_Type.SalesVoucher &&
                                        partyIsGstRegistered ===
                                          CompanyGSTTypes.Regular)) && (
                                      <>
                                        <td
                                          className="textEnd pe-14"
                                          style={{ fontWeight: "bold" }}
                                        >
                                          {" "}
                                          {Utils.getFormattedNumber(
                                            voucherNature !==
                                              Voucher_Nature.ImportExport &&
                                              voucherNature !==
                                                Voucher_Nature.SEZ
                                              ? footerTotal.gst
                                              : 0
                                          )}
                                        </td>
                                        <td
                                          className="textEnd pe-14"
                                          style={{ fontWeight: "bold" }}
                                        >
                                          {" "}
                                          {Utils.getFormattedNumber(
                                            footerTotal.amount
                                          )}
                                        </td>
                                      </>
                                    )}
                                    <td></td>
                                  </tr>
                                </>
                              )}

                              {/* Show Include Other Expenses */}
                              {/* showFreightInsurance */}
                              {showFreightInsurance && (
                                <>
                                  <Form.List name="freightInsLedgers">
                                    {(fields, { add, remove, move }) => {
                                      return (
                                        <>
                                          {ledgerconfirmation && (
                                            <ConfirmationModal
                                              open={ledgerconfirmation}
                                              text={
                                                "Do you really want to delete this Other Expenses"
                                              }
                                              onNo={() =>
                                                setLedgerConfirmation(false)
                                              }
                                              onYes={() => {
                                                setLedgerConfirmation(false);
                                                setLedgerLength(
                                                  fields.length - 2
                                                );
                                                setSelectedOtherExpenses(
                                                  (prev) => {
                                                    const newDisabledInputs = [
                                                      ...prev,
                                                    ];
                                                    newDisabledInputs.splice(
                                                      deleteItemList,
                                                      1
                                                    );
                                                    return newDisabledInputs;
                                                  }
                                                );
                                                fields.length === 0 &&
                                                  setShowFreightInsurance(
                                                    false
                                                  );
                                                remove(deleteLedgerList);
                                                setRefreshDeleteBatch(
                                                  (x: boolean) => !x
                                                );
                                                handleLedgerNetAmount(0);
                                              }}
                                            />
                                          )}
                                          {/* Other Expenses ledgers */}
                                          {fields?.map(
                                            (
                                              { key, name, ...restField },
                                              index
                                            ) => {
                                              return (
                                                <tr key={key}>
                                                  <td
                                                    style={{
                                                      verticalAlign: "top",
                                                      textAlign: "center",
                                                    }}
                                                  >
                                                    {index + 1}.
                                                  </td>
                                                  {!mode && <td></td>}
                                                  <td>
                                                    <Form.Item
                                                      name={[name, "id"]}
                                                      className="m-0"
                                                      {...restField}
                                                      wrapperCol={{
                                                        span: "25",
                                                      }}
                                                    >
                                                      <Select
                                                        variant="filled"
                                                        className="variantFilledSelect"
                                                        labelInValue
                                                        bordered={false}
                                                        loading={
                                                          otherExpensiveDropDownLoading
                                                        }
                                                        placeholder="Search for other expenses"
                                                        showSearch
                                                        optionFilterProp="children"
                                                        filterOption={(
                                                          input,
                                                          option
                                                        ) =>
                                                          (
                                                            option?.label?.toString() ??
                                                            ""
                                                          )
                                                            .toLowerCase()
                                                            .includes(
                                                              input.toLowerCase()
                                                            )
                                                        }
                                                        onChange={(e: any) => {
                                                          if (
                                                            fields.length ===
                                                            index + 1
                                                          )
                                                            add();
                                                          freightInsLedgersSelect(
                                                            e.value,
                                                            index
                                                          );
                                                        }}
                                                        options={freightAndInsuranceOptions
                                                          ?.filter(
                                                            (option: any) =>
                                                              !selectedOtherExpenses.includes(
                                                                option.id
                                                              )
                                                          )
                                                          ?.map(
                                                            (value: any) => ({
                                                              value: value?.id,
                                                              label:
                                                                value?.ledgerName.concat(
                                                                  value?.aliasName
                                                                    ? `${
                                                                        " (" +
                                                                        value?.aliasName +
                                                                        ")"
                                                                      }`
                                                                    : ""
                                                                ),
                                                            })
                                                          )}
                                                        style={{
                                                          width: "100%",
                                                          minWidth: "100%",
                                                          maxWidth: "240px",
                                                          backgroundColor:
                                                            "#FFFFFF",
                                                        }}
                                                        dropdownRender={(
                                                          customerOptions
                                                        ) => (
                                                          <>
                                                            {customerOptions}
                                                            {permissionExpensesAdd && (
                                                              <>
                                                                <Divider
                                                                  style={{
                                                                    margin:
                                                                      "5px 0px",
                                                                  }}
                                                                />
                                                                <Button
                                                                  icon={
                                                                    <PlusOutlined />
                                                                  }
                                                                  type="link"
                                                                  onClick={() => {
                                                                    setOpenModel(
                                                                      {
                                                                        type: "addLedger",
                                                                        param: {
                                                                          open: true,
                                                                          ledgerByGroupsType:
                                                                            splitPathInVchType ===
                                                                            Voucher_Type.SalesVoucher
                                                                              ? SearchLedgerByGroupsTypes.SellingAndDistributionExpenses
                                                                              : mode
                                                                              ? SearchLedgerByGroupsTypes.AllExpensesWithDutiesAndTaxes
                                                                              : SearchLedgerByGroupsTypes.DirectExpenses,
                                                                          showName:
                                                                            "Expense",
                                                                        },
                                                                      }
                                                                    );
                                                                    setEditParty(
                                                                      {
                                                                        id: "",
                                                                      }
                                                                    );
                                                                  }}
                                                                >
                                                                  New Ledger
                                                                </Button>
                                                              </>
                                                            )}
                                                          </>
                                                        )}
                                                      />
                                                    </Form.Item>
                                                    {(settingControl.showItemDescription ||
                                                      updateTimeData.showItemDescription) && (
                                                      <Form.Item
                                                        className="m-0"
                                                        {...restField}
                                                        name={[
                                                          name,
                                                          "description",
                                                        ]}
                                                        wrapperCol={{
                                                          span: 25,
                                                        }}
                                                      >
                                                        <Input
                                                          variant="filled"
                                                          disabled={
                                                            isLocked ||
                                                            fields.length ===
                                                              index + 1
                                                          }
                                                          style={{
                                                            fontSize: "12px",
                                                          }}
                                                          placeholder="Description"
                                                          bordered={false}
                                                        />
                                                      </Form.Item>
                                                    )}
                                                  </td>
                                                  {(itemSetting?.batchTracking ||
                                                    itemSetting?.serialTracking) && (
                                                    <td></td>
                                                  )}
                                                  {!mode && <td></td>}
                                                  {/* Unti Price Amount other Expenses */}
                                                  <td
                                                    style={{
                                                      verticalAlign: "top",
                                                    }}
                                                  >
                                                    <Form.Item
                                                      name={[name, "amount"]}
                                                      className="m-0"
                                                      {...restField}
                                                      wrapperCol={{
                                                        span: "25",
                                                      }}
                                                      initialValue={0.0}
                                                    >
                                                      <InputNumber
                                                        variant="filled"
                                                        bordered={false}
                                                        precision={2}
                                                        disabled={
                                                          isLocked ||
                                                          fields.length ===
                                                            index + 1
                                                        }
                                                        onFocus={(e) => {
                                                          handleInputFocus(
                                                            e,
                                                            form
                                                          );
                                                        }}
                                                        placeholder="Amount"
                                                        min={0}
                                                        step={0.01}
                                                        style={{
                                                          width: "100%",
                                                          backgroundColor:
                                                            fields.length ===
                                                            index + 1
                                                              ? `${themeData.themeData?.themeColor}40`
                                                              : "#FFFFFF",
                                                        }}
                                                        controls={false}
                                                        className="inputNumberTextEnd"
                                                        onChange={() => {
                                                          handleLedgerNetAmount(
                                                            index
                                                          );
                                                        }}
                                                        onKeyPress={
                                                          handleDecimalValues
                                                        }
                                                      />
                                                    </Form.Item>
                                                  </td>
                                                  {/* Discount */}
                                                  {/* {(settingControl.discountPolicy ===
                                                    Discount_Policy.TradenCashDiscount ||
                                                    settingControl.discountPolicy ===
                                                      Discount_Policy.OnlyTradeDiscount ||
                                                    updateTimeData.tradeDiscount) &&
                                                    !mode && (
                                                      <>
                                                        <td></td>
                                                        <td></td>
                                                      </>
                                                    )} */}
                                                  {/* GST */}
                                                  {((splitPathInVchType ===
                                                    Voucher_Type.SalesVoucher &&
                                                    (currentClient?.gstType ===
                                                      CompanyGSTTypes.Regular ||
                                                      updateTimeData.isGSTVoucher)) ||
                                                    (splitPathInVchType !==
                                                      Voucher_Type.SalesVoucher &&
                                                      partyIsGstRegistered ===
                                                        CompanyGSTTypes.Regular)) && (
                                                    <>
                                                      <td
                                                        style={{
                                                          verticalAlign: "top",
                                                        }}
                                                      >
                                                        <Form.Item
                                                          name={[
                                                            name,
                                                            "gstRate",
                                                          ]}
                                                          className="m-0"
                                                          {...restField}
                                                          wrapperCol={{
                                                            span: "25",
                                                          }}
                                                        >
                                                          <Select
                                                            placement="bottomRight"
                                                            labelInValue
                                                            bordered={false}
                                                            disabled={
                                                              isLocked ||
                                                              fields.length ===
                                                                index + 1
                                                            }
                                                            style={{
                                                              minWidth: "100%",
                                                              maxWidth: "100px",
                                                              backgroundColor:
                                                                fields.length ===
                                                                index + 1
                                                                  ? `${themeData.themeData?.themeColor}40`
                                                                  : "#FFFFFF",
                                                            }}
                                                            placeholder={
                                                              "GST %"
                                                            }
                                                            popupMatchSelectWidth={
                                                              false
                                                            }
                                                            filterOption={(
                                                              input,
                                                              option
                                                            ) =>
                                                              (
                                                                option?.label?.toString() ??
                                                                ""
                                                              )
                                                                .toLowerCase()
                                                                .includes(
                                                                  input.toLowerCase()
                                                                )
                                                            }
                                                            onChange={() => {
                                                              if (
                                                                partyIsGstRegisteredSalesInvoice ===
                                                                  CompanyGSTTypes.Overseas ||
                                                                partyIsGstRegisteredSalesInvoice ===
                                                                  CompanyGSTTypes.SEZ
                                                                  ? !underLUT
                                                                  : true
                                                              )
                                                                handleLedgerNetAmount(
                                                                  index
                                                                );
                                                            }}
                                                            options={gstOption?.map(
                                                              (gst: any) => ({
                                                                value: gst?.id,
                                                                title:
                                                                  gst?.rate,
                                                                label:
                                                                  gst?.name,
                                                              })
                                                            )}
                                                          />
                                                        </Form.Item>
                                                        {splitPathInVchType ===
                                                          Voucher_Type.PurchaseVoucher && (
                                                          <Form.Item
                                                            name={[
                                                              name,
                                                              "itcEligibilityType",
                                                            ]}
                                                            className="m-0"
                                                            {...restField}
                                                            wrapperCol={{
                                                              xl: 25,
                                                            }}
                                                          >
                                                            <Select
                                                              bordered={false}
                                                              // variant="filled"
                                                              popupMatchSelectWidth={
                                                                false
                                                              }
                                                              disabled={
                                                                isLocked ||
                                                                fields.length ===
                                                                  index + 1
                                                              }
                                                              style={{
                                                                minWidth:
                                                                  "100%",
                                                                maxWidth:
                                                                  "100px",
                                                              }}
                                                              placement="bottomRight"
                                                              options={
                                                                ITCEligibilityTypeOptions
                                                              }
                                                            />
                                                          </Form.Item>
                                                        )}
                                                      </td>
                                                      <td
                                                        style={{
                                                          verticalAlign: "top",
                                                        }}
                                                      >
                                                        <Form.Item
                                                          className="m-0 inputNumberTextEnd"
                                                          name={[
                                                            name,
                                                            "gstAmount",
                                                          ]}
                                                          {...restField}
                                                          initialValue={0.0}
                                                          wrapperCol={{
                                                            span: "25",
                                                          }}
                                                        >
                                                          <InputNumber
                                                            bordered={false}
                                                            variant="filled"
                                                            controls={false}
                                                            disabled={true}
                                                            precision={2}
                                                            step={0.01}
                                                            className="inputNumberTextEnd"
                                                            style={{
                                                              width: "100%",
                                                              backgroundColor: `${themeData.themeData?.themeColor}40`,
                                                            }}
                                                            onChange={() => {
                                                              handleLedgerNetAmount(
                                                                index
                                                              );
                                                            }}
                                                            onKeyPress={
                                                              handleDecimalValues
                                                            }
                                                          />
                                                        </Form.Item>
                                                      </td>
                                                    </>
                                                  )}
                                                  {/* Gross Amount - other expenses */}
                                                  <td
                                                    style={{
                                                      verticalAlign: "top",
                                                    }}
                                                  >
                                                    <Form.Item
                                                      name={[
                                                        name,
                                                        "totalAmount",
                                                      ]}
                                                      className="m-0 inputNumberTextEnd"
                                                      {...restField}
                                                      initialValue={0.0}
                                                      wrapperCol={{
                                                        span: "25",
                                                      }}
                                                    >
                                                      <InputNumber
                                                        // disabled
                                                        bordered={false}
                                                        disabled={
                                                          isLocked ||
                                                          fields.length ===
                                                            index + 1
                                                        }
                                                        onFocus={(e) => {
                                                          handleInputFocus(
                                                            e,
                                                            form
                                                          );
                                                        }}
                                                        variant="filled"
                                                        style={{
                                                          width: "100%",
                                                          backgroundColor:
                                                            fields.length ===
                                                            index + 1
                                                              ? `${themeData.themeData?.themeColor}40`
                                                              : "#FFFFFF",
                                                        }}
                                                        className="inputNumberTextEnd"
                                                        controls={false}
                                                        step={0.01}
                                                        precision={2}
                                                        onChange={(value) => {
                                                          onLedgerTotalAmountChange(
                                                            index
                                                          );
                                                        }}
                                                        onKeyPress={
                                                          handleDecimalValues
                                                        }
                                                      />
                                                    </Form.Item>
                                                  </td>
                                                  <td
                                                    style={{
                                                      verticalAlign: "top",
                                                    }}
                                                  >
                                                    {(fields.length === 1 ||
                                                      fields.length !==
                                                        index + 1) && (
                                                      <img
                                                        className="cursor mx-1"
                                                        onClick={() => {
                                                          setDeleteLedgerList(
                                                            name
                                                          );
                                                          setLedgerConfirmation(
                                                            true
                                                          );
                                                        }}
                                                        src={deleteImg}
                                                        alt="Delete"
                                                      />
                                                    )}
                                                  </td>
                                                </tr>
                                              );
                                            }
                                          )}
                                          {/* </tbody> */}
                                        </>
                                      );
                                    }}
                                  </Form.List>
                                  {/* Item + Other Expenses Total */}
                                  <tr>
                                    <td
                                      colSpan={mode ? 2 : 3}
                                      style={{
                                        fontWeight: "bold",
                                        textAlign: "end",
                                        padding: "0px 10px",
                                      }}
                                    >
                                      Sub Total
                                    </td>
                                    {(itemSetting?.batchTracking ||
                                      itemSetting?.serialTracking) && <td></td>}

                                    {!mode && (
                                      <td
                                        colSpan={1}
                                        className="textEnd pe-14"
                                      ></td>
                                    )}

                                    <td
                                      className="textEnd pe-14"
                                      style={{ fontWeight: "bold" }}
                                    >
                                      {" "}
                                      {Utils.getFormattedNumber(
                                        footerLedger.ledgerAmount
                                      )}
                                    </td>
                                    {(settingControl.discountPolicy ===
                                      Discount_Policy.TradenCashDiscount ||
                                      settingControl.discountPolicy ===
                                        Discount_Policy.OnlyTradeDiscount ||
                                      updateTimeData.tradeDiscount) &&
                                      !mode && (
                                        <>
                                          <td></td>
                                          <td></td>
                                        </>
                                      )}
                                    {((splitPathInVchType ===
                                      Voucher_Type.SalesVoucher &&
                                      (currentClient?.gstType ===
                                        CompanyGSTTypes.Regular ||
                                        updateTimeData.isGSTVoucher)) ||
                                      (splitPathInVchType !==
                                        Voucher_Type.SalesVoucher &&
                                        partyIsGstRegistered ===
                                          CompanyGSTTypes.Regular)) && (
                                      <>
                                        <td></td>
                                        <td
                                          className="textEnd pe-14"
                                          style={{ fontWeight: "bold" }}
                                        >
                                          {" "}
                                          {Utils.getFormattedNumber(
                                            voucherNature !==
                                              Voucher_Nature.ImportExport &&
                                              voucherNature !==
                                                Voucher_Nature.SEZ
                                              ? footerLedger?.ledgerGstAmount
                                              : 0
                                          )}
                                        </td>
                                      </>
                                    )}
                                    <td
                                      className="textEnd pe-14"
                                      style={{ fontWeight: "bold" }}
                                    >
                                      {" "}
                                      {Utils.getFormattedNumber(
                                        footerLedger?.ledgerTotalAmount
                                      )}
                                    </td>
                                    <td></td>
                                  </tr>
                                </>
                              )}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                    {(footerTotal.taxableAmount > 0 ||
                      footerLedger.ledgerAmount > 0 ||
                      location.state?.ledgerId ||
                      updateId ||
                      cloneId ||
                      draftId ||
                      salesOrderId ||
                      quotationId ||
                      batchData?.length ||
                      serialNoData?.length ||
                      batchItmName ||
                      purchaseOrderId) && (
                      <Row>
                        <Col span={16}>
                          <Row gutter={16} style={{ padding: "0 10px 0 0" }}>
                            {(isCashVoucher ||
                              settingControl?.showReceipt ||
                              editInvBankDetails?.length > 0) && (
                              <Col span={16} className="pt-10">
                                <div>
                                  <table className="AddPageTabelDesign">
                                    <Form.List name="bankDts">
                                      {(fields, { add, remove }) => {
                                        return (
                                          <>
                                            {bankConfirmation && (
                                              <ConfirmationModal
                                                open={true}
                                                text="Do you really want to delete this Row ?"
                                                onNo={() =>
                                                  setBankConfirmation(false)
                                                }
                                                onYes={() => {
                                                  setBankAccountAmt(
                                                    form
                                                      .getFieldValue("bankDts")
                                                      .reduce(
                                                        (acc: number, x: any) =>
                                                          acc + x?.amount,
                                                        0
                                                      )
                                                  );
                                                  setBankConfirmation(false);
                                                }}
                                              />
                                            )}
                                            <thead>
                                              <tr>
                                                <th
                                                  style={{
                                                    textAlign: "start",
                                                    paddingLeft: "8px",
                                                    width: "33%",
                                                    fontWeight: "500",
                                                  }}
                                                >
                                                  Select Account
                                                </th>
                                                <th
                                                  style={{
                                                    textAlign: "start",
                                                    paddingLeft: "8px",
                                                    width: "20%",
                                                    fontWeight: "500",
                                                  }}
                                                >
                                                  Balance
                                                </th>
                                                <th
                                                  style={{
                                                    textAlign: "start",
                                                    paddingLeft: "8px",
                                                    width: "20%",
                                                    fontWeight: "500",
                                                  }}
                                                >
                                                  Reference
                                                </th>
                                                <th
                                                  style={{
                                                    textAlign: "end",
                                                    paddingRight: "8px",
                                                    width: "20%",
                                                    fontWeight: "500",
                                                  }}
                                                >
                                                  Amount
                                                </th>
                                                <th
                                                  style={{ width: "7%" }}
                                                ></th>
                                              </tr>
                                            </thead>

                                            <tbody>
                                              <tr>
                                                <td>
                                                  <Input
                                                    disabled
                                                    bordered={false}
                                                    placeholder="Unallotted amount"
                                                    // variant="filled"
                                                    style={{
                                                      backgroundColor: `${themeData.themeData?.themeColor}40`,
                                                    }}
                                                  />
                                                </td>
                                                <td>
                                                  <Input
                                                    disabled
                                                    bordered={false}
                                                  />
                                                </td>
                                                <td>
                                                  <Input
                                                    disabled
                                                    bordered={false}
                                                  />
                                                </td>
                                                <td>
                                                  <Input
                                                    bordered={false}
                                                    // variant="filled"
                                                    style={{
                                                      textAlign: "end",
                                                      width: "100%",
                                                      backgroundColor: `${themeData.themeData?.themeColor}40`,
                                                    }}
                                                    min={0}
                                                    disabled
                                                    value={
                                                      voucherNature ===
                                                        Voucher_Nature.RCM ||
                                                      partyIsGstRegisteredSalesInvoice ===
                                                        CompanyGSTTypes.Overseas ||
                                                      partyIsGstRegisteredSalesInvoice ===
                                                        CompanyGSTTypes.SEZ
                                                        ? Utils.getFormattedNumber(
                                                            footerTotal.taxableAmount +
                                                              footerLedger.ledgerAmount +
                                                              roundOffAmount -
                                                              cashDiscountRs -
                                                              bankAccountAmt -
                                                              footerTotal.discount +
                                                              totalTcs -
                                                              totalTds
                                                          )
                                                        : Utils.getFormattedNumber(
                                                            Utils.getNumber(
                                                              footerTotal.amount
                                                            ) +
                                                              Utils.getNumber(
                                                                footerLedger.ledgerTotalAmount
                                                              ) +
                                                              roundOffAmount -
                                                              cashDiscountRs -
                                                              bankAccountAmt +
                                                              totalTcs -
                                                              totalTds
                                                          )
                                                    }
                                                  />
                                                </td>
                                                <td></td>
                                              </tr>
                                              {fields?.map(
                                                (
                                                  { key, name, ...restField },
                                                  index
                                                ) => {
                                                  return (
                                                    <tr key={key}>
                                                      {/* Select Account */}
                                                      <td>
                                                        <Form.Item
                                                          name={[name, "name"]}
                                                          className="m-0"
                                                          {...restField}
                                                          wrapperCol={{
                                                            span: 24,
                                                          }}
                                                        >
                                                          <Select
                                                            getPopupContainer={(
                                                              triggerNode
                                                            ) =>
                                                              triggerNode.parentNode
                                                            }
                                                            virtual={false} // ⬅️ Virtual scrolling disable kar raha hai
                                                            bordered={false}
                                                            loading={
                                                              bankAccountDropDownLoading
                                                            }
                                                            variant="filled"
                                                            className="variantFilledSelect"
                                                            disabled={
                                                              isLocked ||
                                                              (location.state
                                                                ?.ledgerId &&
                                                                index === 0)
                                                                ? true
                                                                : false
                                                            }
                                                            labelInValue
                                                            showSearch
                                                            placeholder="Search for bank"
                                                            optionFilterProp="children"
                                                            popupMatchSelectWidth={
                                                              false
                                                            }
                                                            style={{
                                                              width: "100%",
                                                              minWidth: "100%",
                                                              maxWidth: "140px",
                                                              backgroundColor:
                                                                "#FFFFFF",
                                                            }}
                                                            onSearch={(
                                                              value: string
                                                            ) =>
                                                              setSearchBankAccount(
                                                                value
                                                              )
                                                            }
                                                            filterOption={(
                                                              input,
                                                              option
                                                            ) =>
                                                              (
                                                                option?.label.toString() ??
                                                                ""
                                                              )
                                                                .toLowerCase()
                                                                .includes(
                                                                  input.toLowerCase()
                                                                )
                                                            }
                                                            options={bankAccountList
                                                              ?.filter(
                                                                (
                                                                  option: ILedgerSearchByGroupNameResponse
                                                                ) =>
                                                                  !selectedBankLedger.includes(
                                                                    option.id
                                                                  )
                                                              )
                                                              ?.map(
                                                                (
                                                                  value: ILedgerSearchByGroupNameResponse,
                                                                  index: number
                                                                ) => ({
                                                                  key: index,
                                                                  value:
                                                                    value?.id,
                                                                  label:
                                                                    value?.ledgerName.concat(
                                                                      value?.aliasName
                                                                        ? `${
                                                                            " (" +
                                                                            value?.aliasName +
                                                                            ")"
                                                                          }`
                                                                        : ""
                                                                    ),
                                                                  title:
                                                                    value?.partyOrTax?.toString(),
                                                                })
                                                              )}
                                                            onChange={(
                                                              e: any
                                                            ) => {
                                                              if (
                                                                fields.length ===
                                                                  index + 1 &&
                                                                fields.length <
                                                                  2
                                                              )
                                                                add();

                                                              let findBalance =
                                                                bankAccountList?.find(
                                                                  (x: any) =>
                                                                    x.id ===
                                                                    e.value
                                                                );
                                                              if (updateId) {
                                                                const editBankAccountFind =
                                                                  editInvBankDetails.find(
                                                                    (x) =>
                                                                      x.name
                                                                        ?.value ===
                                                                      e.value
                                                                  );
                                                                if (
                                                                  editBankAccountFind
                                                                ) {
                                                                  form.setFieldValue(
                                                                    [
                                                                      "bankDts",
                                                                      index,
                                                                    ],
                                                                    {
                                                                      ...editBankAccountFind,
                                                                      name: {
                                                                        label:
                                                                          editBankAccountFind
                                                                            .name
                                                                            ?.label,
                                                                        value:
                                                                          editBankAccountFind
                                                                            .name
                                                                            .value,
                                                                        title:
                                                                          editBankAccountFind
                                                                            .name
                                                                            ?.title,
                                                                      },
                                                                    }
                                                                  );

                                                                  setBankAccountAmt(
                                                                    bankAccountAmt +
                                                                      editBankAccountFind?.amount
                                                                  );
                                                                }
                                                                setSelectedBankBalance(
                                                                  (x: any) => {
                                                                    const updatedSelectedOptions =
                                                                      [...x];
                                                                    updatedSelectedOptions[
                                                                      index
                                                                    ] =
                                                                      (findBalance?.balance ??
                                                                        0) +
                                                                      (editBankAccountFind?.amount ??
                                                                        0);
                                                                    return updatedSelectedOptions;
                                                                  }
                                                                );
                                                              } else {
                                                                setSelectedBankBalance(
                                                                  (x: any) => {
                                                                    const updatedSelectedOptions =
                                                                      [...x];
                                                                    updatedSelectedOptions[
                                                                      index
                                                                    ] =
                                                                      findBalance?.balance;
                                                                    return updatedSelectedOptions;
                                                                  }
                                                                );
                                                              }

                                                              setSelectedBankLedger(
                                                                (prevState) => {
                                                                  const updatedSelectedOptions =
                                                                    [
                                                                      ...prevState,
                                                                    ];
                                                                  updatedSelectedOptions[
                                                                    index
                                                                  ] = e.value;
                                                                  return updatedSelectedOptions;
                                                                }
                                                              );

                                                              setSelectedBankPartyOrTax(
                                                                (prevState) => {
                                                                  const updatedSelectedOptions =
                                                                    [
                                                                      ...prevState,
                                                                    ];
                                                                  updatedSelectedOptions[
                                                                    index
                                                                  ] = e.title;
                                                                  return updatedSelectedOptions;
                                                                }
                                                              );
                                                            }}
                                                            dropdownRender={(
                                                              bankAccountList
                                                            ) => (
                                                              <>
                                                                {
                                                                  bankAccountList
                                                                }
                                                                {(permissionCashAdd ||
                                                                  permissionBankAdd) && (
                                                                  <>
                                                                    <Divider
                                                                      style={{
                                                                        margin:
                                                                          "5px 0px",
                                                                      }}
                                                                    />
                                                                    <Button
                                                                      style={{
                                                                        width:
                                                                          "100%",
                                                                      }}
                                                                      icon={
                                                                        <PlusOutlined />
                                                                      }
                                                                      type="link"
                                                                      onClick={() => {
                                                                        setNewBankAccountAddedIndex(
                                                                          index
                                                                        );
                                                                        setApiCallField(
                                                                          "New Bank"
                                                                        );
                                                                        setOpenModel(
                                                                          {
                                                                            type: "addBankAccount",
                                                                            param:
                                                                              {
                                                                                open: true,
                                                                                defaultGroup:
                                                                                  {
                                                                                    id: "6603af4b99242bad67d446c5",
                                                                                    ledgerName:
                                                                                      "Bank Account",
                                                                                    parent:
                                                                                      "65af9ce61a48db26effbb598",
                                                                                  },
                                                                              },
                                                                          }
                                                                        );
                                                                      }}
                                                                    >
                                                                      New Bank
                                                                    </Button>
                                                                  </>
                                                                )}
                                                              </>
                                                            )}
                                                          />
                                                        </Form.Item>
                                                      </td>
                                                      {/* Balance */}
                                                      <td>
                                                        <Form.Item
                                                          className="m-0"
                                                          {...restField}
                                                          wrapperCol={{
                                                            span: 25,
                                                          }}
                                                        >
                                                          <InputNumber
                                                            bordered={false}
                                                            // variant="filled"
                                                            style={{
                                                              width: "100%",
                                                              backgroundColor: `${themeData.themeData?.themeColor}40`,
                                                            }}
                                                            disabled
                                                            value={
                                                              selectedBankBalance[
                                                                index
                                                              ]
                                                            }
                                                          />
                                                        </Form.Item>
                                                      </td>
                                                      {/* Reference */}
                                                      <td>
                                                        <Form.Item
                                                          name={[
                                                            name,
                                                            "payRecReference",
                                                          ]}
                                                          className="m-0"
                                                          {...restField}
                                                          wrapperCol={{
                                                            span: 25,
                                                          }}
                                                        >
                                                          <Input
                                                            bordered={false}
                                                            variant="filled"
                                                            disabled={
                                                              isLocked ||
                                                              (location.state
                                                                ?.ledgerId &&
                                                                index === 0) ||
                                                              !selectedBankLedger[
                                                                index
                                                              ]
                                                            }
                                                            style={{
                                                              width: "100%",
                                                            }}
                                                          />
                                                        </Form.Item>
                                                      </td>
                                                      {/* Amount */}
                                                      <td>
                                                        <Form.Item
                                                          name={[
                                                            name,
                                                            "amount",
                                                          ]}
                                                          className="m-0"
                                                          {...restField}
                                                          initialValue={0.0}
                                                          wrapperCol={{
                                                            span: 25,
                                                          }}
                                                        >
                                                          <InputNumber
                                                            bordered={false}
                                                            variant="filled"
                                                            precision={2}
                                                            step={0.01}
                                                            min={0}
                                                            onFocus={(e) => {
                                                              handleInputFocus(
                                                                e,
                                                                form
                                                              );
                                                            }}
                                                            onKeyPress={
                                                              handleDecimalValues
                                                            }
                                                            disabled={
                                                              isLocked ||
                                                              (location.state
                                                                ?.ledgerId &&
                                                                index === 0) ||
                                                              !selectedBankLedger[
                                                                index
                                                              ]
                                                            }
                                                            onBlur={(x) => {
                                                              if (
                                                                splitPathInVchType ===
                                                                  Voucher_Type.PurchaseVoucher &&
                                                                selectedBankPartyOrTax[
                                                                  index
                                                                ] ===
                                                                  Party_Tax.BanknCash
                                                              ) {
                                                                if (
                                                                  Utils.getNumber(
                                                                    x.target
                                                                      .value
                                                                  ) >
                                                                  selectedBankBalance[
                                                                    index
                                                                  ]
                                                                ) {
                                                                  form.setFieldValue(
                                                                    [
                                                                      "bankDts",
                                                                      index,
                                                                      "amount",
                                                                    ],
                                                                    selectedBankBalance[
                                                                      index
                                                                    ]
                                                                  );
                                                                  setBankAccountAmt(
                                                                    form
                                                                      .getFieldValue(
                                                                        "bankDts"
                                                                      )
                                                                      .reduce(
                                                                        (
                                                                          acc: number,
                                                                          x: any
                                                                        ) =>
                                                                          acc +
                                                                          x?.amount,
                                                                        0
                                                                      )
                                                                  );
                                                                } else {
                                                                  setBankAccountAmt(
                                                                    form
                                                                      .getFieldValue(
                                                                        "bankDts"
                                                                      )
                                                                      .reduce(
                                                                        (
                                                                          acc: number,
                                                                          x: any
                                                                        ) =>
                                                                          acc +
                                                                          x?.amount,
                                                                        0
                                                                      )
                                                                  );
                                                                }
                                                              }

                                                              if (
                                                                Utils.getNumber(
                                                                  voucherNature ===
                                                                    Voucher_Nature.RCM ||
                                                                    partyIsGstRegisteredSalesInvoice ===
                                                                      CompanyGSTTypes.Overseas ||
                                                                    partyIsGstRegisteredSalesInvoice ===
                                                                      CompanyGSTTypes.SEZ
                                                                    ? Utils.getFormattedNumber(
                                                                        footerTotal.taxableAmount +
                                                                          footerLedger.ledgerAmount +
                                                                          totalTcs +
                                                                          roundOffAmount -
                                                                          footerTotal.discount -
                                                                          cashDiscountRs
                                                                      )
                                                                    : Utils.getFormattedNumber(
                                                                        footerTotal.amount +
                                                                          footerLedger.ledgerTotalAmount +
                                                                          totalTcs +
                                                                          roundOffAmount -
                                                                          cashDiscountRs
                                                                      )
                                                                ) -
                                                                  form
                                                                    .getFieldValue(
                                                                      "bankDts"
                                                                    )
                                                                    .reduce(
                                                                      (
                                                                        acc: number,
                                                                        x: any
                                                                      ) =>
                                                                        acc +
                                                                        x?.amount,
                                                                      0
                                                                    ) <
                                                                0
                                                              ) {
                                                                form.setFieldValue(
                                                                  [
                                                                    "bankDts",
                                                                    index,
                                                                    "amount",
                                                                  ],
                                                                  0.0
                                                                );
                                                                setBankAccountAmt(
                                                                  form
                                                                    .getFieldValue(
                                                                      "bankDts"
                                                                    )
                                                                    .reduce(
                                                                      (
                                                                        acc: number,
                                                                        x: any
                                                                      ) =>
                                                                        acc +
                                                                        x?.amount,
                                                                      0
                                                                    )
                                                                );
                                                              } else
                                                                setBankAccountAmt(
                                                                  form
                                                                    .getFieldValue(
                                                                      "bankDts"
                                                                    )
                                                                    .reduce(
                                                                      (
                                                                        acc: number,
                                                                        x: any
                                                                      ) =>
                                                                        acc +
                                                                        x?.amount,
                                                                      0
                                                                    )
                                                                );
                                                            }}
                                                            // min={1}
                                                            className="inputNumberTextEnd"
                                                            controls={false}
                                                            style={{
                                                              width: "100%",
                                                              backgroundColor:
                                                                (location.state
                                                                  ?.ledgerId &&
                                                                  index ===
                                                                    0) ||
                                                                !selectedBankLedger[
                                                                  index
                                                                ]
                                                                  ? `${themeData.themeData?.themeColor}40`
                                                                  : "#ffffff",
                                                            }}
                                                          />
                                                        </Form.Item>
                                                      </td>
                                                      <td
                                                        style={{
                                                          textAlign: "center",
                                                        }}
                                                      >
                                                        {selectedBankLedger[
                                                          index
                                                        ] && (
                                                          <img
                                                            className="cursor mx-1"
                                                            onClick={() => {
                                                              const currentAmount =
                                                                form.getFieldValue(
                                                                  [
                                                                    "bankDts",
                                                                    index,
                                                                    "amount",
                                                                  ]
                                                                );
                                                              if (
                                                                location.state
                                                                  ?.ledgerId &&
                                                                index !== 0
                                                              ) {
                                                                remove(name);
                                                                remove(
                                                                  deleteBankAccountRow
                                                                );
                                                                if (
                                                                  fields.length <
                                                                  3
                                                                ) {
                                                                  add({});
                                                                }
                                                              } else if (
                                                                !location.state
                                                                  ?.ledgerId
                                                              ) {
                                                                if (
                                                                  fields.length >
                                                                  1
                                                                ) {
                                                                  remove(name);
                                                                  if (
                                                                    fields.length <
                                                                    3
                                                                  ) {
                                                                    add({});
                                                                  }
                                                                } else
                                                                  form.setFieldValue(
                                                                    [
                                                                      "bankDts",
                                                                      index,
                                                                    ],
                                                                    {
                                                                      amount: 0,
                                                                    }
                                                                  );
                                                              }

                                                              setSelectedBankLedger(
                                                                (prev) => {
                                                                  const newDisabledInputs =
                                                                    [...prev];
                                                                  newDisabledInputs.splice(
                                                                    name,
                                                                    1
                                                                  );
                                                                  return newDisabledInputs;
                                                                }
                                                              );

                                                              setSelectedBankPartyOrTax(
                                                                (prev) => {
                                                                  const newDisabledInputs =
                                                                    [...prev];
                                                                  newDisabledInputs.splice(
                                                                    name,
                                                                    1
                                                                  );
                                                                  return newDisabledInputs;
                                                                }
                                                              );

                                                              setSelectedBankBalance(
                                                                (x: any) => {
                                                                  const allBankAmount =
                                                                    [...x];
                                                                  allBankAmount.splice(
                                                                    name,
                                                                    1
                                                                  );
                                                                  return allBankAmount;
                                                                }
                                                              );

                                                              setBankAccountAmt(
                                                                (prevAmt) =>
                                                                  prevAmt -
                                                                  currentAmount
                                                              );
                                                            }}
                                                            src={deleteImg}
                                                            alt="Delete"
                                                          />
                                                        )}
                                                        {/* )} */}
                                                      </td>
                                                    </tr>
                                                  );
                                                }
                                              )}
                                            </tbody>
                                          </>
                                        );
                                      }}
                                    </Form.List>
                                  </table>
                                </div>
                              </Col>
                            )}

                            <Col
                              style={{ marginTop: "9px" }}
                              span={
                                isCashVoucher ||
                                settingControl?.showReceipt ||
                                editInvBankDetails?.length > 0
                                  ? 8
                                  : 16
                              }
                              className="pt-10"
                            >
                              <Form.Item
                                name="narration"
                                className="m-0"
                                wrapperCol={{ span: 25 }}
                              >
                                <TextArea
                                  placeholder="Write narration"
                                  autoSize={{ minRows: 2, maxRows: 4 }}
                                />
                              </Form.Item>
                            </Col>
                          </Row>
                          <Row>
                            {/*  View and edit Terms and Conditions //commented for temporary basis  */}
                            <Col span={24} style={{ marginTop: "10px" }}>
                              <Button
                                style={{ backgroundColor: "ButtonFace" }}
                                onClick={() => {
                                  setOpenModel({
                                    type: "termsAndConditionsModal",
                                    param: { open: true },
                                  });
                                }}
                              >
                                View and edit Terms and Conditions
                              </Button>
                            </Col>

                            {/* Upload  */}
                            <Col span={24}>
                              <Form.Item
                                name="attachments"
                                valuePropName="fileList"
                                getValueFromEvent={(e) => {
                                  return e.fileList;
                                }}
                                // className="m-0"
                                style={{
                                  paddingTop: "10px",
                                  margin: "0px",
                                }}
                              >
                                <Upload
                                  multiple
                                  maxCount={2}
                                  accept={".png, .jpg, .jpeg, .pdf"}
                                  beforeUpload={(file) => {
                                    if (file.size > 1024 * 1024) {
                                      openNotification(
                                        "error",
                                        `${file.name} size is more than 1 MB`
                                      );
                                      return Upload.LIST_IGNORE;
                                    }
                                    let imgArray: string[] = [
                                      "image/jpeg",
                                      "image/jpg",
                                      "image/png",
                                      "application/pdf",
                                    ];
                                    if (
                                      !imgArray.some(
                                        (type) => type === file.type
                                      )
                                    ) {
                                      openNotification(
                                        "error",
                                        `${file.name} has invalid file format`
                                      );
                                      return Upload.LIST_IGNORE;
                                    }
                                    return false;
                                  }}
                                  onRemove={(e: any) => {
                                    if (updateId && e?.id) {
                                      setDeleteUploadId([
                                        ...deleteUploadId,
                                        e?.id,
                                      ]);
                                    }
                                  }}
                                  onPreview={(e: any) => {
                                    console.log("preview", e);
                                    if (updateId && e?.path) {
                                      setPreviewImage({
                                        isBaseConvert: false,
                                        path: e,
                                      });
                                    } else if (
                                      e.type?.split("/")[0] === "image"
                                    ) {
                                      setPreviewImage({
                                        isBaseConvert: true,
                                        path: e,
                                      });
                                    }
                                  }}
                                >
                                  <Button
                                    icon={<UploadOutlined />}
                                    style={{
                                      backgroundColor: "ButtonFace",
                                    }}
                                    disabled={
                                      isLocked ||
                                      form.getFieldValue("attachments")
                                        ?.length > 5
                                        ? true
                                        : false
                                    }
                                  >
                                    Upload
                                  </Button>
                                </Upload>
                              </Form.Item>
                            </Col>
                          </Row>
                        </Col>

                        <Col
                          xl={8}
                          lg={
                            isCashVoucher ||
                            settingControl?.showReceipt ||
                            editInvBankDetails?.length > 0
                              ? 24
                              : 16
                          }
                          md={24}
                          xs={24}
                          className="pt-10"
                        >
                          <Row gutter={[0, 8]} style={{ marginTop: "5px" }}>
                            {!mode && (
                              <>
                                <Col lg={9} span={9}>
                                  <span>
                                    {splitPathInVchType ===
                                    Voucher_Type.SalesVoucher
                                      ? "Selling Price"
                                      : "Purchase price"}
                                  </span>
                                </Col>
                                <Col lg={15} span={15} className="textEnd">
                                  <span>
                                    ₹{" "}
                                    {Utils.getFormattedNumber(
                                      footerTotal.taxableAmount
                                    )}
                                  </span>
                                </Col>
                              </>
                            )}
                            {showFreightInsurance && (
                              <>
                                <Col lg={9} span={9}>
                                  <span>
                                    {mode
                                      ? "Total Gross Amount"
                                      : "Other Expenses"}
                                  </span>
                                </Col>
                                <Col lg={15} span={15} className="textEnd">
                                  <span>
                                    ₹{" "}
                                    {Utils.getFormattedNumber(
                                      footerLedger.ledgerAmount
                                    )}
                                  </span>
                                </Col>
                              </>
                            )}
                            {/* {footerTotal.discount > 0 && (
                              <>
                                <Col lg={9} span={9}>
                                  <span>Trade Discount</span>
                                </Col>
                                <Col lg={15} span={15} className="textEnd">
                                  <span>
                                    - ₹{" "}
                                    {Utils.getFormattedNumber(
                                      footerTotal.discount
                                    )}
                                  </span>
                                </Col>
                              </>
                            )} */}
                            {(currentClient?.gstType ===
                              CompanyGSTTypes.Regular ||
                              updateTimeData.isGSTVoucher ||
                              splitPathInVchType ===
                                Voucher_Type.PurchaseVoucher) && (
                              <>
                                {isStateSame &&
                                partyIsGstRegisteredSalesInvoice !==
                                  CompanyGSTTypes.SEZ &&
                                partyIsGstRegisteredSalesInvoice !==
                                  CompanyGSTTypes.Overseas ? (
                                  <>
                                    <Col lg={9} span={9}>
                                      <span>CGST</span>
                                    </Col>
                                    <Col lg={15} span={15} className="textEnd">
                                      <span>
                                        ₹{" "}
                                        {Utils.getFormattedNumber(
                                          (footerTotal.gst +
                                            footerLedger.ledgerGstAmount) /
                                            2
                                        )}
                                      </span>
                                    </Col>
                                    <Col lg={9} span={9}>
                                      <span>SGST</span>
                                    </Col>
                                    <Col lg={15} span={15} className="textEnd">
                                      <span>
                                        ₹{" "}
                                        {Utils.getFormattedNumber(
                                          (footerTotal.gst +
                                            footerLedger.ledgerGstAmount) /
                                            2
                                        )}
                                      </span>
                                    </Col>
                                  </>
                                ) : currentCustomerState ? (
                                  <>
                                    <Col lg={9} span={9}>
                                      <span>IGST</span>
                                    </Col>
                                    <Col lg={15} span={15} className="textEnd">
                                      <span>
                                        ₹{" "}
                                        {Utils.getFormattedNumber(
                                          footerTotal.gst +
                                            footerLedger.ledgerGstAmount
                                        )}
                                      </span>
                                    </Col>
                                  </>
                                ) : (
                                  <></>
                                )}

                                {(isStateSame || currentCustomerState) &&
                                  voucherNature === Voucher_Nature.RCM && (
                                    <>
                                      <Col lg={12} span={11}>
                                        <span>Tax Under Reverse Charge</span>
                                      </Col>
                                      <Col
                                        lg={12}
                                        span={13}
                                        className="textEnd"
                                      >
                                        <span>
                                          ₹{" "}
                                          {Utils.getFormattedNumber(
                                            footerTotal.gst +
                                              footerLedger.ledgerGstAmount
                                          )}
                                        </span>
                                      </Col>
                                    </>
                                  )}
                              </>
                            )}

                            <Divider
                              className="grayBg"
                              style={{ margin: "0px" }}
                            />
                            <>
                              {/* <Divider className="my-0 grayBg" /> */}
                              <Col lg={9} span={9}>
                                <span>Gross Total</span>
                              </Col>
                              <Col lg={15} span={15} className="textEnd">
                                <span>
                                  ₹{" "}
                                  {Utils.getFormattedNumber(
                                    footerTotal.taxableAmount +
                                      footerLedger.ledgerAmount +
                                      footerTotal.gst +
                                      footerLedger.ledgerGstAmount -
                                      footerTotal.discount
                                  )}
                                </span>
                              </Col>
                            </>
                            {(settingControl.discountPolicy ===
                              Discount_Policy.OnlyCashDiscount ||
                              settingControl.discountPolicy ===
                                Discount_Policy.TradenCashDiscount) && (
                              <>
                                <Col lg={6} span={6}>
                                  <span>Cash Discount</span>
                                </Col>

                                <Col lg={4} span={4}>
                                  <Form.Item
                                    // style={{flex:'end'}}
                                    name="cashDiscountDrop"
                                    className="inputBoxMb"
                                    wrapperCol={{ span: 20 }}
                                  >
                                    <Select
                                      size="small"
                                      options={[
                                        {
                                          value:
                                            DiscountType.PercentageDiscount,
                                          label: "%",
                                        },
                                        {
                                          value: DiscountType.RupeeDiscount,
                                          label: "₹",
                                        },
                                      ]}
                                      onChange={() => hangleCashDisCount()}
                                    />
                                  </Form.Item>
                                </Col>

                                <Col lg={7} span={7}>
                                  <Form.Item
                                    className="discountInput inputBoxMb textEnd"
                                    name="cashDiscount"
                                  >
                                    <InputNumber
                                      step={0.01}
                                      controls={false}
                                      className="inputNumberTextEnd"
                                      size="small"
                                      placeholder="0.0"
                                      precision={2}
                                      onFocus={(e) => {
                                        handleInputFocus(e, form);
                                      }}
                                      onKeyPress={handleDecimalValues}
                                      min={0.0}
                                      max={
                                        form.getFieldValue(
                                          "cashDiscountDrop"
                                        ) === DiscountType.PercentageDiscount
                                          ? 100
                                          : Utils.getNumber(
                                              footerTotal.amount +
                                                footerLedger.ledgerTotalAmount
                                            )
                                      }
                                      style={{
                                        width: "100%",
                                      }}
                                      onChange={() => hangleCashDisCount()}
                                    />
                                  </Form.Item>
                                </Col>

                                <Col lg={7} span={7} className="textEnd">
                                  <span>
                                    {cashDiscountRs !== 0 && "-"} ₹{" "}
                                    {Utils.getFormattedNumber(cashDiscountRs)}
                                  </span>
                                </Col>

                                {cashDiscountRs > 0 && (
                                  <>
                                    <Divider
                                      className="grayBg"
                                      style={{ margin: "0px" }}
                                    />
                                    <Col lg={6} span={6}>
                                      <span>Sub Total</span>
                                    </Col>

                                    <Col lg={18} span={18} className="textEnd">
                                      <span>
                                        {" "}
                                        {voucherNature === Voucher_Nature.RCM ||
                                        partyIsGstRegisteredSalesInvoice ===
                                          CompanyGSTTypes.Overseas ||
                                        partyIsGstRegisteredSalesInvoice ===
                                          CompanyGSTTypes.SEZ
                                          ? Utils.getFormattedNumber(
                                              footerTotal.taxableAmount +
                                                footerLedger.ledgerAmount -
                                                cashDiscountRs -
                                                footerTotal.discount
                                            )
                                          : Utils.getFormattedNumber(
                                              footerTotal.amount +
                                                footerLedger.ledgerTotalAmount -
                                                cashDiscountRs
                                            )}
                                      </span>
                                    </Col>
                                  </>
                                )}
                              </>
                            )}

                            {(totalTcs > 0 ||
                              totalTds > 0 ||
                              isPartTDSOrTDS.tds ||
                              isPartTDSOrTDS.tcs) && (
                              <>
                                <Col lg={17} span={15}>
                                  <Row>
                                    <Col lg={12} span={12}>
                                      <Radio.Group
                                        // disabled
                                        onChange={(e) => {
                                          setTotalTcs(0);
                                          setTotalTds(0);
                                          form.setFieldValue("tcsDetail", null);
                                          form.setFieldValue("tdsDetail", null);
                                          setTdsOrTcs(e.target.value);
                                          handleAllTheTotalValues(
                                            e.target.value
                                          );
                                        }}
                                        value={tdsOrTcs}
                                      >
                                        {(isPartTDSOrTDS.tds ||
                                          totalTds > 0) && (
                                          <Radio value={0}>TDS</Radio>
                                        )}

                                        {(isPartTDSOrTDS.tcs ||
                                          totalTcs > 0) && (
                                          <Radio value={1}>TCS</Radio>
                                        )}
                                      </Radio.Group>
                                    </Col>
                                    <Col lg={12} span={12}>
                                      {tdsOrTcs === 1 ? (
                                        <Row gutter={5}>
                                          <Col lg={18} span={18}>
                                            <Form.Item
                                              name="tcsDetail"
                                              className="m-0"
                                              wrapperCol={{
                                                span: 24,
                                              }}
                                            >
                                              <Select
                                                labelInValue
                                                placement="bottomRight"
                                                popupMatchSelectWidth={false}
                                                placeholder="Select TCS"
                                                // disabled
                                                allowClear
                                                size="small"
                                                onChange={(e) => {
                                                  const tcsSelect =
                                                    tcsList?.find(
                                                      (x) => x?.id === e?.value
                                                    );
                                                  form.setFieldValue(
                                                    "tcsDetail",
                                                    {
                                                      value: e?.value,
                                                      label: tcsSelect?.section,
                                                      title: tcsSelect?.rate,
                                                    }
                                                  );
                                                  handleAllTheTotalValues();
                                                }}
                                                options={tcsList?.map(
                                                  (value: any) => ({
                                                    value: value?.id,
                                                    label: (
                                                      <div>
                                                        <Col>
                                                          <p
                                                            style={{
                                                              fontWeight:
                                                                "bold",
                                                              color: "dimgray",
                                                            }}
                                                          >
                                                            {value?.section}
                                                          </p>
                                                        </Col>

                                                        <div>
                                                          <span>
                                                            {
                                                              value?.natureOfCollection
                                                            }
                                                          </span>
                                                        </div>
                                                      </div>
                                                    ),
                                                    title: value?.rate,
                                                  })
                                                )}
                                                filterOption={(input, option) =>
                                                  (
                                                    option?.label?.toString() ??
                                                    ""
                                                  )
                                                    .toLowerCase()
                                                    .includes(
                                                      input.toLowerCase()
                                                    )
                                                }
                                                // dropdownRender={(menu) => (
                                                //   <div>
                                                //     {menu}
                                                //     <Divider
                                                //       style={{
                                                //         margin: "5px 0px",
                                                //       }}
                                                //     />
                                                //     <Button
                                                //       style={{ width: "100%" }}
                                                //       icon={<PlusOutlined />}
                                                //       type="link"
                                                //       onClick={() => {
                                                //         setEditParty({ id: "" });
                                                //         setOpenModel({
                                                //           type: "addTcsRate",
                                                //           param: {
                                                //             open: true,
                                                //           },
                                                //         });
                                                //       }}
                                                //     >
                                                //       TCS Rate
                                                //     </Button>
                                                //   </div>
                                                // )}
                                              />
                                            </Form.Item>
                                          </Col>
                                          <Col
                                            lg={4}
                                            span={4}
                                            style={{
                                              paddingTop: "2.5px",
                                            }}
                                          >
                                            {tcsTdsPercentage}%
                                          </Col>
                                        </Row>
                                      ) : tdsOrTcs === 0 ? (
                                        <Row gutter={5}>
                                          <Col lg={18} span={18}>
                                            <Form.Item
                                              name="tdsDetail"
                                              className="m-0"
                                              wrapperCol={{
                                                span: 24,
                                              }}
                                            >
                                              <Select
                                                labelInValue
                                                optionFilterProp="children"
                                                // disabled
                                                placeholder="Select TDS"
                                                placement="bottomRight"
                                                popupMatchSelectWidth={false}
                                                size="small"
                                                allowClear
                                                onChange={(e) => {
                                                  if (e) {
                                                    const tdsSelect =
                                                      tdsList.find(
                                                        (x) =>
                                                          x?.id === e?.value
                                                      );
                                                    // console.log("any", tdsSelect, e);
                                                    form.setFieldValue(
                                                      "tdsDetail",
                                                      {
                                                        value: e?.value,
                                                        label:
                                                          tdsSelect?.section,
                                                        title:
                                                          tdsSelect?.rateDetail,
                                                      }
                                                    );
                                                    setTdsPostDetail({
                                                      id: tdsSelect?.id,
                                                      formNo: tdsSelect?.form,
                                                      transactionType:
                                                        tdsSelect?.transactionType,
                                                    });
                                                  } else {
                                                    form.setFieldValue(
                                                      "tdsDetail",
                                                      null
                                                    );
                                                    setTdsPostDetail({
                                                      id: "",
                                                      formNo: "",
                                                      transactionType:
                                                        Transaction_Type.Domestic,
                                                    });
                                                    setTotalTds(0);
                                                  }
                                                  handleAllTheTotalValues();
                                                }}
                                                options={tdsList?.map(
                                                  (value: any) => ({
                                                    value: value?.id,
                                                    label: (
                                                      <div>
                                                        <Col>
                                                          <p
                                                            style={{
                                                              fontWeight:
                                                                "bold",
                                                              color: "dimgray",
                                                            }}
                                                          >
                                                            {value?.section}
                                                          </p>
                                                        </Col>

                                                        <div>
                                                          <span>
                                                            {
                                                              value?.natureOfPayment
                                                            }
                                                          </span>
                                                        </div>
                                                      </div>
                                                    ),
                                                    title:
                                                      value?.TransactionType ===
                                                      Transaction_Type.Domestic
                                                        ? value?.domesticSegment
                                                        : value?.internationalSegment,
                                                  })
                                                )}
                                                filterOption={(input, option) =>
                                                  (
                                                    option?.label?.toString() ??
                                                    ""
                                                  )
                                                    .toLowerCase()
                                                    .includes(
                                                      input.toLowerCase()
                                                    )
                                                }
                                                // dropdownRender={(menu) => (
                                                //   <>
                                                //     <div>
                                                //       {menu}
                                                //       <Divider
                                                //         style={{
                                                //           margin: "5px 0px",
                                                //         }}
                                                //       />
                                                //       <Button
                                                //         style={{
                                                //           width: "100%",
                                                //         }}
                                                //         icon={<PlusOutlined />}
                                                //         type="link"
                                                //         onClick={() => {
                                                //           setEditParty({
                                                //             id: "",
                                                //           });
                                                //           setOpenModel({
                                                //             type: "addTdsRate",
                                                //             param: {
                                                //               open: true,
                                                //             },
                                                //           });
                                                //         }}
                                                //       >
                                                //         Rate
                                                //       </Button>
                                                //     </div>
                                                //   </>
                                                // )}
                                              />
                                            </Form.Item>
                                          </Col>
                                          <Col
                                            lg={4}
                                            span={4}
                                            style={{
                                              paddingTop: "2.5px",
                                            }}
                                          >
                                            {tcsTdsPercentage}%
                                          </Col>
                                        </Row>
                                      ) : (
                                        <></>
                                      )}
                                    </Col>
                                  </Row>
                                </Col>

                                {tdsOrTcs === 1 ? (
                                  <Col lg={7} span={9} className="textEnd">
                                    <span>
                                      ₹ {Utils.getFormattedNumber(totalTcs)}
                                    </span>
                                  </Col>
                                ) : tdsOrTcs === 0 ? (
                                  <Col lg={7} span={9} className="textEnd">
                                    {/* <span>
                                      ₹ {Utils.getFormattedNumber(totalTds)}
                                    </span> */}
                                    <InputNumber
                                      disabled={
                                        tdsPostDetail?.id ? false : true
                                      }
                                      step={0.01}
                                      precision={2}
                                      className="inputNumberTextEnd"
                                      size="small"
                                      type="number"
                                      controls={false}
                                      placeholder="0.0"
                                      value={totalTds}
                                      // onFocus={(e) => {
                                      //   handleInputFocus(e, form);
                                      // }}
                                      min={0}
                                      style={{
                                        width: "100%",
                                      }}
                                      onChange={(e: number | null) => {
                                        if (e || e === 0) {
                                          setTotalTds(e);
                                          // const roundOffAmount = handleRoundoff(
                                          //   totalPaymentIn +
                                          //     (splitPathInVchType ===
                                          //     Voucher_Type.Receipt
                                          //       ? e
                                          //       : -e),
                                          //   form.getFieldValue(
                                          //     "roundoffCheckbox"
                                          //   ),
                                          //   settingControl.roundOffType
                                          // );

                                          // form.setFieldValue(
                                          //   "roundOff",
                                          //   roundOffAmount
                                          // );
                                          // setRoundoffAmount(roundOffAmount);
                                        }
                                      }}
                                      // onKeyPress={handleDecimalValues}
                                    />
                                  </Col>
                                ) : (
                                  <></>
                                )}
                              </>
                            )}
                            {(settingControl.autoRoundOff ||
                              updateTimeData.roundOff) && (
                              <>
                                <Col
                                  lg={5}
                                  span={5}
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                  }}
                                >
                                  <span>Round off</span>
                                </Col>

                                <Col lg={4} span={4}>
                                  <Form.Item
                                    valuePropName="checked"
                                    name="roundoffCheckbox"
                                    className="inputBoxMb"
                                  >
                                    <Checkbox
                                      onChange={() => {
                                        const roundOffAmount = handleRoundoff(
                                          voucherNature ===
                                            Voucher_Nature.RCM ||
                                            partyIsGstRegisteredSalesInvoice ===
                                              CompanyGSTTypes.Overseas ||
                                            partyIsGstRegisteredSalesInvoice ===
                                              CompanyGSTTypes.SEZ
                                            ? footerTotal.taxableAmount +
                                                footerLedger.ledgerAmount +
                                                totalTcs -
                                                footerTotal.discount -
                                                cashDiscountRs
                                            : footerTotal.amount +
                                                footerLedger.ledgerTotalAmount +
                                                totalTcs -
                                                cashDiscountRs,
                                          form.getFieldValue(
                                            "roundoffCheckbox"
                                          ),
                                          settingControl.roundOffType
                                        );

                                        form.setFieldValue(
                                          "roundOff",
                                          roundOffAmount
                                        );
                                        setRoundoffAmount(roundOffAmount);
                                      }}
                                    />
                                  </Form.Item>
                                </Col>

                                <Col
                                  lg={15}
                                  span={15}
                                  style={{
                                    display: "flex",
                                    justifyContent: "flex-end",
                                  }}
                                >
                                  <Form.Item
                                    className="discountInput inputBoxMb textEnd"
                                    name="roundOff"
                                    wrapperCol={{ span: "25" }}
                                  >
                                    <InputNumber
                                      step={0.01}
                                      precision={2}
                                      className="inputNumberTextEnd"
                                      size="small"
                                      controls={false}
                                      placeholder="0.0"
                                      max={
                                        voucherNature === Voucher_Nature.RCM ||
                                        partyIsGstRegisteredSalesInvoice ===
                                          CompanyGSTTypes.Overseas ||
                                        partyIsGstRegisteredSalesInvoice ===
                                          CompanyGSTTypes.SEZ
                                          ? footerTotal.taxableAmount +
                                            footerLedger.ledgerAmount +
                                            totalTcs -
                                            footerTotal.discount -
                                            cashDiscountRs
                                          : footerTotal.amount +
                                            footerLedger.ledgerTotalAmount +
                                            totalTcs -
                                            cashDiscountRs
                                      }
                                      min={
                                        voucherNature === Voucher_Nature.RCM ||
                                        partyIsGstRegisteredSalesInvoice ===
                                          CompanyGSTTypes.Overseas ||
                                        partyIsGstRegisteredSalesInvoice ===
                                          CompanyGSTTypes.SEZ
                                          ? -(
                                              footerTotal.taxableAmount +
                                              footerLedger.ledgerAmount +
                                              totalTcs -
                                              footerTotal.discount -
                                              cashDiscountRs
                                            )
                                          : -(
                                              footerTotal.amount +
                                              footerLedger.ledgerTotalAmount +
                                              totalTcs -
                                              cashDiscountRs
                                            )
                                      }
                                      style={{
                                        width: "100%",
                                      }}
                                      onChange={(e: any) => {
                                        setRoundoffAmount(e);
                                      }}
                                      onFocus={(e) => {
                                        handleInputFocus(e, form);
                                      }}
                                      // onKeyPress={handleDecimalValues}
                                    />
                                  </Form.Item>
                                </Col>
                              </>
                            )}
                            {(totalTcs > 0 || totalTds > 0) && (
                              <>
                                <Col lg={6} span={6}>
                                  <span>Sub Total</span>
                                </Col>

                                <Col lg={18} span={18} className="textEnd">
                                  <span>
                                    ₹{" "}
                                    {voucherNature === Voucher_Nature.RCM ||
                                    partyIsGstRegisteredSalesInvoice ===
                                      CompanyGSTTypes.Overseas ||
                                    partyIsGstRegisteredSalesInvoice ===
                                      CompanyGSTTypes.SEZ
                                      ? Utils.getFormattedNumber(
                                          footerTotal.taxableAmount +
                                            footerLedger.ledgerAmount -
                                            cashDiscountRs -
                                            footerTotal.discount +
                                            totalTcs -
                                            totalTds +
                                            roundOffAmount
                                        )
                                      : Utils.getFormattedNumber(
                                          footerTotal.amount +
                                            footerLedger.ledgerTotalAmount -
                                            cashDiscountRs +
                                            totalTcs -
                                            totalTds +
                                            roundOffAmount
                                        )}
                                  </span>
                                  {/* {Utils.getFormattedNumber(cashDiscount)} */}
                                </Col>
                              </>
                            )}
                            {bankAccountAmt > 0 && (
                              <>
                                <Divider
                                  className="grayBg"
                                  style={{ margin: "0px" }}
                                />
                                <Col lg={11} span={11}>
                                  <span>
                                    {splitPathInVchType ===
                                    Voucher_Type.SalesVoucher
                                      ? "Received"
                                      : "Paid"}
                                  </span>
                                </Col>
                                <Col lg={13} span={13} className="textEnd">
                                  <span>
                                    ₹ {Utils.getFormattedNumber(bankAccountAmt)}
                                  </span>
                                </Col>

                                <Col lg={9} span={9}>
                                  <span>Balance</span>
                                </Col>
                                <Col lg={15} span={15} className="textEnd">
                                  <span>
                                    ₹{" "}
                                    {voucherNature === Voucher_Nature.RCM ||
                                    partyIsGstRegisteredSalesInvoice ===
                                      CompanyGSTTypes.Overseas ||
                                    partyIsGstRegisteredSalesInvoice ===
                                      CompanyGSTTypes.SEZ
                                      ? Utils.getFormattedNumber(
                                          footerTotal.taxableAmount +
                                            footerLedger.ledgerAmount -
                                            cashDiscountRs -
                                            footerTotal.discount +
                                            totalTcs -
                                            totalTds +
                                            roundOffAmount -
                                            bankAccountAmt
                                        )
                                      : Utils.getFormattedNumber(
                                          footerTotal.amount +
                                            footerLedger.ledgerTotalAmount -
                                            cashDiscountRs +
                                            totalTcs -
                                            totalTds +
                                            roundOffAmount -
                                            bankAccountAmt
                                        )}
                                  </span>
                                </Col>
                                {/* <Divider className="grayBg" style={{ margin: "0px" }} /> */}
                              </>
                            )}
                          </Row>

                          <Divider className="my-5 grayBg" />

                          <Row gutter={[12, 2]}>
                            <Col
                              lg={11}
                              span={11}
                              style={{
                                fontWeight: 600,
                                fontSize: "16px",
                              }}
                            >
                              <span>
                                {splitPathInVchType ===
                                Voucher_Type.SalesVoucher
                                  ? "Total Invoice Value"
                                  : "Bill Amount"}
                              </span>
                            </Col>
                            <Col
                              lg={13}
                              span={13}
                              className="textEnd"
                              style={{
                                fontWeight: 600,
                                fontSize: "16px",
                              }}
                            >
                              <span>
                                ₹{" "}
                                {Utils.getFormattedNumber(
                                  voucherNature === Voucher_Nature.RCM ||
                                    partyIsGstRegisteredSalesInvoice ===
                                      CompanyGSTTypes.Overseas ||
                                    partyIsGstRegisteredSalesInvoice ===
                                      CompanyGSTTypes.SEZ
                                    ? footerTotal.taxableAmount +
                                        footerLedger.ledgerAmount +
                                        totalTcs +
                                        roundOffAmount -
                                        footerTotal.discount -
                                        cashDiscountRs
                                    : Utils.getNumber(footerTotal.amount) +
                                        Utils.getNumber(
                                          footerLedger.ledgerTotalAmount
                                        ) +
                                        totalTcs +
                                        roundOffAmount -
                                        cashDiscountRs
                                )}
                              </span>
                            </Col>
                          </Row>
                        </Col>
                      </Row>
                    )}
                  </Form>
                </>
              </div>
            </Spin>
          </div>
        </Content>

        <Footer
          style={{
            bottom: 0,
            position: "fixed",
            width: "100%",
            background: "#fff",
            marginLeft: "-14px",
            zIndex: 999,
          }}
        >
          <Row style={{ padding: "10px" }}>
            <Col lg={16}></Col>
            <Col lg={8}>
              <Row gutter={10}>
                <Col>
                  <Tooltip
                    title={<p>ALT+C</p>}
                    placement="bottomLeft"
                    open={showKeys}
                  >
                    <Button
                      disabled={isLocked}
                      onClick={() => {
                        if (
                          Utils.getNumber(footerTotal.amount) +
                            Utils.getNumber(footerLedger.ledgerTotalAmount) +
                            roundOffAmount -
                            cashDiscountRs >
                            0 &&
                          !updateId &&
                          selectedParty
                          //form.getFieldValue("effectiveLedger")
                        ) {
                          saveDrift();
                        }
                        setIsSaveDraft(false);
                        sessionStorage.removeItem(`${currentClient?.id} Sales`);
                        sessionStorage.removeItem("NotificationState");
                        if (location.state?.ledgerId) {
                          navigate(
                            `/accounts/clients/${currentClient?.id}/banking/bankTransactionsDetails/${location.state?.bankEntriesId}`,
                            {
                              state: {
                                ledgerId: location.state?.ledgerId,
                                bankImportIndex: null,
                                voucherRef: null,
                              },
                            }
                          );
                        } else {
                          navigate(-1);
                        }
                      }}
                    >
                      Cancel
                    </Button>
                  </Tooltip>
                </Col>
                <Col>
                  {/* <Form.Item> */}
                  <Tooltip
                    title={<p>ALT+S</p>}
                    placement="bottomLeft"
                    open={showKeys}
                  >
                    <Button
                      disabled={isLocked}
                      type="primary"
                      loading={updateAndNewButton}
                      onClick={() => {
                        addSalesInvoice(false);
                        setIsSaveDraft(false);
                        setIsSaveAndNew(false);
                      }}
                    >
                      {updateId && !updateAndNew ? "Update" : "Save"}
                    </Button>
                  </Tooltip>

                  {/* </Form.Item> */}
                </Col>
                <Col>
                  {updateId && !updateAndNew ? (
                    <Button
                      disabled={isLocked}
                      loading={saveNewLoading}
                      onClick={() => {
                        // setIsSaveDraft(false);
                        addSalesInvoice(true);
                        setIsSaveAndNew(true);
                      }}
                      type="primary"
                    >
                      Update & New
                    </Button>
                  ) : (
                    <Button
                      disabled={isLocked}
                      loading={saveNewLoading}
                      onClick={() => {
                        // setIsSaveDraft(false);
                        addSalesInvoice(true);
                        setIsSaveAndNew(true);
                      }}
                      type="primary"
                    >
                      Save & New
                    </Button>
                  )}
                </Col>
              </Row>
            </Col>
          </Row>
        </Footer>
      </Layout>
      {/* </Col> */}

      {/* ------------- props -------------  */}
      {/* -------------TCS Model ----------*/}
      {tcsModelOpen && (
        <TcsModel isModalOpen={tcsModelOpen} setIsModalOpen={setTcsModelOpen} />
      )}
      {/* -------------TDS Model ----------*/}
      {tdsModelOpen && (
        <TdsModel isModalOpen={tdsModelOpen} setIsModalOpen={setTdsModelOpen} />
      )}
      {/* -------------ADD Party ----------*/}

      {/* -------------ADD Item(s) (Item) ----------*/}
      {openModel.type === "addItem" && (
        <AddItems
          open={openModel?.param.open}
          onCancel={() => setOpenModel({ type: "", param: "" })}
          id={itemId}
          setTrigger={setloadItemAPI}
          setNewItem={setNewItem}
        />
      )}
      {/* -------------ADD Bank Account ----------*/}
      {openModel.type === "addBankAccount" && (
        <AddBankAccount
          open={true}
          onCancel={() => setOpenModel({ type: "", param: "" })}
          id={openModel.param?.id}
          defaultGroup={openModel?.param?.defaultGroup}
          bankAccountTrigger={() => setBankLedgerTrigger(!bankLedgerTrigger)}
          setNewItem={setAddLedgerResponse}
        />
      )}
      {openModel.type === "addInvoiceReferenceModel" && (
        <AddSalesInvBillAndExpensesReferenceModel
          open={true}
          onCancel={() => {
            setOpenModel({ type: "", param: "" });
            setSaveNewLoading(false);
            setLoading(false);
            setUpdateAndNewButton(false);
          }}
          invoiceId={updateAndNew ? undefined : updateId}
          voucherType={splitPathInVchType}
          currentInvoiceDetails={currentInvoiceDetails}
          newPartyRecepitDetails={newPartyRecepitDetails}
          oldPartyRecepitDetails={
            updateInPartyId === selectedParty ? oldPartyRecepitDetails : []
          }
          newSalesInvoice={saveNewLoading}
          setSaveAndNew={() => setSaveAndNew(true)}
          setUpdateAndNew={() => setUpdateAndNew(true)}
          editInvBankDetails={editInvBankDetails}
          settingControl={{
            showReceipt: settingControl.showReceipt,
            voucherTitle: selectCustomizationTemplete.title,
            templateId: selectCustomizationTemplete.templateId,
          }}
          voucherStatus={voucherStatus}
          updateInPartyId={updateInPartyId}
        />
      )}
      {openModel.type === "addLedger" && (
        <AddLedger
          openDrawer={openModel?.param.open}
          id={editParty?.id}
          setOpenDrawer={() => setOpenModel({ type: "", param: "" })}
          type={openModel?.param?.ledgerByGroupsType}
          setAddLedgerResponse={setAddLedgerResponse}
          // setRefresh={setRefresh}
          defaultGroup={openModel?.param?.defaultGroup}
          showName={openModel?.param?.showName}
        />
      )}
      {openModel.type === "addDespatchDetail" && (
        <AddSalesInvoiceDespatchDetails
          open={openModel?.param.open}
          onCancel={() => {
            // !updateId && setInvoiceDespatchDetails({});
            setOpenModel({ type: "", param: "" });
          }}
          data={(data: any) => {
            setInvoiceDespatchDetails(data);
            setOpenModel({ type: "", param: "" });
          }}
          saveData={invoiceDespatchDetails}
          voucherType={splitPathInVchType}
        />
      )}
      {openModel.type === "addExportDetail" && (
        <AddSalesInvoiceExportDetail
          open={openModel?.param.open}
          onCancel={() => setOpenModel({ type: "", param: "" })}
          data={handleDataFromChild}
          saveData={invoiceExportDetails}
        />
      )}
      {openModel.type === "termsAndConditionsModal" && (
        <TermsAndConditionModal
          open={openModel.param.open}
          onCancel={() => setOpenModel({ type: "", param: { open: false } })}
          setTermsAndConditionField={setTermsAndConditionField}
          termsAndConditionField={termsAndConditionField}
          voucherType={
            splitPathInVchType === Voucher_Type.SalesVoucher
              ? Voucher_Type?.SalesVoucher
              : splitPathInVchType === Voucher_Type?.PurchaseVoucher
              ? Voucher_Type.PurchaseVoucher
              : ""
          }
          voucherTitleCustomization={selectCustomizationTemplete.templateId}
        />
      )}
      {previewImage.path && (
        <DocumentPreview
          open={true}
          onCancel={() =>
            setPreviewImage({
              path: "",
              isBaseConvert: false,
              // uploadType: "",
            })
          }
          documentDetails={previewImage}
        />
      )}
      {/* --------- Add TCS Model--------- */}
      {openModel.type === "addTcsRate" && (
        <AddTcsTaxRate
          open={true}
          setOpen={() => setOpenModel({ type: "", param: { open: false } })}
          setTrigger={setTcsListTrigger}
          editData={openModel.param}
        />
      )}
      {/* --------- Add TDS Model--------- */}
      {openModel.type === "addTdsRate" && (
        <AddTdsTaxRate
          open={true}
          setOpen={() => setOpenModel({ type: "", param: "" })}
          setTrigger={setTdsListTrigger}
          editData={openModel.param}
        />
      )}

      {/* {openModel.type === "batchItem" && (
        <AddBatchItemsModal
          open={true}
          onCancel={() => setOpenModel({ type: "", param: "" })}
          setBatchData={setBatchData}
          batchData={batchData[0]?.currentQty ? batchData : itmData}
          setBatchOpnQty={function (param: any): void {
            throw new Error("Function not implemented.");
          }}
          id={props?.id}
          // batchData={batchData}
          // setBatchOpnQty={setBatchOpnQty}
          // batchOpnQty={batchOpnQty}
        />
      )} */}

      {openModel.type === "batchItem" && (
        <SelectBatchItemModal
          open={true}
          onCancel={() => setOpenModel({ type: "", param: "" })}
          inputFieldNull={() => form.resetFields([["items", index]])}
          id={batchItmId}
          setBatchData={setBatchData}
          setBatchItmName={setBatchItmName}
          setForAddBatchData={setForAddBatchData}
          alReadySelectedData={alReadySelectedData}
          setBatchQty={setBatchQty}
          batchQty={batchQty}
          totalQty={finalBatchQty}
          forAddBatchData={forAddBatchData}
          selectedBatchData={selectedBatchData}
          setSelectedBatchData={setSelectedBatchData}
          setTriggerBatchData={setTriggerBatchData}
          setAddBatches={setAddBatches}
          addBatches={addBatches}
        />
      )}

      {/* {openModel.type === "serialNo" && (
        <AddSerialNoModal
          open={true}
          onCancel={() => setOpenModel({ type: "", param: "" })}
          setSerialNoData={function (param: any): void {
            throw new Error("Function not implemented.");
          }} // setSerialNoData={itmData} // setSerialNoData={setSerialNoData}
          serialNoData={itmData}
          // id={props?.id}

          setInInvoice={setSerialNoData}
        />
      )} */}

      {openModel.type === "serialNo" && (
        <SelectSerialNo
          open={true}
          onCancel={() => {
            setOpenModel({ type: "", param: "" });
          }}
          inputFieldNull={() => form.resetFields([["items", index]])}
          id={batchItmId}
          setInInvoice={setSerialNoData}
          setBatchItmName={setBatchItmName}
          setForAddSerialData={setForAddSerialData}
          setSerial={setSerial}
          serial={serial}
          setTriggerSerialData={setTriggerSerialData}
          alReadySelectedData={alReadySelectedData}
          forAddSerialData={forAddSerialData}
          selectedBatchData={selectedBatchData}
          setSelectedBatchData={setSelectedBatchData}
        />
      )}

      {openModel.type === "normalAssetItem" && (
        <SelectDisposeAssetItem
          open={true}
          onCancel={() => setOpenModel({ type: "", param: "" })}
          isLocked={isLocked}
          itemIndex={openModel.param?.index}
          itemData={form.getFieldValue(["items", openModel.param?.index])}
          saveIndexAssetItems={(x: any) => saveIndexAssetItems(x)}
          voucherDate={form.getFieldValue("date")}
          updateId={updateId}
          // selectedInvDetail={form.getFieldValue([
          //   "items",
          //   openModel.param?.index,
          // ])}
          // inputFieldNull={() => form.resetFields([["items", index]])}
          // id={batchItmId}
          // setBatchData={setBatchData}
          // setBatchItmName={setBatchItmName}
          // setForAddBatchData={setForAddBatchData}
          // alReadySelectedData={alReadySelectedData}
          // setBatchQty={setBatchQty}
          // batchQty={batchQty}
          // totalQty={finalBatchQty}
          // forAddBatchData={forAddBatchData}
          // selectedBatchData={selectedBatchData}
          // setSelectedBatchData={setSelectedBatchData}
          // setTriggerBatchData={setTriggerBatchData}
          // setAddBatches={setAddBatches}
          // addBatches={addBatches}
        />
      )}
    </>
  );
};

export default AddSalesInvoiceAndPurchaseBill;

export const returnNetAmount = (i: number, items: any[]) => {
  let netAmount = items && items[i]?.amount?.price * items[i]?.amount?.qty;
  return netAmount;
};
